<template>
	<div class="store-psi-container">
		<!-- 过渡动画容器 -->
		<transition name="el-zoom-in-center" mode="out-in">
			<!-- 采购入库主页面 -->
			<div v-if="!isReturnMode" key="main">
				<!-- 查询条件区域 -->
				<div class="query-section">
					<el-form :model="queryForm" inline class="query-form">
						<el-form-item label="">
							<el-date-picker size="mini" v-model="queryForm.createTime" type="daterange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
						</el-form-item>
						<!-- 入库库房下拉选择框 -->
						<el-form-item label="入库库房：">
							<el-select size="mini" v-model="queryForm.warehouse" placeholder="请选择入库库房"
								@change="handleWarehouseChange">
								<el-option :key="4" label="中药房" :value="4" />
							</el-select>
						</el-form-item>

						<!-- 状态筛选下拉框 - 修改：默认值为空字符串 -->
						<el-form-item label="状态：">
							<el-select v-model="queryForm.state" placeholder="全部状态" @change="handleStatusChange"
								size="mini">
								<el-option v-for="status in statusList" :key="status.id" :label="status.label"
									:value="status.id" />
							</el-select>
						</el-form-item>

						<!-- 入库类型下拉选择框 -->
						<el-form-item label="入库类型：">
							<el-select size="mini" v-model="queryForm.storageType" placeholder="全部类型"
								@change="handleStorageTypeChange">
								<el-option v-for="item in storageTypeOptions" :key="item.id" :label="item.label"
									:value="item.id" />
							</el-select>
						</el-form-item>
					<!-- 	<el-form-item label="供应商名称：">
							<el-input size="mini" v-model="queryForm.supplier" placeholder="供应商名称" />
						</el-form-item> -->

						<el-form-item>
							<el-button size="mini" icon="el-icon-Ssearch" type="primary"
								@click="handleQuery">查询</el-button>
						</el-form-item>
					</el-form>
				</div>

				<!-- 操作按钮区域 -->
				<div class="operation-buttons">
					<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAddPurchase">
						添加入库
					</el-button>

					<el-button type="danger" @click="handleBatchDelete" size="mini" :disabled="selectedRows.length === 0">
						批量删除
					</el-button>
				</div>

				<!-- 双表格布局容器 -->
				<div class="dual-table-container">
					<!-- 采购入库表格 -->
					<div class="table-wrapper purchase-table" :class="{ 'half-width': showTransferTable }">
						<div class="table-header">
							<h3 class="table-title">{{ getTableTitle() }}</h3>
							<!-- 					<el-button v-if="showTransferTable" type="text" icon="el-icon-close"
								@click="closeTransferTable" class="close-transfer-btn">
								关闭调拨单
							</el-button> -->
						</div>

						<el-table ref="purchaseTable" :data="tableData" stripe border style="width: 100%"
							height="calc(100vh - 430px)" @selection-change="handleSelectionChange"
							@row-click="handleRowClick" v-loading="tableLoading">
							<!-- 采购入库表格列保持不变 -->
							<el-table-column type="selection" width="55" align="center" />

							<el-table-column label="创建信息" width="150" fixed="left">
								<template slot-scope="scope">
									<div class="creator-info-cell">
										<div class="creator-name">{{ getCreatorName(scope.row) }}</div>
										<div class="create-time">{{ formatDate(scope.row.createTime) }}</div>
									</div>
								</template>
							</el-table-column>

							<el-table-column prop="state" label="状态" width="100" align="center">
								<template slot-scope="scope">
									<el-tag :type="getStatusType(scope.row.state)" size="small">
										{{ getStatusText(scope.row.state) }}
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="docNum" label="入库编号" width="180" show-overflow-tooltip />

							<!-- 入库类型列 -->
							<el-table-column prop="storageType" label="入库类型" width="100" align="center">
								<template slot-scope="scope">
									<el-tag :type="getStorageTypeTagType(scope.row.putinTypeName)" size="small">
										{{ scope.row.putinTypeName }}
									</el-tag>
								</template>
							</el-table-column>

							<el-table-column prop="supplierName" label="供货单位" width="160" />
							<!-- <el-table-column prop="putinTypeName" label="入库方式" width="120" align="center" /> -->
							<!-- 数量相关列 -->
							<!-- 	<el-table-column prop="purcCnt" label="入库数量" width="120" align="center">
								<template slot-scope="scope">
									{{ scope.row.purcCnt }}
									{{ scope.row.purcType === '1' ? scope.row.dosUnt : scope.row.pacUnt }}
								</template>
							</el-table-column> -->

							<!-- 价格相关列 -->
							<!-- <el-table-column prop="purcPric" label="成本单价" width="120" align="center">
								<template slot-scope="scope">
									¥{{ Number(scope.row.purcPric || 0).toFixed(8) }}
								</template>
							</el-table-column>

							<el-table-column prop="salePric" label="零售单价" width="100" align="center">
								<template slot-scope="scope">
									¥{{ Number(scope.row.salePric || 0).toFixed(8) }}
								</template>
							</el-table-column> -->

							<el-table-column prop="costAmt" label="成本总额" width="120" align="center">
								<template slot-scope="scope">
									¥{{ Number(scope.row.costAmt || 0) }}
								</template>
							</el-table-column>

							<!-- <el-table-column prop="saleAmt" label="零售总额" width="120" align="center">
								<template slot-scope="scope">
									¥{{ Number(scope.row.saleAmt || 0) }}
								</template>
							</el-table-column> -->

							<!-- 生产信息列 -->
							<!-- <el-table-column prop="manuLotnum" label="生产批号" width="120" />
							<el-table-column prop="manuDate" label="生产日期" width="120">
								<template slot-scope="scope">
									{{ formatDate(scope.row.manuDate) }}
								</template>
							</el-table-column>

							<el-table-column prop="expyDate" label="有效日期" width="120">
								<template slot-scope="scope">
									{{ formatDate(scope.row.expyDate) }}
								</template>
							</el-table-column>

							<el-table-column prop="prodentpName" label="生产厂家" width="160" show-overflow-tooltip /> -->

							<!-- 入库方式列 -->
							<!-- <el-table-column prop="putinTypeId" label="入库方式" width="120" align="center">
							    <template slot-scope="scope">
							        {{ getPutinTypeText(scope.row.putinTypeId) }}
							    </template>
							</el-table-column> -->
							<el-table-column prop="createName" label="提交人" width="120" />
							<el-table-column prop="createTime" label="提交时间" width="180">
								<template slot-scope="scope">
									{{ scope.row.createTime === '--' ? '--' : formatDateTime(scope.row.createTime) }}
								</template>
							</el-table-column>
							<el-table-column prop="reviewName" label="审核人" width="120" />
							<el-table-column prop="reviewTime" label="审核时间" width="180">
								<template slot-scope="scope">
									{{ scope.row.reviewTime === '--' ? '--' : formatDateTime(scope.row.reviewTime) }}
								</template>
							</el-table-column>
							<el-table-column prop="passingOrdersName" label="过单人" width="120" />
							<el-table-column prop="passingOrdersTime" label="过单时间" width="180">
								<template slot-scope="scope">
									{{ scope.row.passingOrdersTime === '--' ? '--' : formatDateTime(scope.row.passingOrdersTime) }}
								</template>
							</el-table-column>
							<!-- 操作列 -->
							<el-table-column label="操作" width="188" fixed="right" align="center">
							    <template slot-scope="scope">
							        <div class="operation-buttons" style="display: flex; align-items: center; justify-content: center; gap: 4px;">
							            <!-- 查看按钮 - 始终显示 -->
							            <el-button type="text" size="mini" @click="handleDetail(scope.row)">查看</el-button>
							
							            <!-- 根据状态显示不同的操作按钮 -->
							            <template v-if="scope.row.state === 0">
							                <el-button type="text" size="mini" @click="handleEdit(scope.row)">修改</el-button>
							                <el-button type="text" size="mini" @click="handleSubmit(scope.row)">提交</el-button>
							                <el-button type="text" size="mini" style="color: #ff4d4f;" @click="handleDelete(scope.row)">删除</el-button>
							            </template>
							
							            <template v-if="scope.row.state === 2">
							                <el-button type="text" size="mini" @click="handleAudit(scope.row)">审核</el-button>
							            </template>
							
							            <template v-if="scope.row.state === 4">
							                <el-button type="text" size="mini" @click="handlePass(scope.row)">过单</el-button>
							            </template>
							
							            <template v-if="scope.row.state === 5">
							                <!-- 关键修改：根据 isAllot 字段判断是否显示快捷调拨按钮 -->
							                <template v-if="scope.row.isAllot === 1">
							                    <!-- 已调拨完成，显示不可点击状态 -->
							                    <el-button 
							                        type="text" 
							                        size="mini" 
							                        disabled 
							                        style="color: #c0c4cc; cursor: not-allowed;"
							                        title="该入库单已完成调拨">
							                        已完成调拨
							                    </el-button>
							                </template>
							                <template v-else>
							                    <!-- 未调拨，显示可点击的快捷调拨按钮 -->
							                    <el-button 
							                        type="text" 
							                        size="mini" 
							                        @click="handleQuickTransferDetail(scope.row)"
							                        :disabled="scope.row.isAllot === 1">
							                        快捷调拨
							                    </el-button>
							                </template>
							                
							                <el-button type="text" size="mini" style="color: #e6a23c;" @click="handleReverse(scope.row)">冲销</el-button>
							            </template>
							        </div>
							    </template>
							</el-table-column>
						</el-table>

						<!-- 分页组件 -->
						<div class="pagination">
							<el-pagination :current-page="pagination.currentPage" :page-size="pagination.pageSize"
								:total="pagination.total" layout="total, prev, pager, next, jumper"
								@current-change="handlePageChange" />
						</div>
					</div>
				</div>
			</div>

			<!-- 采购退库页面 -->
			<!--  <div v-else key="return">
			     修改：添加 current-warehouse 属性传递当前选中的药库 
			      @return-back="handleReturnBack" 
			      :current-warehouse="queryForm.warehouse"
			      :warehouse-list="warehouseList"
			    />
			  </div> -->
		</transition>

		<!-- 采购入库模态框 -->
		<el-dialog :title="purchaseDialogTitle" :visible.sync="purchaseDialogVisible" width="80%" top="5vh"
			class="purchase-dialog" :close-on-click-modal="false" @close="handlePurchaseDialogClose"
			@open="handlePurchaseDialogOpen">
			<div class="purchase-dialog-content" :class="{ 'readonly-mode': detailMode === 'exam' }">
				<!-- 采购信息区域 -->
				<div class="purchase-info-section">
					<h4 class="section-title">采购信息</h4>
					<el-form :model="purchaseForm" :rules="purchaseRules" ref="purchaseForm" label-width="100px"
						size="mini" :disabled="detailMode === 'exam'">
						<el-row :gutter="24">
							<el-col :span="6">
								<el-form-item label="采购药库：" prop="warehouse">
									<el-select v-model="purchaseForm.warehouse" placeholder="请选择采购药库"
										@change="handlePurchaseWarehouseChange">
										<el-option :key="4" label="中药房" :value="4" />
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="业务日期：" prop="busDate">
									<el-date-picker v-model="purchaseForm.busDate" type="date" value-format="yyyy-MM-dd"
										placeholder="选择业务日期" style="width: 100%" />
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="发票号码：" prop="purcInvoCodg">
									<el-input v-model="purchaseForm.purcInvoCodg" placeholder="请输入采购发票号码" />
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="24">
							<el-col :span="6">
								<el-form-item label="供货单位：" prop="supplierId">
									<div class="supplier-select">
										<el-select v-model="purchaseForm.supplierId" filterable placeholder="请选择供货单位"
											@change="handleSupplierChange"
											:class="{ 'error-border': !purchaseForm.supplierId }">
											<el-option v-for="supplier in gysOption" :key="supplier.id"
												:label="supplier.supplierName" :value="supplier.id" />
										</el-select>
										<!-- 新增：供货单位添加按钮 -->
										<el-button icon="el-icon-plus" size="mini" class="add-supplier-button"
											@click="handleAddSupplier" title="新增供货单位" />
									</div>
									<div v-if="!purchaseForm.supplierId" class="error-message">
										请选择供货单位
									</div>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="供货号码：" prop="supplyCode">
									<el-input v-model="purchaseForm.supplyCode" placeholder="请输入供货号码" />
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="入库方式：" prop="putinTypeId">
									<el-select v-model="purchaseForm.putinTypeId" placeholder="请选择入库方式">
										<el-option v-for="typed in putinOption" :key="typed.id" :label="typed.name"
											:value="typed.id" />
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="备注：" prop="remark">
									<el-input type="textarea" :rows="2" v-model="purchaseForm.remark"
										placeholder="请输入备注信息" />
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>

				<!-- 药品信息区域 -->
				<div class="goods-info-section">
					<div class="section-header">
						<h4 class="section-title">药品明细信息</h4>
						<el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAddGoods">
							添加药品
						</el-button>
					</div>

					<el-table :data="goodsList" border style="width: 100%" size="mini">
						<!-- 药品名称列（下拉选择框） -->
						<el-table-column prop="name" label="药品名称" width="160" align="center">
							<template slot-scope="scope">
								<div class="drug-select-container">
									<el-select v-model="scope.row.drugId" filterable placeholder="请选择药品" size="mini"
										style="width: 100%" @change="handleDrugChange($event, scope.row)" clearable
										:loading="scope.row.drugLoading">
										<el-option v-for="drug in drugOptions" :key="drug.id" :label="drug.name"
											:value="drug.id">
											<div class="drug-option">
												<span class="drug-name">{{ drug.name }}</span>
												<span class="drug-spec" v-if="drug.drugSpecifications">
													规格：{{ drug.drugSpecifications }}
												</span>
											</div>
										</el-option>
									</el-select>
									<!-- <i v-if="scope.row.drugLoading" class="el-icon-loading drug-loading-icon"></i> -->
								</div>
							</template>
						</el-table-column>

						<!-- 入库数量列 添加聚焦和失焦事件 -->
						<!-- 修改入库数量列的模板 -->
						<el-table-column prop="purcCnt" label="入库数量" width="180" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.purcCnt" :min="1" :max="99999" size="mini"
									controls-position="right" @change="handlePurcCntChange($event, scope.row)"
									@focus="handlePurcCntFocus(scope.row)" @blur="handlePurcCntBlur(scope.row)" />
								<!-- 修改：动态显示单位 -->
								<span style="margin-left: 4px; font-size: 12px; color: #666;">
									{{ scope.row.purcType === '1' ? (scope.row.dosUnt || '最小单位') : (scope.row.pacUnt || '包装单位') }}
								</span>
							</template>
						</el-table-column>

						<!-- 修改：库存类型列，使用 :value 替代 v-model -->
						<el-table-column prop="purcType" label="库存类型" width="120" align="center">
							<template slot-scope="scope">
								<el-select :value="scope.row.purcType" size="mini" style="width: 100%"
									@change="(newValue) => handleStorageTypeChange(newValue, scope.row)">
									<el-option label="最小单位" value="1" />
									<el-option label="包装单位" value="2" />
								</el-select>
								<!-- 添加单位提示 -->
								<div style="font-size: 10px; color: #909399; margin-top: 2px;">
									当前: {{ scope.row.purcType === '1' ? '最小单位' : '包装单位' }}
								</div>
							</template>
						</el-table-column>
						<!-- 修改：包装数量列，添加blur事件 -->
						<el-table-column prop="pacCnt" label="包装数量" width="120" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.pacCnt" size="mini" :disabled="true"
									controls-position="right" @change="handlePacCntChange($event, scope.row)"
									@blur="handlePacCntBlur(scope.row)" />
							</template>
						</el-table-column>
						<!-- 生产批号列 -->
						<el-table-column prop="manuLotnum" label="生产批号" width="120" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.manuLotnum" size="mini" placeholder="请输入生产批号" />
							</template>
						</el-table-column>

						<!-- 生产日期列 -->
						<el-table-column prop="manuDate" label="生产日期" width="160" align="center">
							<template slot-scope="scope">
								<el-date-picker v-model="scope.row.manuDate" type="date" value-format="yyyy-MM-dd"
									placeholder="选择生产日期" size="mini" style="width: 100%"
									@change="handleManuDateChange($event, scope.row)" />
							</template>
						</el-table-column>

						<!-- 有效日期列 -->
						<el-table-column prop="expyDate" label="有效日期" width="160" align="center">
							<template slot-scope="scope">
								<el-date-picker v-model="scope.row.expyDate" type="date" value-format="yyyy-MM-dd"
									placeholder="选择有效日期" size="mini" style="width: 100%"
									@change="handleExpiryDateChange($event, scope.row)" />
							</template>
						</el-table-column>
						<el-table-column prop="prodentpName" label="生产厂家" width="180" align="center">
							<template slot-scope="scope">
								<el-select v-model="scope.row.prodentpNameId" filterable placeholder="生产厂家" size="mini"
									style="width: 100%" @change="handleManufacturerChange($event, scope.row)"
									:loading="scope.row.manufacturerLoading">
									<el-option v-for="item in scope.row.manufacturerOptions" :key="item.id"
										:label="item.prodentpName" :value="item.id">
										<div class="manufacturer-option">
											<span class="manufacturer-name">{{ item.prodentpName }}</span>
											<span v-if="item.prodentpCode"
												class="manufacturer-code">({{ item.prodentpCode }})</span>
										</div>
									</el-option>
								</el-select>

								<!-- 显示当前选中的厂家名称 -->
								<div v-if="scope.row.prodentpNameId && scope.row.manufacturerOptions.length > 0"
									class="selected-manufacturer">
									<el-tooltip :content="getSelectedManufacturerName(scope.row)" placement="top">
										<span class="manufacturer-text">
											{{ getSelectedManufacturerName(scope.row) }}
										</span>
									</el-tooltip>
								</div>
							</template>
						</el-table-column>

						<!-- 成本单价列，使其可编辑 -->
						<!-- 成本单价列 -->
						<el-table-column prop="purcPric" label="成本单价" width="140" align="center">
							<template slot-scope="scope">
								<el-input-number 
									v-model="scope.row.purcPric" 
									:precision="8"
									:step="0.00000001"
									:min="0" 
									:max="999999.99999999" 
									size="mini"
									controls-position="right" 
									@change="handleCostPriceChange(scope.row)"
									@focus="handleCostPriceFocus(scope.row)" 
									@blur="handleCostPriceBlur(scope.row)"
									style="width: 100px;" />
								<!-- 在输入框下方显示格式化后的值（调试用） -->
								<div v-if="scope.row.purcPric" style="font-size: 10px; color: #909399; margin-top: 2px;">
									显示: {{ smartFormatPrice(scope.row.purcPric) }}
								</div>
							</template>
						</el-table-column>

						<!-- 零售单价列 -->
						<!-- <el-table-column prop="salePric" label="零售单价" width="100" align="center">
							<template slot-scope="scope">
								<span :class="{'price-loading': scope.row.priceLoading}">
									{{ smartFormatPrice(scope.row.salePric) }}
								</span>
								<i v-if="scope.row.priceLoading" class="el-icon-loading"></i> -->
								<!-- 显示实际小数位数 -->
								<!-- <div v-if="scope.row.salePric" style="font-size: 10px; color: #909399; margin-top: 2px;">
									小数位: {{ getActualDecimalPlaces(scope.row.salePric) }}
								</div>
							</template>
						</el-table-column> -->

						<!-- 成本金额列 -->
						<el-table-column prop="purcAmt" label="成本金额" width="100" align="center">
							<template slot-scope="scope">
								<span style="color: #ff6b35; font-weight: bold;">
									{{ smartFormatPrice(scope.row.purcAmt) }}  <!-- 智能格式化 -->
								</span>
							</template>
						</el-table-column>

						<!-- 零售金额列 -->
						<!-- <el-table-column prop="saleAmt" label="零售金额" width="100" align="center">
							<template slot-scope="scope">
								<span style="color: #67c23a; font-weight: bold;">
									{{ smartFormatPrice(scope.row.saleAmt) }}
								</span>
							</template>
						</el-table-column> -->

						<!-- 加成方式列 -->
						<el-table-column prop="markUpId" label="加成方式" width="120" align="center">
							<template slot-scope="scope">
								<el-select v-model="scope.row.markUpId" size="mini" style="width: 100%" disabled
									@change="handleMarkUpChange($event, scope.row)">
									<el-option v-for="markUp in markUpOptions" :key="markUp.id" :label="markUp.label"
										:value="markUp.id.toString()" />
								</el-select>
							</template>
						</el-table-column>

						<!-- 加成值列 -->
						<!-- 修改加成值列 -->
						<el-table-column prop="markUpValue" :label="getCurrentMarkUpLabel()" width="120" align="center">
							<template slot-scope="scope">
								<!-- 比例加成（markUpId=1） - 显示为文本 -->
								<span v-if="scope.row.markUpId === '1'">
									{{ Number(scope.row.markUpRate || 0) }}
								</span>

								<!-- 固定加成（markUpId=2） - 显示为可编辑输入框 -->
								<el-input v-else-if="scope.row.markUpId === '2'" v-model="scope.row.markUpPric" :min="0"
									:precision="8" :step="0.00000001" size="mini"
									@change="handleMarkUpValueChange(scope.row)" style="width: 100px;" />

								<!-- 手工比例加成（markUpId=3） - 显示为文本 -->
								<span v-else-if="scope.row.markUpId === '3'">
									{{ Number(scope.row.markUpRate || 0) }}%
								</span>

								<!-- 不加成（markUpId=4） -->
								<span v-else-if="scope.row.markUpId === '4'">--</span>

								<!-- 默认显示 -->
								<span v-else>{{ getMarkUpDisplayValue(scope.row) }}</span>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="markUpValue" :label="getCurrentMarkUpLabel()" width="120" align="center">
							<template slot-scope="scope">
								<span>{{ getMarkUpDisplayValue(scope.row) }}</span>
							</template>
						</el-table-column> -->

						<el-table-column prop="drugSpecifications" label="规格描述" width="160">
							<template slot-scope="scope">
								<el-tooltip :content="scope.row.drugSpecifications || '--'" placement="top"
									:disabled="!scope.row.drugSpecifications || scope.row.drugSpecifications.length <= 8">
									<span class="spec-text">
										{{ formatSpecText(scope.row.drugSpecifications) }}
									</span>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="pacSpec" label="包装规格" width="160">
							<template slot-scope="scope">
								<el-tooltip :content="scope.row.pacSpec || '--'" placement="top"
									:disabled="!scope.row.pacSpec || scope.row.pacSpec.length <= 8">
									<span class="spec-text">
										{{ formatSpecText(scope.row.pacSpec) }}
									</span>
								</el-tooltip>
							</template>
						</el-table-column>
						<!-- 操作列 -->
						<el-table-column label="操作" width="80" align="center" fixed="right">
							<template slot-scope="scope">
								<el-button type="text" size="mini" @click="handleRemoveGoods(scope.$index)"
									style="color: #ff4d4f;">
									删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>

					<!-- 金额统计 -->
					<div class="goods-total"
						style="margin-top: 16px; text-align: right; padding: 8px 16px; background: #f5f7fa;">
						<span style="margin-right: 24px; font-weight: bold;">
							成本合计：
							<span style="color: #ff6b35;" 
								  :title="'精确值: ' + (AtotalCostRaw || '0.00000000')">
								¥{{ calculateTotalCost() }}
							</span>
						</span>
					<!-- 	<span style="font-weight: bold;">
							零售合计：
							<span style="color: #67c23a;" 
								  :title="'精确值: ' + (AtotalSaleRaw || '0.00000000')">
								¥{{ calculateTotalSale() }}
							</span>
						</span> -->
					</div>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<!-- 修改确定按钮，添加计算状态禁用 -->
				<el-button type="primary" @click="handlePurchaseSubmit" :loading="submitLoading" v-if="!isEditMode"
					:disabled="!isSubmitEnabled || goodsList.length === 0 || isCalculating">
					确定
				</el-button>

				<el-button type="primary" @click="handlePurchaseEdit" :loading="submitLoading"
					:disabled="!isSubmitEnabled || isCalculating" v-else>
					保存修改
				</el-button>
			</div>
		</el-dialog>
		<!-- 新增：供货单位模态框 -->
		<el-dialog title="新增供货单位" :visible.sync="supplierDialogVisible" width="500px" top="10vh" class="supplier-dialog"
			:close-on-click-modal="false">
			<div class="supplier-dialog-content">
				<el-form :model="supplierForm" :rules="supplierRules" ref="supplierForm" label-width="100px"
					size="mini">
					<el-form-item label="供货单位名称：" prop="supplierName">
						<el-input v-model="supplierForm.supplierName" placeholder="请输入供货单位名称" />
					</el-form-item>

					<el-form-item label="供货单位编码：" prop="supplierCode">
						<el-input v-model="supplierForm.supplierCode" placeholder="请输入供货单位编码" />
					</el-form-item>

					<el-form-item label="联系人：" prop="contact">
						<el-input v-model="supplierForm.contact" placeholder="请输入联系人姓名" />
					</el-form-item>

					<el-form-item label="联系电话：" prop="contactPhone">
						<el-input v-model="supplierForm.contactPhone" placeholder="请输入联系电话" />
					</el-form-item>

					<el-form-item label="地址：" prop="address">
						<el-input type="textarea" :rows="2" v-model="supplierForm.address" placeholder="请输入详细地址" />
					</el-form-item>

					<el-form-item label="备注：" prop="remark">
						<el-input type="textarea" :rows="2" v-model="supplierForm.remark" placeholder="请输入备注信息" />
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="supplierDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="handleSupplierSubmit" :loading="supplierLoading">
					确定
				</el-button>
			</div>
		</el-dialog>
		<!-- 采购计划抽屉 -->
		<el-drawer title="选择采购计划单" :visible.sync="purchasePlanDrawerVisible" direction="rtl" size="50%" :modal="false"
			:before-close="handleDrawerClose" class="purchase-plan-drawer">
			<div class="drawer-content">
				<!-- 搜索条件 -->
				<div class="drawer-search">
					<el-form :model="planQueryForm" inline class="plan-query-form">
						<el-form-item label="采购单号：">
							<el-input v-model="planQueryForm.docNum" placeholder="采购单号" size="small" />
						</el-form-item>

						<el-form-item label="供应商：">
							<el-input v-model="planQueryForm.supplier" placeholder="供应商名称" size="small" />
						</el-form-item>

						<el-form-item>
							<el-button type="primary" size="small" @click="handlePlanQuery">查询</el-button>
							<el-button size="small" @click="resetPlanQuery">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
				<!-- 采购计划列表 -->
				<div class="drawer-table">
					<el-table :data="purchasePlanList" stripe border style="width: 100%" height="calc(100vh - 200px)"
						v-loading="planLoading" @row-click="handlePlanRowClick">
						<el-table-column prop="docNum" label="采购单号" width="120" />
						<el-table-column prop="supplierName" label="供应商" width="150" show-overflow-tooltip />
						<el-table-column prop="createName" label="创建人" width="100" />
						<el-table-column prop="createTime" label="创建时间" width="120">
							<template slot-scope="scope">
								{{ formatDate(scope.row.createTime) }}
							</template>
						</el-table-column>
						<el-table-column prop="totalAmt" label="总金额" width="100" align="right">
							<template slot-scope="scope">
								¥{{ scope.row.totalAmt ? scope.row.totalAmt.toFixed(8) : '0.00000000' }}
							</template>
						</el-table-column>
						<el-table-column prop="state" label="状态" width="80" align="center">
							<template slot-scope="scope">
								<el-tag :type="getStatusType(scope.row.state)" size="small">
									{{ getStatusText(scope.row.state) }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="80" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="mini" @click="selectPurchasePlan(scope.row)">选择</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<!-- 分页 -->
				<div class="drawer-pagination">
					<el-pagination :current-page="planPagination.currentPage" :page-size="planPagination.pageSize"
						:total="planPagination.total" layout="total, prev, pager, next, jumper"
						@current-change="handlePlanPageChange" size="small" />
				</div>
			</div>
		</el-drawer>
		<!-- 在适当位置添加导出进度对话框 -->
		<el-dialog title="导出进度" :visible.sync="exporting" width="30%" 
		           :close-on-click-modal="false" :show-close="false"
		           class="export-progress-dialog">
		  <div style="text-align: center;">
		    <el-progress type="circle" :percentage="exportProgress" 
		                 :status="exportProgress === 100 ? 'success' : ''"></el-progress>
		    <p style="margin-top: 20px; color: #606266;">
		      {{ exportProgress === 100 ? '导出完成' : '正在生成导出文件，请稍候...' }}
		    </p>
		    
		    <!-- 导出完成后的操作 -->
		    <div v-if="exportProgress === 100" style="margin-top: 20px;">
		      <el-button type="primary" size="mini" @click="exporting = false">
		        关闭
		      </el-button>
		      <el-button type="text" size="mini" @click="handleOpenDownloadFolder" v-if="isElectron">
		        打开下载文件夹
		      </el-button>
		    </div>
		  </div>
		</el-dialog>
		<!-- 快速调拨对话框 -->
		<el-dialog title="快捷调拨单" :visible.sync="showQuickTransferDialog" width="80%" top="5vh"
			class="quick-transfer-dialog" :close-on-click-modal="false">
			<div class="quick-transfer-content">
				<!-- 调拨信息区域 -->
				<div class="transfer-info-section">
					<h4 class="section-title">调拨信息</h4>
					<el-form :model="quickTransferForm" label-width="100px" size="mini">
						<el-row :gutter="24">
							<el-col :span="6">
								<el-form-item label="调出药库：">
									<el-select v-model="quickTransferForm.fromWarehouse" placeholder="请选择调出药库" disabled>
										<el-option v-if="queryForm.warehouse == 1" :key="1" label="西药库" :value="1" />
										<el-option v-else-if="queryForm.warehouse == 2" :key="2" label="中药库"
											:value="2" />
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="调入药库：">
									<el-select v-model="quickTransferForm.toWarehouse" placeholder="请选择调入药库">
										<!-- 修改：设置默认值为3 -->
										<el-option v-for="warehouse in warehouseList" :key="warehouse.id"
											:label="warehouse.label" :value="warehouse.id"
											:disabled="warehouse.id === quickTransferForm.fromWarehouse" />
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="业务日期：">
									<el-date-picker v-model="quickTransferForm.busDate" type="date"
										value-format="yyyy-MM-dd" placeholder="选择业务日期" style="width: 100%" />
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="调拨单号：">
									<el-input v-model="quickTransferForm.docNum" placeholder="系统自动生成" disabled />
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="24">
							<el-col :span="12">
								<el-form-item label="备注：">
									<el-input type="textarea" :rows="2" v-model="quickTransferForm.remark"
										placeholder="请输入调拨备注信息" />
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>

				<!-- 调拨明细区域 -->
				<div class="transfer-details-section">
					<div class="section-header">
						<h4 class="section-title">调拨药品明细</h4>
						<span class="selected-count">已选择 {{ transferTableDetailsData.length }} 条药品明细</span>
					</div>

					<el-table :data="transferTableDetailsData" border style="width: 100%" size="mini" height="300">
						<el-table-column type="index" label="序号" width="60" align="center" />
						<el-table-column prop="sourceDocNum" label="来源单号" width="120" />
						<el-table-column prop="name" label="药品名称" width="150" show-overflow-tooltip />
						<el-table-column prop="drugSpec" label="规格" width="120" />
						<el-table-column prop="manuLotnum" label="批号" width="120" />
						<el-table-column prop="purcCnt" label="数量" width="100" align="center" />
						<el-table-column label="单位" width="80" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.purcType === '1' ? scope.row.dosUnt : scope.row.pacUnt }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="purcPric" label="成本单价" width="100" align="right">
							<template slot-scope="scope">
								¥{{ Number(scope.row.purcPric || 0) }}
							</template>
						</el-table-column>
						<el-table-column prop="purcAmt" label="成本金额" width="100" align="right">
							<template slot-scope="scope">
								¥{{ Number(scope.row.purcAmt || 0) }}
							</template>
						</el-table-column>
						<el-table-column prop="salePric" label="零售单价" width="100" align="right">
							<template slot-scope="scope">
								¥{{ Number(scope.row.salePric || 0) }}
							</template>
						</el-table-column>
						<el-table-column prop="saleAmt" label="零售金额" width="100" align="right">
							<template slot-scope="scope">
								¥{{ Number(scope.row.saleAmt || 0) }}
							</template>
						</el-table-column>
					</el-table>

					<!-- 金额统计 -->
					<div class="transfer-total"
						style="margin-top: 16px; text-align: right; padding: 12px; background: #f5f7fa;">
						<span style="margin-right: 24px; font-weight: bold;">
							成本合计：<span style="color: #ff6b35;">¥{{ totalCostAmount }}</span>
						</span>
						<span style="font-weight: bold;">
							零售合计：<span style="color: #67c23a;">¥{{ totalSaleAmount }}</span>
						</span>
					</div>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="showQuickTransferDialog = false">取消</el-button>
				<el-button type="primary" @click="confirmQuickTransfer" :loading="transferLoading"
					:disabled="!quickTransferForm.toWarehouse || transferTableDetailsData.length === 0">
					确认调拨
				</el-button>
			</div>
		</el-dialog>

		<div class="excel">
			<!-- Excel导入对话框 -->
			<el-dialog title="Excel批量导入" :visible.sync="excelDialogVisible" width="80%" top="10vh" :modal="false"
				custom-class="excel-import-dialog">
				<div class="excel-import-container">
					<!-- 左侧上传区域 -->
					<div class="left-panel">
						<!-- 上传头部 -->
						<!-- 修改上传组件部分 -->
						<div class="upload-header">
							<el-upload class="upload-demo" drag action="" :auto-upload="false"
								:file-list="excelFileList" :before-upload="beforeExcelUpload"
								:on-change="handleExcelChange" accept=".xlsx, .xls" :multiple="false">
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
								<div class="el-upload__tip" slot="tip">
									支持.xls、.xlsx格式，文件大小不超过10MB
									<br>建议使用系统提供的模板文件
								</div>
							</el-upload>
						</div>

						<!-- 文件信息区域 -->
						<div class="file-info">
							<div class="file-type-select">
								<el-form label-width="80px" size="mini">
									<el-form-item label="文件类型">
										<el-select v-model="fileType">
											<el-option label="Excel" value="excel"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="文件路径">
										<el-input v-model="filePath" placeholder="上传后自动显示文件路径" readonly>
											<el-button slot="append" icon="el-icon-refresh" @click="reSelectFile"
												:disabled="!excelFileList.length">重新选择</el-button>
										</el-input>
									</el-form-item>
								</el-form>
							</div>

							<!-- 文件列表表格 -->
							<div class="file-table">
								<el-table :data="fileList" border height="188">
									<el-table-column style="font-size: 12px;" prop="name" label="文件名称"
										width="180"></el-table-column>
									<el-table-column style="font-size: 12px;" prop="path" label="文件路径"
										show-overflow-tooltip></el-table-column>
									<el-table-column style="font-size: 12px;" prop="status" label="状态" width="100">
										<template slot-scope="{row}">
											<el-tag :type="row.status === '导入成功' ? 'success' : 'danger'" size="mini">
												{{row.status}}
											</el-tag>
										</template>
									</el-table-column>
									<el-table-column label="操作" width="80" align="center">
										<template slot-scope="{row}">
											<el-button type="danger" icon="el-icon-del" size="mini" circle
												@click="removeFile(row)"></el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>

						<!-- 底部操作按钮 -->
						<div class="action-footer">
							<!-- 修改立即执行按钮 -->
							<el-button type="primary" size="medium" @click="submitExcel" :loading="loading"
								:disabled="isSubmitDisabled || !excelTableData.length">
								立即执行
							</el-button>
						</div>
					</div>

					<!-- 右侧预览区域 -->
					<div class="right-panel">
						<div class="preview-header">
							<h4>数据预览 (共 {{ excelTableData.length }} 条记录)</h4>
						</div>

						<!-- 预览表格 -->
						<div class="preview-table">
							<el-table :data="excelTableData" border height="300" v-loading="loading">
								<el-table-column v-for="col in excelColumns" :key="col.prop" :prop="col.prop"
									:label="col.label" :width="col.width" show-overflow-tooltip></el-table-column>
							</el-table>
						</div>

						<!-- 错误信息区域 -->
						<div class="error-info-section" v-if="errorData.length > 0">
							<div class="error-header">
								<h4 style="color: #F56C6C;">
									<i class="el-icon-warning"></i>
									导入错误信息 (共 {{ errorData.length }} 条错误)
								</h4>
								<el-button type="danger" size="mini" icon="el-icon-download" @click="downloadErrorExcel"
									:loading="downloadingError">
									下载错误信息
								</el-button>
							</div>

							<!-- 错误信息表格 -->
							<div class="error-table">
								<el-table :data="errorData" border height="300" style="width: 100%" size="mini">
									<!-- 行号列 - 修改：从第1行开始 -->
									<el-table-column label="行号" width="80" align="center" fixed="left">
										<template slot-scope="{ row, $index }">
											<span
												style="font-weight: bold;">第{{ getDisplayRowNumber(row, $index) }}行</span>
										</template>
									</el-table-column>

									<!-- 其他列保持不变 -->
									<el-table-column v-for="col in excelColumns" :key="col.prop" :prop="col.prop"
										:label="col.label" :width="col.width" show-overflow-tooltip align="center">
										<template slot-scope="{ row }">
											<span>{{ row[col.prop] || '--' }}</span>
										</template>
									</el-table-column>

									<!-- 错误原因列 -->
									<el-table-column prop="errorInfo" label="错误原因" width="200" align="center"
										fixed="right">
										<template slot-scope="{ row }">
											<span
												style="color: #F56C6C; font-weight: bold;">{{ row.errorInfo || '未知错误' }}</span>
										</template>
									</el-table-column>

									<!-- 操作列 -->
									<el-table-column label="操作" width="80" align="center" fixed="right">
										<template slot-scope="{ row }">
											<el-button type="text" size="mini" @click="copyErrorInfo(row)">
												复制
											</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>

		<store-psi-detail ref="storePsiDetail" :visible="detailDialogVisible" :mode="detailMode"
			:plan-id="currentPlanId" @update:visible="handleDetailDialogVisibleChange" @close="handleDetailDialogClose"
			@refresh="handleDetailDialogRefresh" @mode-change="handleDetailDialogModeChange"
			@operation-success="handleDetailOperationSuccess" @quick-transfer-confirm="handleQuickTransferConfirm" />
	</div>
	</div>
</template>

<script>
	import * as XLSX from 'xlsx'; // 使用 * as 导入
	// 导入相关接口
	import { tcmDocPage } from "@/api/MedicenHouse/traMedici.js";
	import { selectDropDownList,getWareZY,getProdentZY } from "@/api/PSI.js";
	// 新增入库
	import { getPlanData,getPutin,docMarkById } from "@/api/PSI.js";
	// 入库
	import { dugDocPutin,dugDocZYFInsert,dugDocgetZYFDrugDetails,editZYFdugDoc,dugDoctoZYFExamine,
		deleteZYFDoc, } from "@/api/MedicenHouse/Western.js";
	// 采购计划
	import {
		getPurchasingPlanZY,
		TcmPage
	} from "@/api/PSI.js";
	// 供货单位
	import {
		addSupplierEntity
	} from "@/api/supplier.js";
	// 生产厂家
	import {
		getManufacturerById
	} from "@/api/MedicenCata.js";

	// 调拨
	import {
		ZYfastTransfer,
		importZYExcel
	} from "@/api/systemCatalogue/Western.js";

	// 引入详情模态框子组件
	import StorePsiDetail from './StorePsiDetail.vue';
	// 引入调拨单对话框子组件
	import AddAllocateDialog from './addAllocateDiglog.vue';
	// 引入调拨单对话框子组件 提交= 审核= 过单
	import exaAllocateDiglog from './exaAllocateDiglog.vue';
	// 新增：引入采购退库页面组件
	// import ReturnStore from '../shopReturn/shopReturn.vue';
	export default {
		name: 'StorePsi',
		components: {
			StorePsiDetail,
			AddAllocateDialog,
			exaAllocateDiglog // 修复组件名拼写错误
			// ReturnStore // 注册采购退库组件
		},
		filters: {
			currencyFormat(value) {
				if (value === null || value === undefined || value === '') return '¥0.00';
				const num = Number(value);
				if (isNaN(num)) return '¥0.00000000';
				return '¥' + num.toFixed(8);
			}
		},
		data() {
			return {
				// 修复：添加过滤器需要用到的数据
				currencyFormat: this.currencyFormatFilter, // 将过滤器作为方法引用
				// 新增：记录当前调拨操作类型和来源
				currentTransferOperation: 'create', // create: 新建, edit: 编辑, generate: 生成
				currentTransferSourceData: null, // 调拨来源数据
				// 新增模态框控制数据、
				// 导出相关数据
				exporting: false,
				exportProgress: 0,
				exportTimer: null,
				// 新增：全局loading状态
				globalLoading: false,
				allocateDialogVisible: false,
				exaAllocateDialogVisible: false,
				currentPlanData: null,
				isCalculating: false,
				calculationTimer: null,
				currentTransferRow: null, // 当前操作的调拨单行数据
				currentOperation: '', // 当前操作类型：edit/submit/audit/pass
				selectedTransferRows: [],
				// 新增：快速调拨按钮启用状态
				isQuickTransferEnabled: false,
				// 新增：错误数据相关状态
				errorData: [], // 存储错误信息
				downloadingError: false, // 下载错误信息状态
				// 新增：记录调拨单打开来源
				transferOpenSource: null, // null: 新建, 'audit': 审核调拨单, 'generate': 生成调拨单
				currentSelectedRow: null, // 当前选中的采购入库行数据
				transferLoadingTimer: null, // loading计时器
				showTransferLoading: false, // 是否显示调拨单加载状态
				// 新增：调拨单对话框可见性
				// allocateDialogVisible: false,
				isFromPlanTransfer: false, // 是否从采购计划跳转过来
				// 新增：编辑模式标识
				isEditMode: false,
				loading: false,
				pageSize: 10,
				pageNum:1,
				currentEditId: null, // 当前编辑的ID
				// 修改：退库模式状态
				isReturnMode: false,
				// 采购入库模态框相关数据
				purchaseDialogVisible: false,
				submitLoading: false,
				// 新增：确定按钮启用状态
				// 新增：药品选项数据
				drugOptions: [],
				// 新增：退库模式相关数据
				// isReturnMode: false,
				exportLoading: false,
				returnDialogVisible: false,
				returnLoading: false,
				returnForm: {
					id: null,
					docNum: '',
					drugInfo: '',
					currentStock: 0,
					returnQuantity: 1,
					returnReason: ''
				},
				// 快速调拨相关数据
				showQuickTransferDialog: false,
				transferLoading: false,
				quickTransferForm: {
					fromWarehouse: '',
					toWarehouse: 4, // 修改：默认设置为4（中药房）
					busDate: new Date().toISOString().split('T')[0],
					docNum: '',
					remark: ''
				},
				transferTableDetailsData: [],
				totalCostAmount: '0.00',
				totalSaleAmount: '0.00',
				// 新增：供货单位模态框相关数据
				supplierDialogVisible: false,
				supplierLoading: false,
				supplierForm: {
					supplierName: '',
					supplierCode: '',
					contact: '',
					contactPhone: '',
					address: '',
					remark: ''
				},
				// 存储原始精度值的变量
				AtotalCostRaw: '0.00000000',
				AtotalSaleRaw: '0.00000000',
				supplierRules: {
					supplierName: [{
						required: true,
						message: '请输入供货单位名称',
						trigger: 'blur'
					}],
					supplierCode: [{
						required: true,
						message: '请输入供货单位编码',
						trigger: 'blur'
					}]
				},
				// 新增：控制立即执行按钮状态
				isSubmitDisabled: true,
				// 新增：记录当前入库类型
				currentStorageType: 'purchase', // purchase, other, transfer, inventory
				// 新增：加成方式选项
				markUpOptions: [{
						id: 1,
						label: '比例加成'
					},
					{
						id: 2,
						label: '固定加成'
					},
					{
						id: 3,
						label: '手工比例'
					},
					{
						id: 4,
						label: '不加成'
					}
				],

				// 新增：调拨单表格显示状态
				showTransferTable: false,
				// 调拨单表格数据
				transferTableData: [],
				transferTableLoading: false,
				transferPagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				// 新增：调拨单筛选条件
				transferFilter: {
					state: '', // 状态筛选
					dateRange: [], // 日期范围
				},
				// 查询表单数据
				queryForm: {
					state: '', // 默认选择全部状态
					createTime: [],
					storageType: 'all',
					supplier: '',
					docNum: '',
					goodsInfo: '',
					warehouse: 4, // 默认选择中药房
				},

				purchaseForm: {
				  warehouse: '',
				  busDate: new Date().toISOString().split('T')[0], // 默认今天
				  supplierId: '',
				  supplierName: '',
				  purcInvoCodg: '',
				  supplyCode: '',
				  putinTypeId: 2, // 默认设置为2（入库）
				  remark: '',
				  totalAmt: '0.00'
				},
				// 新增：表格加载状态
				tableLoading: false,

				// 新增：采购计划抽屉相关数据
				purchasePlanDrawerVisible: false,
				purchasePlanList: [],
				purchasePlanOptions: [],
				planLoading: false,
				planQueryForm: {
					docNum: '',
					supplier: ''
				},
				planPagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				// 表单验证规则
				purchaseRules: {
					warehouse: [{
						required: true,
						message: '请选择采购药库',
						trigger: 'change'
					}],
					busDate: [{
						required: true,
						message: '请选择业务日期',
						trigger: 'change'
					}],
					supplierId: [{
						required: true,
						message: '请选择供货单位',
						trigger: 'change'
					}]
				},
				// 药品列表（参考第二个文件的结构）
				goodsList: [],

				// 选项数据（参考第二个文件）
				gysOption: [],
				// 新增：请求控制相关变量

				// submitLoading: false,
				detailLoading: false,
				currentLoadingId: null,
				isLoading: false,
				cachedPurchaseData: null, // 缓存采购数据
				putinOption: [], // 入库方式
				cgOption: [],

				prodentOption: [],
				// 错误验证规则
				validationRules: {
					drugId: {
						required: true,
						message: '请选择药品名称'
					},
					purcCnt: {
						required: true,
						message: '请输入入库数量',
						validator: (value) => value !== null && value !== undefined && value !== '' && Number(value) > 0
					},
					manuLotnum: {
						required: true,
						message: '请输入生产批号'
					},
					manuDate: {
						required: true,
						message: '请选择生产日期'
					},
					expyDate: {
						required: true,
						message: '请选择有效日期'
					},
					prodentpNameId: {
						required: true,
						message: '请选择生产厂家'
					}
				},
				excelDialogVisible: false, // 控制Excel导入对话框显示
				excelFileList: [], // 上传的文件列表
				excelTableData: [], // 解析后的Excel数据
				excelColumns: [], // Excel表头
				uploadUrl: '/api/importZYExcel', // 模拟上传接口
				uploadHeaders: {
					'Authorization': localStorage.getItem('token')
				},
				filePath: '',
				fileList: '',
				fileType: 'excel',
				// 新增：调拨单相关数据
				isTransferSubmitEnabled: false,
				// selectedTransferRows: [],
				transferForm: {
					fromWarehouse: '',
					toWarehouse: '',
					busDate: new Date().toISOString().split('T')[0],
					docNum: '',
					remark: ''
				},
				transferRules: {
					fromWarehouse: [{
						required: true,
						message: '请选择调出药库',
						trigger: 'change'
					}],
					toWarehouse: [{
						required: true,
						message: '请选择调入药库',
						trigger: 'change'
					}],
					busDate: [{
						required: true,
						message: '请选择业务日期',
						trigger: 'change'
					}]
				},
				// 其他数据保持不变
				currentStatus: 'all',
				selectedRows: [],
				tableData: [],
				warehouseList: [
					{
						id: 2,
						label: '中药库'
					},
					{
						id: 4,
						label: '中药房'
					}
				],
				// 新增：状态映射常量
				transferStatusMap: {
					'draft': '0', // 草稿
					'submit': '2', // 已提交
					'audit': '4', // 已审核
					'pass': '5' // 已过单
				},
				// 详情模态框相关数据
				// 判断是否为 Electron 环境
				    isElectron: false,
				// 详情模态框相关数据 - 修复：统一使用 detailMode
				detailDialogVisible: false,
				detailMode: 'view', // view/edit/exam - 修复：将 detailDialogMode 改为 detailMode
				currentPlanId: null,
				// currentPlanData: null,
				watermarkText: '',
				storageTypeOptions: [],
				statusList: [{
						id: '', // 空字符串表示全部状态
						label: '全部状态',
						value: 'all'
					},
					{
						id: 0,
						label: '草稿',
						value: '0'
					},
					{
						id: 2,
						label: '已提交',
						value: '2'
					},
					{
						id: 4,
						label: '已审核',
						value: '4'
					},
					{
						id: 5,
						label: '已过单',
						value: '5'
					},
					{
						id: 6,
						label: '已冲销',
						value: '6'
					}
				],
				previousWarehouse: 2, // 记录之前的库房值
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				}
			}
		},
		// 修复：正确定义过滤器
		// filters: {
		//   currencyFormat(value) {
		//     if (value === null || value === undefined || value === '') return '¥0.00';
		//     const num = Number(value);
		//     if (isNaN(num)) return '¥0.00';
		//     return '¥' + num.toFixed(8);
		//   }
		// },
		computed: {
			isSubmitEnabled() {
				// 检查供货单位是否已选择
				if (!this.purchaseForm.supplierId) {
					return false;
				}

				// 检查药品列表是否为空
				if (this.goodsList.length === 0) {
					return false;
				}

				// 检查所有药品行的必填字段
				return this.goodsList.every(row => {
					const requiredFields = ['drugId', 'purcCnt', 'manuLotnum', 'manuDate', 'expyDate',
						'prodentpNameId'
					];

					// 对每个必填字段进行检查
					const fieldsComplete = requiredFields.every(field => {
						// 对于purcCnt字段，只要不为空且大于0即可（包括默认值1）
						if (field === 'purcCnt') {
							const value = row[field];
							return value !== null &&
								value !== undefined &&
								value !== '' &&
								Number(value) > 0;
						}

						// 对于其他字段，检查是否存在且不为空字符串
						return row[field] && (typeof row[field] !== 'string' || row[field].trim() !== '');
					});

					// 检查是否有错误
					const noErrors = !row.$errors || !Object.keys(row.$errors).some(key => row.$errors[key]);

					return fieldsComplete && noErrors;
				});
			},
			// 修改采购对话框标题计算属性
			purchaseDialogTitle() {
				const warehouseType = this.purchaseForm.warehouse == 2 ? '中药库' : '中药房';
				const typeMap = {
					'purchase': '采购入库',
					'other': '其他入库',
					'transfer': '调拨入库',
					'inventory': '盘点入库'
				};
				const typeText = typeMap[this.currentStorageType] || '入库';

				if (this.isEditMode) {
					const docNum = this.purchaseForm.docNum || '采购入库单';
					return `修改 ${docNum} ${warehouseType}${typeText}`;
				} else {
					return `添加${warehouseType}${typeText}单`;
				}
			},
		},
		async mounted() {
			// 检查是否有传入的采购计划ID
			const selectedPlanIds = this.$route.query.selectedPlanIds;
			if (selectedPlanIds) {
				// 延迟执行，确保页面完全加载后再打开模态框
				this.$nextTick(() => {
					setTimeout(() => {
						this.handleImportPurchasePlans(selectedPlanIds);
					}, 500);
				});
			}

			// 原有初始化逻辑
			await this.loadStorageTypeOptions();
			this.loadData();

			// 初始化时立即检查完成状态
			this.$nextTick(() => {
				this.checkAllRowsCompletion();
			});
			this.checkIsElectron();
		},
		// 修改：监听调拨表单变化
		watch: {
			'transferForm.toWarehouse': function(newVal) {
				this.isTransferSubmitEnabled = this.checkTransferSubmitEnabled();
			},
			visible: {
				immediate: true,
				handler(newVal) {
					this.dialogVisible = newVal;
					if (newVal && this.planId && this.planId !== this.currentPlanId) {
						this.currentPlanId = this.planId;
						this.loadPlanData(this.planId);
					}

					// 新增：当对话框打开时，确保模式正确设置
					if (newVal && this.mode === 'exam') {
						this.$nextTick(() => {
							this.autoSetExamModeType();
						});
					}
				}
			},
			goodsList: {
				deep: true,
				handler(newVal, oldVal) {
					// 检查是否有价格或数量变化
					const hasPriceChange = newVal.some((row, index) => {
						if (!oldVal[index]) return false;
						return row.purcPric !== oldVal[index].purcPric ||
							row.purcCnt !== oldVal[index].purcCnt;
					});

					if (hasPriceChange) {
						this.calculateAllAmounts();
					}
				}
			},

			// 新增：计算所有行的金额
			calculateAllAmounts() {
				this.goodsList.forEach(row => {
					this.calculateAmounts(row);
				});

				this.calculateTotalCost();
				this.calculateTotalSale();
			},
			selectedTransferRows: {
				handler() {
					this.calculateTransferTotals();
					this.isTransferSubmitEnabled = this.checkTransferSubmitEnabled();
				},
				deep: true
			},
		},
		methods: {
			// 新增：获取入库类型选项的方法
			async loadStorageTypeOptions() {
				try {
					this.loading = true;
					const response = await getPutin(); // 调用接口获取入库类型

					if (response.code === 200) {
						// 根据接口返回的数据结构进行处理
						const optionsData = response.data || response.data.content || response.data.list || [];

						// 转换数据格式为统一的选项格式
						this.storageTypeOptions = optionsData.map(item => ({
							id: item.id || item.value || item.code, // 根据实际接口返回的字段调整
							label: item.name || item.label || item.text, // 根据实际接口返回的字段调整
							value: item.id || item.value || item.code // 根据实际接口返回的字段调整
						}));

						// 确保包含"全部类型"选项
						if (!this.storageTypeOptions.some(opt => opt.id === 'all')) {
							this.storageTypeOptions.unshift({
								id: 'all',
								label: '全部类型',
								value: 'all'
							});
						}

						// ////console.log('入库类型选项加载成功:', this.storageTypeOptions);
					} else {
						////console.error('获取入库类型失败:', response.message);
						// 使用默认选项作为备选
						this.setDefaultStorageOptions();
					}
				} catch (error) {
					////console.error('加载入库类型选项失败:', error);
					// 使用默认选项作为备选
					this.setDefaultStorageOptions();
				} finally {
					this.loading = false;
				}
			},
			// 新增：显示全局loading
			showGlobalLoading() {
				this.globalLoading = true;
				// 可以在这里添加全屏loading效果
				if (this.$loading) {
					this.loadingInstance = this.$loading({
						lock: true,
						text: '数据加载中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				}
			},

			// 新增：隐藏全局loading
			hideGlobalLoading() {
				this.globalLoading = false;
				if (this.loadingInstance) {
					this.loadingInstance.close();
				}
			},
			// 状态变化处理
			handleStatusChange(value) {
				// ////console.log('状态筛选变化:', value);
				this.pagination.currentPage = 1; // 重置到第一页
				this.loadData(); // 重新加载数据
			},
			// 新增：设置默认入库类型选项（备用）
			setDefaultStorageOptions() {
				this.storageTypeOptions = [{
						id: 'all',
						label: '全部类型',
						value: 'all'
					},
					{
						id: 'purchase',
						label: '采购入库',
						value: 'purchase'
					},
					{
						id: 'transfer',
						label: '调拨入库',
						value: 'transfer'
					},
					{
						id: 'other',
						label: '其他入库',
						value: 'other'
					},
					{
						id: 'inventory',
						label: '盘点入库',
						value: 'inventory'
					}
				];
				this.$message.warning('使用默认入库类型选项');
			},

			// 修改：库存类型变化处理 - 修复比例加成重新计算问题
			async handleStorageTypeChange(newType, row) {
				console.log('库存类型变化处理开始:', {
					药品: row.name,
					当前类型: row.purcType,
					新类型: newType,
					是否相同: row.purcType === newType,
					加成方式: row.markUpId
				});

				try {
					this.isCalculating = true;
					row.isCalculating = true;

					// 关键修复：正确获取旧类型
					const oldType = row.purcType;

					// 如果类型没有变化，直接返回
					if (oldType === newType) {
						console.log('库存类型未变化，跳过处理');
						this.isCalculating = false;
						row.isCalculating = false;
						return;
					}

					console.log('开始处理库存类型转换:', {
						药品: row.name,
						旧类型: oldType,
						新类型: newType,
						当前数量: row.purcCnt,
						包装数量: row.pacCnt,
						当前成本单价: row.purcPric,
						加成方式: row.markUpId
					});

					const pacCnt = Number(row.pacCnt) || 1;
					const currentPurcCnt = Number(row.purcCnt) || 0;

					// 关键修复：先保存旧值，再更新类型
					row.purcType = newType;

					// 根据切换方向进行数量和单价转换
					if (oldType === '2' && newType === '1') {
						// 从包装单位切换到最小单位
						await this.convertFromPackageToUnit(row, pacCnt, currentPurcCnt);
					} else if (oldType === '1' && newType === '2') {
						// 从最小单位切换到包装单位
						await this.convertFromUnitToPackage(row, pacCnt, currentPurcCnt);
					}

					// 关键修复：如果加成方式为比例加成，重新调用接口计算零售单价
					if (row.markUpId === '1') {
						console.log('比例加成模式，重新调用接口计算零售单价:', {
							新成本单价: row.purcPric,
							库存类型: newType
						});

						await this.calculateSalePriceWithMarkUpApi(row);
					} else {
						// 其他加成方式，使用本地计算
						this.calculateSalePriceLocally(row);
					}

					// 重新计算金额
					this.calculateAmounts(row);

					// 更新合计金额
					this.calculateTotalCost();
					this.calculateTotalSale();

					// 更新单位显示
					this.updateUnitDisplay(row);

					console.log('库存类型切换完成:', {
						药品: row.name,
						旧类型: oldType,
						新类型: newType,
						转换后数量: row.purcCnt,
						转换后成本单价: row.purcPric,
						转换后零售单价: row.salePric,
						加成方式: row.markUpId
					});

				} catch (error) {
					console.error('库存类型切换计算失败:', error);
					this.$message.error('计算失败，请检查数据');
				} finally {
					this.isCalculating = false;
					if (row.isCalculating !== undefined) {
						row.isCalculating = false;
					}
				}
			},

			// 修改：从包装单位转换到最小单位 - 确保比例加成重新计算
			async convertFromPackageToUnit(row, pacCnt, currentPurcCnt) {
				console.log('包装单位→最小单位转换开始:', {
					当前数量: currentPurcCnt,
					包装数量: pacCnt,
					当前成本单价: row.purcPric
				});

				try {
					// 入库数量 = 原数量 × 包装数量
					const newPurcCnt = currentPurcCnt * pacCnt;
					row.purcCnt = newPurcCnt.toString();

					// 确保基准价格存在
					await this.ensureBasePricesExist(row);

					// 显示最小单价
					const oldCostPrice = row.purcPric; // 保存旧成本单价
					row.purcPric = row.minPurcPric || '0.00000000';

					console.log('包装单位→最小单位数量转换完成:', {
						数量转换: `${currentPurcCnt} × ${pacCnt} = ${row.purcCnt}`,
						旧成本单价: oldCostPrice,
						新成本单价: row.purcPric
					});

					// 关键修复：比例加成需要重新调用接口
					if (row.markUpId === '1') {
						console.log('比例加成模式，使用新成本单价调用接口:', row.purcPric);
						await this.calculateSalePriceWithMarkUpApi(row);
					} else {
						// 其他加成方式，直接使用基准价格
						row.salePric = row.minSalePric || '0.00000000';
						console.log('非比例加成模式，直接使用最小零售单价:', row.salePric);
					}

				} catch (error) {
					console.error('包装单位到最小单位转换失败:', error);
					throw error;
				}
			},

			// 修改：从最小单位转换到包装单位 - 确保比例加成重新计算
			async convertFromUnitToPackage(row, pacCnt, currentPurcCnt) {
				console.log('最小单位→包装单位转换开始:', {
					当前数量: currentPurcCnt,
					包装数量: pacCnt,
					当前成本单价: row.purcPric
				});

				try {
					// 入库数量 = 原数量 ÷ 包装数量
					const newPurcCnt = currentPurcCnt / pacCnt;

					// 确保数量是合理的小数
					if (newPurcCnt % 1 === 0) {
						row.purcCnt = newPurcCnt.toString();
					} else {
						row.purcCnt = newPurcCnt;
					}

					// 确保基准价格存在
					await this.ensureBasePricesExist(row);

					// 显示最大单价
					const oldCostPrice = row.purcPric; // 保存旧成本单价
					row.purcPric = row.maxPurcPric || '0.00000000';

					console.log('最小单位→包装单位数量转换完成:', {
						数量转换: `${currentPurcCnt} ÷ ${pacCnt} = ${row.purcCnt}`,
						旧成本单价: oldCostPrice,
						新成本单价: row.purcPric
					});

					// 关键修复：比例加成需要重新调用接口
					if (row.markUpId === '1') {
						console.log('比例加成模式，使用新成本单价调用接口:', row.purcPric);
						await this.calculateSalePriceWithMarkUpApi(row);
					} else {
						// 其他加成方式，直接使用基准价格
						row.salePric = row.maxSalePric || '0.00000000';
						console.log('非比例加成模式，直接使用最大零售单价:', row.salePric);
					}

				} catch (error) {
					console.error('最小单位到包装单位转换失败:', error);
					throw error;
				}
			},

			// 修改：确保基准价格存在的方法
			async ensureBasePricesExist(row) {
				const pacCnt = Number(row.pacCnt) || 1;
				const currentPurcPric = Number(row.purcPric) || 0;
				const currentSalePric = Number(row.salePric) || 0;

				console.log('确保基准价格存在:', {
					当前成本单价: currentPurcPric,
					当前零售单价: currentSalePric,
					包装数量: pacCnt,
					库存类型: row.purcType
				});

				// 如果基准价格不存在，根据当前价格计算
				if (!row.minPurcPric || Number(row.minPurcPric) === 0) {
					if (row.purcType === '1') {
						// 当前是最小单位模式
						row.minPurcPric = currentPurcPric;
						row.maxPurcPric = (currentPurcPric * pacCnt);
					} else {
						// 当前是包装单位模式
						row.maxPurcPric = currentPurcPric;
						row.minPurcPric = (currentPurcPric / pacCnt);
					}
				}

				if (!row.minSalePric || Number(row.minSalePric) === 0) {
					if (row.purcType === '1') {
						// 当前是最小单位模式
						row.minSalePric = currentSalePric;
						row.maxSalePric = (currentSalePric * pacCnt);
					} else {
						// 当前是包装单位模式
						row.maxSalePric = currentSalePric;
						row.minSalePric = (currentSalePric / pacCnt);
					}
				}

				console.log('基准价格确保完成:', {
					最小成本单价: row.minPurcPric,
					最大成本单价: row.maxPurcPric,
					最小零售单价: row.minSalePric,
					最大零售单价: row.maxSalePric,
					当前库存类型: row.purcType
				});
			},

			// 修改：成本单价变化处理 - 根据markUpId正确计算零售单价
			async handleCostPriceChange(row) {
				this.isCalculating = true;
				if (row.isCalculating !== undefined) {
					row.isCalculating = true;
				}

				try {
					// 验证成本单价格式
					if (!this.validateCostPrice(row.purcPric)) {
						this.$message.warning('成本单价格式不正确');
						row.purcPric = 0;
						return;
					}

					const costPrice = parseFloat(row.purcPric);
					const pacCnt = parseInt(row.pacCnt) || 1;

					console.log('成本单价变化处理:', {
						药品: row.name,
						新价格: costPrice,
						库存类型: row.purcType,
						包装数量: pacCnt,
						markUpId: row.markUpId
					});

					// 关键修改：根据当前库存类型更新对应的基准价格
					if (row.purcType === '1') {
						// 最小单位模式：更新最小基准价，重新计算最大基准价
						row.minPurcPric = costPrice;
						row.maxPurcPric = (costPrice * pacCnt);
					} else {
						// 包装单位模式：更新最大基准价，重新计算最小基准价
						row.maxPurcPric = costPrice;
						row.minPurcPric = (costPrice / pacCnt);
					}

					console.log('基准价格更新完成:', {
						最小成本: row.minPurcPric,
						最大成本: row.maxPurcPric
					});

					// 关键修改：根据markUpId重新计算零售单价
					await this.calculateSalePriceByMarkUpType(row);

					// 重新计算金额
					this.calculateAmounts(row);

					// 更新合计金额
					this.calculateTotalCost();
					this.calculateTotalSale();

				} catch (error) {
					console.error('成本单价变化处理失败:', error);
					this.$message.error('计算失败，请检查数据');
				} finally {
					this.isCalculating = false;
					if (row.isCalculating !== undefined) {
						row.isCalculating = false;
					}
				}
			},
			// 修改：调用接口计算零售单价的方法 - 优化参数处理
			async calculateSalePriceWithMarkUpApi(row) {
				// 只有当markUpId为1（比例加成）时才调用接口
				if (row.markUpId !== '1') {
					console.log('非比例加成模式，跳过接口调用');
					return;
				}

				try {
					// 如果成本单价为空或为0，不进行计算
					if (!row.purcPric || Number(row.purcPric) <= 0) {
						row.salePric = '0.00000000';
						row.markUpRate = 0;
						console.log('成本单价无效，重置零售单价为0');
						return;
					}

					const costPrice = Number(row.purcPric);

					// 关键修复：确保成本单价是转换后的正确值
					console.log('调用比例加成接口参数:', {
						成本单价: costPrice,
						库存类型: row.purcType,
						药品名称: row.name,
						包装数量: row.pacCnt
					});

					const apiParams = {
						costPric: costPrice, // 使用转换后的成本单价
						drugType: 9 // 固定为9，表示中药
					};

					// 调用接口获取加成率和销售单价
					const response = await docMarkById(apiParams);

					if (response.code === 200 && response.data) {
						const markUpData = response.data;

						// 更新加成率和销售单价
						row.markUpRate = markUpData.markUpRate || 0;
						const calculatedSalePrice = markUpData.salePrice ? Number(markUpData.salePrice) :
							'0.00000000';
						row.salePric = calculatedSalePrice;

						console.log('接口计算零售单价成功:', {
							成本单价: costPrice,
							加成率: row.markUpRate,
							零售单价: row.salePric,
							库存类型: row.purcType,
							计算方式: '比例加成接口'
						});
					} else {
						// 如果接口调用失败，使用默认计算方法
						console.warn('比例加成接口调用失败，使用本地计算:', response.message);
						this.calculateSalePriceLocally(row);
					}
				} catch (error) {
					console.error('比例加成计算失败:', error);
					// 出错时使用本地计算方法
					this.calculateSalePriceLocally(row);
				}
			},

			// 修改：本地计算零售单价（用于非比例加成情况）
			calculateSalePriceLocally(row) {
				if (!row.purcPric || Number(row.purcPric) <= 0) {
					row.salePric = '0.00000000';
					row.markUpRate = 0;
					return;
				}

				const costPrice = Number(row.purcPric);
				const markUpId = row.markUpId ? row.markUpId.toString() : '1';

				console.log('本地计算零售单价:', {
					成本单价: costPrice,
					加成方式: markUpId,
					库存类型: row.purcType
				});

				switch (markUpId) {
					case '1': // 比例加成 - 理论上不应该进入这里，但作为备用
						// 如果有缓存的比例，使用缓存比例计算
						const markUpRate = Number(row.markUpRate || 0);
						row.salePric = (costPrice * (1 + markUpRate / 100));
						console.log('本地比例加成计算:', {
							成本: costPrice,
							加成率: markUpRate,
							零售价: row.salePric
						});
						break;

					case '2': // 固定加成：零售单价 = 成本单价 + 固定加成金额
						const markUpPric = Number(row.markUpPric || 0);
						row.salePric = (costPrice + markUpPric);
						console.log('固定加成计算:', {
							成本: costPrice,
							加成金额: markUpPric,
							零售价: row.salePric
						});
						break;

					case '3': // 手工比例加成：零售单价 = 成本单价 × (1 + 加成率/100)
						const manualRate = Number(row.markUpRate || 0);
						row.salePric = (costPrice * (1 + manualRate / 100));
						console.log('手工比例加成计算:', {
							成本: costPrice,
							手工加成率: manualRate,
							零售价: row.salePric
						});
						break;

					case '4': // 不加成：零售单价 = 成本单价
						row.salePric = costPrice;
						console.log('不加成计算:', {
							成本: costPrice,
							零售价: row.salePric
						});
						break;

					default: // 默认比例加成
						row.salePric = costPrice;
						console.log('默认计算:', {
							成本: costPrice,
							零售价: row.salePric
						});
				}

				// 确保零售单价不为负数
				if (Number(row.salePric) < 0) {
					row.salePric = '0.00000000';
				}

				console.log('本地计算完成:', {
					最终零售单价: row.salePric
				});
			},

			// 修改：处理药品选择变化 - 自动设置加成方式
			async handleDrugChange(drugId, row) {
				try {
					row.drugLoading = true;
					console.log('药品选择变化:', {
						drugId,
						当前行: row,
						当前加成方式: row.markUpId
					});

					// 查找选中的药品
					const selectedDrug = this.drugOptions.find(drug => drug.id === drugId);
					if (!selectedDrug) {
						console.warn('未找到选中的药品信息');
						row.drugLoading = false;
						return;
					}

					console.log('选中药品信息:', {
						药品名称: selectedDrug.name,
						接口返回的加成方式ID: selectedDrug.markUpId,
						接口返回的加成方式类型: typeof selectedDrug.markUpId
					});

					// 关键修改：设置药品基本信息
					row.drugId = selectedDrug.id;
					row.name = selectedDrug.name || '';
					row.drugSpecifications = selectedDrug.drugSpecifications || '';
					row.pacSpec = selectedDrug.pacSpec || '';
					row.dosUnt = selectedDrug.dosUnt || '粒';
					row.pacUnt = selectedDrug.pacUnt || '盒';
					row.pacCnt = selectedDrug.pacCnt || 1;

					// 关键修改：根据接口返回的markUpId设置加成方式
					if (selectedDrug.markUpId !== undefined && selectedDrug.markUpId !== null) {
						// 确保markUpId是字符串类型（与下拉选项值类型一致）
						const newMarkUpId = selectedDrug.markUpId.toString();

						console.log('设置加成方式:', {
							原加成方式: row.markUpId,
							新加成方式: newMarkUpId,
							加成方式名称: this.getMarkUpNameById(newMarkUpId)
						});

						row.markUpId = newMarkUpId;

						// 同时设置对应的加成值
						await this.setMarkUpValueByType(newMarkUpId, row, selectedDrug);
					} else {
						// 如果接口没有返回markUpId，使用默认的比例加成
						console.warn('接口未返回加成方式ID，使用默认比例加成');
						row.markUpId = '1';
						await this.setDefaultMarkUpValues(row);
					}

					// 设置基准价格
					await this.initializeBasePrices(row, selectedDrug.costPric || 0);

					// 根据加成方式计算零售单价
					await this.calculateSalePriceByMarkUpType(row);

					// 计算金额
					this.calculateAmounts(row);

					// 加载生产厂家选项
					await this.loadManufacturerOptionsForDrug(drugId, row);

					console.log('药品选择处理完成:', {
						药品: row.name,
						最终加成方式: row.markUpId,
						加成方式名称: this.getMarkUpNameById(row.markUpId),
						成本单价: row.purcPric,
						零售单价: row.salePric
					});

				} catch (error) {
					console.error('处理药品选择变化失败:', error);
					this.$message.error('处理药品选择失败');
				} finally {
					row.drugLoading = false;
				}
			},
			// 新增：根据加成方式ID获取名称
			getMarkUpNameById(markUpId) {
				const markUpMap = {
					'1': '比例加成',
					'2': '固定加成',
					'3': '手工比例加成',
					'4': '不加成'
				};
				return markUpMap[markUpId] || '未知加成方式';
			},

			// 新增：根据加成方式类型设置对应的值
			async setMarkUpValueByType(markUpId, row, drugData) {
				console.log('设置加成值:', {
					加成方式: markUpId,
					药品数据: drugData
				});

				switch (markUpId) {
					case '1': // 比例加成
						row.markUpRate = drugData.markUpRate || 0;
						row.markUpPric = 0;
						console.log('比例加成模式: 加成比例=', row.markUpRate);
						break;

					case '2': // 固定加成
						row.markUpRate = 0;
						row.markUpPric = drugData.markUpPric || 0;
						console.log('固定加成模式: 加成金额=', row.markUpPric);
						break;

					case '3': // 手工比例加成
						row.markUpRate = drugData.markUpRate || 0;
						row.markUpPric = 0;
						console.log('手工比例加成模式: 加成比例=', row.markUpRate);
						break;

					case '4': // 不加成
						row.markUpRate = 0;
						row.markUpPric = 0;
						console.log('不加成模式: 清空加成值');
						break;

					default:
						console.warn('未知加成方式，使用默认值');
						await this.setDefaultMarkUpValues(row);
				}
			},

			// 新增：设置默认加成值
			setDefaultMarkUpValues(row) {
				row.markUpRate = 0;
				row.markUpPric = 0;
				console.log('使用默认加成值');
			},

			// 新增：根据加成方式计算零售单价
			async calculateSalePriceByMarkUpType(row) {
				if (!row.purcPric || Number(row.purcPric) <= 0) {
					row.salePric = '0.00000000';
					return;
				}

				const costPrice = Number(row.purcPric);
				const markUpId = row.markUpId || '1';

				console.log('根据加成方式计算零售单价:', {
					成本单价: costPrice,
					加成方式: markUpId,
					加成比例: row.markUpRate,
					加成金额: row.markUpPric
				});

				try {
					switch (markUpId) {
						case '1': // 比例加成：零售单价 = 成本单价 × (1 + 加成率)
							const rate1 = Number(row.markUpRate || 0);
							row.salePric = (costPrice * (1 + rate1 / 100));
							console.log(`比例加成计算: ${costPrice} × (1 + ${rate1}%) = ${row.salePric}`);
							break;

						case '2': // 固定加成：零售单价 = 成本单价 + 加成金额
							const fixedPrice = Number(row.markUpPric || 0);
							row.salePric = (costPrice + fixedPrice);
							console.log(`固定加成计算: ${costPrice} + ${fixedPrice} = ${row.salePric}`);
							break;

						case '3': // 手工比例加成：零售单价 = 成本单价 × (1 + 加成率/100)
							const rate3 = Number(row.markUpRate || 0);
							row.salePric = (costPrice * (1 + rate3 / 100));
							console.log(`手工比例加成计算: ${costPrice} × (1 + ${rate3}%) = ${row.salePric}`);
							break;

						case '4': // 不加成：零售单价 = 成本单价
							row.salePric = costPrice;
							console.log(`不加成计算: 零售单价 = 成本单价 = ${row.salePric}`);
							break;

						default:
							// 默认使用比例加成
							row.salePric = costPrice;
							console.log('默认计算: 使用成本单价作为零售单价');
					}

					// 确保零售单价不为负数
					if (Number(row.salePric) < 0) {
						row.salePric = '0.00000000';
					}

					console.log('零售单价计算完成:', row.salePric);

				} catch (error) {
					console.error('计算零售单价失败:', error);
					row.salePric = costPrice.toFixed(8);
				}
			},
			// 修改：初始化基准价格 - 确保在设置加成方式后调用
			async initializeBasePrices(row, baseCostPrice) {
				if (!baseCostPrice || baseCostPrice <= 0) {
					baseCostPrice = 0;
				}

				const costPrice = Number(baseCostPrice);
				const pacCnt = Number(row.pacCnt) || 1;

				// 设置基准价格
				row.minPurcPric = (costPrice / pacCnt).toFixed(8); // 最小单位价格
				row.maxPurcPric = costPrice.toFixed(8); // 包装单位价格

				// 根据当前库存类型设置显示价格
				if (row.purcType === '1') {
					row.purcPric = row.minPurcPric;
				} else {
					row.purcPric = row.maxPurcPric;
				}

				console.log('基准价格初始化完成:', {
					基准成本: costPrice,
					包装数量: pacCnt,
					最小单价: row.minPurcPric,
					最大单价: row.maxPurcPric,
					显示单价: row.purcPric,
					当前库存类型: row.purcType
				});
			},

			// 新增：为药品加载生产厂家选项
			async loadManufacturerOptionsForDrug(drugId, row) {
				try {
					row.manufacturerLoading = true;

					const response = await getProdentZY({
						drugId: drugId
					});

					if (response.code === 200) {
						const manufacturers = response.data || response.data.list || [];
						row.manufacturerOptions = manufacturers.map(prod => ({
							id: prod.prodentpId || prod.id,
							prodentpName: prod.prodentpName || prod.name,
							prodentpCode: prod.prodentpCode || prod.code
						}));

						console.log('加载生产厂家选项成功:', {
							药品ID: drugId,
							厂家数量: row.manufacturerOptions.length
						});

						// 如果有选中的生产厂家ID，确保选项中存在
						if (row.prodentpNameId && row.manufacturerOptions.length > 0) {
							const selectedManufacturer = row.manufacturerOptions.find(
								prod => prod.id === row.prodentpNameId
							);

							if (!selectedManufacturer) {
								console.warn('选中的生产厂家不在选项中，尝试单独加载:', row.prodentpNameId);
								await this.loadManufacturerById(row.prodentpNameId, row);
							}
						}
					} else {
						console.warn('获取生产厂家失败:', response.message);
						row.manufacturerOptions = [];
					}
				} catch (error) {
					console.error('加载生产厂家选项失败:', error);
					row.manufacturerOptions = [];
				} finally {
					row.manufacturerLoading = false;
				}
			},

			// 新增：通过ID加载生产厂家信息
			async loadManufacturerById(manufacturerId, row) {
				try {
					const id = this.safeParseInt(manufacturerId);
					if (id === null) {
						console.warn('生产厂家ID格式不正确:', manufacturerId);
						return;
					}

					const response = await getManufacturerById({
						id: id
					});

					if (response.code === 200 && response.data) {
						const manufacturerData = response.data;
						const manufacturerOption = {
							id: manufacturerData.prodentpId || manufacturerData.id || id,
							prodentpName: manufacturerData.prodentpName || manufacturerData.name || `厂家${id}`,
							prodentpCode: manufacturerData.prodentpCode || manufacturerData.code || ''
						};

						// 添加到选项中
						if (!row.manufacturerOptions) {
							row.manufacturerOptions = [];
						}

						// 检查是否已存在相同的选项
						const existingIndex = row.manufacturerOptions.findIndex(
							item => item.id === manufacturerOption.id
						);

						if (existingIndex === -1) {
							row.manufacturerOptions.push(manufacturerOption);
						}

						// 确保选中值正确
						row.prodentpNameId = manufacturerOption.id;

						console.log('生产厂家信息已从接口获取:', manufacturerOption);
					} else {
						console.warn('未找到选中的生产厂家信息，ID:', id);
						this.createDefaultManufacturerOption(id, row);
					}
				} catch (error) {
					console.error('通过ID获取生产厂家信息失败:', error);
					this.createDefaultManufacturerOption(this.safeParseInt(manufacturerId), row);
				}
			},

			// 新增：安全转换数字方法
			safeParseInt(value) {
				if (value === null || value === undefined || value === '') return null;
				if (typeof value === 'number') return value;
				if (typeof value === 'string') {
					const parsed = parseInt(value);
					return isNaN(parsed) ? null : parsed;
				}
				return null;
			},

			// 新增：创建默认的生产厂家选项
			createDefaultManufacturerOption(manufacturerId, row) {
				if (manufacturerId === null) return;

				const defaultOption = {
					id: manufacturerId,
					prodentpName: `厂家${manufacturerId}`,
					prodentpCode: ''
				};

				if (!row.manufacturerOptions) {
					row.manufacturerOptions = [];
				}

				const existingIndex = row.manufacturerOptions.findIndex(
					item => item.id === manufacturerId
				);

				if (existingIndex === -1) {
					row.manufacturerOptions.push(defaultOption);
				}

				row.prodentpNameId = manufacturerId;

				console.log('创建默认生产厂家选项:', defaultOption);
			},

			// 修改：计算金额方法 - 支持8位小数
			calculateAmounts(row) {
				try {
					const purcCnt = this.getValidNumber(row.purcCnt, 8);
					const purcPric = this.getValidNumber(row.purcPric, 8);
					const salePric = this.getValidNumber(row.salePric, 8);
			
					// 计算时使用8位精度
					const costAmount = this.calculateWithPrecision(purcCnt * purcPric, 8);
					const saleAmount = this.calculateWithPrecision(purcCnt * salePric, 8);
					
					// 存储8位精度的原始值
					row._purcAmtRaw = this.formatToDecimal(costAmount, 8);
					row._saleAmtRaw = this.formatToDecimal(saleAmount, 8);
					
					// 显示时使用智能格式化
					row.purcAmt = this.smartFormatPrice(costAmount);
					row.saleAmt = this.smartFormatPrice(saleAmount);
			
					// 确保金额不为负数
					if (Number(row._purcAmtRaw) < 0) {
						row._purcAmtRaw = '0.00000000';
						row.purcAmt = '0.00';
					}
					if (Number(row._saleAmtRaw) < 0) {
						row._saleAmtRaw = '0.00000000';
						row.saleAmt = '0.00';
					}
				} catch (error) {
					console.error('计算金额失败:', error);
					row._purcAmtRaw = '0.00000000';
					row._saleAmtRaw = '0.00000000';
					row.purcAmt = '0.00';
					row.saleAmt = '0.00';
				}
			},
			
			// 新增：获取有效数字的方法
			getValidNumber(value, precision = 8) {
				if (value === null || value === undefined || value === '') return 0;
				
				const num = Number(value);
				if (isNaN(num)) return 0;
				
				// 四舍五入到指定精度
				return parseFloat(num.toFixed(precision));
			},
			
			// 新增：高精度计算方法
			calculateWithPrecision(value, precision = 8) {
				// 使用toFixed处理精度问题
				const factor = Math.pow(10, precision);
				return Math.round(value * factor) / factor;
			},
			
			// 新增：格式化到指定小数位
			formatToDecimal(value, precision = 8) {
				const num = this.getValidNumber(value, precision);
				return num.toFixed(precision);
			},
			
			// 修改：计算合计成本金额 - 8位小数
			calculateTotalCost() {
				const total = this.goodsList.reduce((sum, item) => {
					const amount = this.getValidNumber(item._purcAmtRaw || item.purcAmt, 8);
					
					if (isNaN(amount)) {
						console.warn('无效的成本金额:', item.purcAmt, '药品:', item.drugName);
						return sum;
					}
			
					return this.calculateWithPrecision(sum + amount, 8);
				}, 0);
			
				// 存储原始8位值
				this.AtotalCostRaw = this.formatToDecimal(total, 8);
				// 显示智能格式化值
				const displayValue = this.smartFormatPrice(total);
				this.purchaseForm.totalAmt = displayValue;
			
				console.log('成本合计计算完成:', {
					商品数量: this.goodsList.length,
					原始值: this.AtotalCostRaw,
					显示值: displayValue
				});
			
				return displayValue;
			},
			// 新增：智能格式化价格方法
				smartFormatPrice(value, defaultPrecision = 2) {
					if (value === null || value === undefined || value === '') {
						return '0.00000000';
					}
					
					const num = Number(value);
					if (isNaN(num)) {
						return '0.00000000';
					}
					
					// 检查是否为整数
					if (Number.isInteger(num)) {
						return num.toFixed(defaultPrecision);
					}
					
					// 转换为字符串，分析小数位数
					const strValue = num.toString();
					const decimalIndex = strValue.indexOf('.');
					
					if (decimalIndex === -1) {
						// 没有小数点，显示默认精度
						return num.toFixed(defaultPrecision);
					}
					
					// 获取实际小数位数
					const actualDecimals = strValue.length - decimalIndex - 1;
					
					// 处理科学计数法
					const eIndex = strValue.indexOf('e');
					if (eIndex !== -1) {
						// 如果是科学计数法，转换为普通小数
						const exponent = parseInt(strValue.substring(eIndex + 1));
						if (exponent < 0) {
							// 对于非常小的数，最多显示8位小数
							return num.toFixed(Math.min(8, -exponent));
						} else {
							// 对于非常大的数，使用默认精度
							return num.toFixed(defaultPrecision);
						}
					}
					
					// 如果实际小数位数少于默认精度，使用实际位数
					// 如果实际小数位数多于8位，最多显示8位
					const displayDecimals = Math.min(Math.max(actualDecimals, defaultPrecision), 8);
					
					return num.toFixed(displayDecimals);
				},
			
				// 新增：获取实际小数位数
				getActualDecimalPlaces(value) {
					if (value === null || value === undefined || value === '') {
						return 0;
					}
					
					const strValue = value.toString();
					const decimalIndex = strValue.indexOf('.');
					
					if (decimalIndex === -1) {
						return 0;
					}
					
					// 计算小数部分长度
					let decimalPart = strValue.substring(decimalIndex + 1);
					
					// 处理科学计数法
					const eIndex = decimalPart.indexOf('e');
					if (eIndex !== -1) {
						decimalPart = decimalPart.substring(0, eIndex);
					}
					
					// 去除末尾的零
					decimalPart = decimalPart.replace(/0+$/, '');
					
					return decimalPart.length;
				},
			
				// 修改：格式化价格显示方法
				formatPriceWithPrecision(price, defaultPrecision = 2) {
					return this.smartFormatPrice(price, defaultPrecision);
				},
			// 修改：计算合计零售金额 - 8位小数
			calculateTotalSale() {
				const total = this.goodsList.reduce((sum, item) => {
					const amount = this.getValidNumber(item._saleAmtRaw || item.saleAmt, 8);
					
					if (isNaN(amount)) {
						console.warn('无效的零售金额:', item.saleAmt, '药品:', item.drugName);
						return sum;
					}
			
					return this.calculateWithPrecision(sum + amount, 8);
				}, 0);
			
				// 存储原始8位值
				this.AtotalSaleRaw = this.formatToDecimal(total, 8);
				// 显示智能格式化值
				const displayValue = this.smartFormatPrice(total);
			
				console.log('零售合计计算完成:', {
					商品数量: this.goodsList.length,
					原始值: this.AtotalSaleRaw,
					显示值: displayValue
				});
			
				return displayValue;
			},

			// 修改：入库数量变化处理 - 确保重新计算金额
			async handlePurcCntChange(value, row) {
				this.isCalculating = true;
				if (row.isCalculating !== undefined) {
					row.isCalculating = true;
				}

				try {
					// 验证入库数量
					if (!this.validatePurcCntField(row)) {
						this.$message.warning('入库数量必须大于0');
						return;
					}

					console.log('入库数量变化:', {
						药品: row.name,
						新数量: value,
						旧数量: row.purcCnt,
						库存类型: row.purcType
					});

					// 重新计算金额
					this.calculateAmounts(row);

					// 更新合计金额
					this.calculateTotalCost();
					this.calculateTotalSale();

				} catch (error) {
					console.error('入库数量变化处理失败:', error);
					this.$message.error('计算失败，请检查数据');
				} finally {
					this.isCalculating = false;
					if (row.isCalculating !== undefined) {
						row.isCalculating = false;
					}
				}
			},

			// 修改：包装数量变化处理 - 重新计算价格并转换数量
			async handlePacCntChange(value, row) {
				if (!value || value <= 0) {
					this.$message.warning('包装数量必须大于0');
					return;
				}

				try {
					this.isCalculating = true;
					row.isCalculating = true;

					const oldPacCnt = row.pacCnt || 1;
					row.pacCnt = parseInt(value);

					console.log('包装数量变化:', {
						旧数量: oldPacCnt,
						新数量: row.pacCnt,
						库存类型: row.purcType,
						当前数量: row.purcCnt,
						当前成本单价: row.purcPric
					});

					// 关键修改：重新计算基准价格
					if (row.purcType === '1') {
						// 最小单位模式：重新计算最大单价
						if (row.minPurcPric) {
							row.maxPurcPric = (parseFloat(row.minPurcPric) * row.pacCnt).toFixed(8);
						}
						if (row.minSalePric) {
							row.maxSalePric = (parseFloat(row.minSalePric) * row.pacCnt).toFixed(8);
						}
					} else {
						// 包装单位模式：重新计算最小单价
						if (row.maxPurcPric) {
							row.minPurcPric = (parseFloat(row.maxPurcPric) / row.pacCnt).toFixed(8);
						}
						if (row.maxSalePric) {
							row.minSalePric = (parseFloat(row.maxSalePric) / row.pacCnt).toFixed(8);
						}
					}

					// 关键修改：如果当前显示的是与包装数量相关的价格，需要重新计算
					if (row.purcType === '1') {
						// 最小单位模式：显示最小单价
						row.purcPric = row.minPurcPric || '0.00000000';
						row.salePric = row.minSalePric || '0.00000000';
					} else {
						// 包装单位模式：显示最大单价
						row.purcPric = row.maxPurcPric || '0.00000000';
						row.salePric = row.maxSalePric || '0.00000000';
					}

					console.log('包装数量变化后的价格:', {
						最小单价: row.minPurcPric,
						最大单价: row.maxPurcPric,
						当前单价: row.purcPric
					});

					// 关键修改：根据markUpId重新计算零售单价
					await this.calculateSalePriceByMarkUpType(row);

					// 重新计算金额
					this.calculateAmounts(row);

					// 更新单位显示
					this.updateUnitDisplay(row);

					console.log('包装数量变化处理完成:', {
						新数量: row.pacCnt,
						最小单价: row.minPurcPric,
						最大单价: row.maxPurcPric,
						当前单价: row.purcPric,
						加成方式: row.markUpId
					});

				} catch (error) {
					console.error('包装数量变化处理失败:', error);
					this.$message.error('计算失败，请检查数据');
				} finally {
					this.isCalculating = false;
					if (row.isCalculating !== undefined) {
						row.isCalculating = false;
					}
				}
			},

			// 修改：从采购计划填充数据时确保正确初始化基准价格
			async fillGoodsListFromPlan(planData) {
				if (!planData || !planData.list) return;

				this.goodsList = [];

				for (const item of planData.list) {
					const newRow = this.createNewGoodsRow();

					// 填充基本信息
					newRow.drugId = item.drugId;
					newRow.name = item.name;
					newRow.drugSpecifications = item.drugSpecifications;
					newRow.pacSpec = item.pacSpec;
					newRow.purcCnt = item.purcCnt || 1;
					newRow.pacCnt = item.pacCnt || 1;
					newRow.purcType = item.purcType?.toString() || '2';

					// 设置成本单价
					const costPrice = item.purcPric || item.estimatedPrice || 0;

					// 关键修改：正确初始化基准价格
					await this.initializeBasePricesFromPlan(newRow, costPrice);

					console.log('从采购计划填充数据:', {
						药品: newRow.name,
						库存类型: newRow.purcType,
						成本单价: newRow.purcPric,
						最小单价: newRow.minPurcPric,
						最大单价: newRow.maxPurcPric
					});

					// 根据markUpId计算零售单价
					await this.calculateSalePriceByMarkUpType(newRow);

					// 计算金额
					this.calculateAmounts(newRow);

					// 更新单位显示
					this.updateUnitDisplay(newRow);

					this.goodsList.push(newRow);
				}

				// 更新合计金额
				this.calculateTotalCost();
				this.calculateTotalSale();

				console.log('采购计划数据填充完成，共', this.goodsList.length, '条记录');
			},

			// 新增：从采购计划初始化基准价格
			initializeBasePricesFromPlan(row, costPrice) {
				const pacCnt = Number(row.pacCnt) || 1;

				// 初始化基准价格
				row.maxPurcPric = Number(costPrice).toFixed(8);
				row.minPurcPric = (costPrice / pacCnt).toFixed(8);

				// 根据库存类型设置显示价格
				if (row.purcType === '1') {
					row.purcPric = row.minPurcPric;
				} else {
					row.purcPric = row.maxPurcPric;
				}

				console.log('采购计划基准价格初始化:', {
					成本单价: costPrice,
					包装数量: pacCnt,
					最小单价: row.minPurcPric,
					最大单价: row.maxPurcPric,
					显示单价: row.purcPric
				});
			},

			// 修改：更新单位显示方法
			updateUnitDisplay(row) {
				if (row.purcType === '1') {
					// 最小单位模式：显示最小单位
					row.unitDisplay = row.dosUnt || '最小单位';
					row.unitType = '最小单位';
				} else {
					// 包装单位模式：显示包装单位
					row.unitDisplay = row.pacUnt || '包装单位';
					row.unitType = '包装单位';
				}

				console.log('单位显示更新:', row.name, '->', row.unitDisplay);
			},

			// 修改：重新计算所有相关金额的通用方法
			async recalculateAllAmounts(row) {
				try {
					this.isCalculating = true;
					row.isCalculating = true;

					console.log('开始重新计算所有金额:', {
						药品: row.name,
						库存类型: row.purcType,
						当前成本单价: row.purcPric,
						当前数量: row.purcCnt
					});

					// 1. 重新根据markUpId计算零售单价
					await this.calculateSalePriceByMarkUpType(row);

					// 2. 重新计算成本金额和零售金额
					this.calculateAmounts(row);

					// 3. 更新合计金额
					this.calculateTotalCost();
					this.calculateTotalSale();

					// 4. 更新单位显示
					this.updateUnitDisplay(row);

					console.log('所有金额重新计算完成:', {
						药品: row.name,
						库存类型: row.purcType,
						成本单价: row.purcPric,
						零售单价: row.salePric,
						成本金额: row.purcAmt,
						零售金额: row.saleAmt,
						最小单价: row.minPurcPric,
						最大单价: row.maxPurcPric
					});

				} catch (error) {
					console.error('重新计算金额失败:', error);
					this.$message.error('计算失败，请检查数据');
				} finally {
					this.isCalculating = false;
					if (row.isCalculating !== undefined) {
						row.isCalculating = false;
					}
				}
			},

			// 修改：加成方式变化处理 - 重新计算零售单价
			async handleMarkUpChange(markUpId, row) {
				try {
					console.log('加成方式变化:', {
						旧方式: row.markUpId,
						新方式: markUpId,
						药品: row.name
					});

					row.markUpId = markUpId;

					// 重置加成值（除了手工比例，其他情况重置）
					if (markUpId !== '3') {
						row.markUpRate = 0;
					}
					if (markUpId !== '2') {
						row.markUpPric = 0;
					}

					// 重新根据markUpId计算零售单价
					await this.calculateSalePriceByMarkUpType(row);

					// 重新计算金额
					this.calculateAmounts(row);

					// 更新合计金额
					this.calculateTotalCost();
					this.calculateTotalSale();

					console.log('加成方式变化处理完成:', {
						加成方式: markUpId,
						新零售单价: row.salePric
					});

				} catch (error) {
					console.error('加成方式变化处理失败:', error);
					this.$message.error('计算失败');
				}
			},
			
			// 新增：计算日期差（天数）
				calculateDateDifference(startDate, endDate) {
					try {
						// 清空验证错误
						this.clearDateValidationError();
			
						if (!startDate || !endDate) {
							return null;
						}
			
						const start = new Date(startDate);
						const end = new Date(endDate);
			
						// 验证日期格式
						if (isNaN(start.getTime()) || isNaN(end.getTime())) {
							console.warn('日期格式无效:', { startDate, endDate });
							return null;
						}
			
						// 计算天数差
						const timeDiff = end.getTime() - start.getTime();
						const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
			
						console.log('日期差计算:', {
							开始日期: startDate,
							结束日期: endDate,
							天数差: daysDiff
						});
			
						return daysDiff;
					} catch (error) {
						console.error('计算日期差失败:', error);
						return null;
					}
				},
			
				// 新增：验证日期格式
				validateDateFormat(dateString) {
					if (!dateString) return false;
					
					// 检查是否符合 yyyy-MM-dd 格式
					const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
					if (!dateRegex.test(dateString)) {
						return false;
					}
					
					// 检查是否为有效日期
					const dateObj = new Date(dateString);
					return !isNaN(dateObj.getTime());
				},
			
				// 新增：验证有效期是否晚于生产日期（增强版）
				async validateExpiryDateAfterManufacture(manuDate, expyDate, row) {
					return new Promise((resolve) => {
						try {
							// 清空验证错误
							this.clearDateValidationError(row);
			
							if (!manuDate || !expyDate) {
								resolve(true);
								return;
							}
			
							// 验证日期格式
							if (!this.validateDateFormat(manuDate) || !this.validateDateFormat(expyDate)) {
								this.$message.warning('日期格式不正确，请检查！');
								
								if (!row.$errors) {
									this.$set(row, '$errors', {});
								}
								
								if (!this.validateDateFormat(manuDate)) {
									this.$set(row.$errors, 'manuDate', '日期格式不正确');
								}
								if (!this.validateDateFormat(expyDate)) {
									this.$set(row.$errors, 'expyDate', '日期格式不正确');
								}
								
								this.highlightInvalidDateField(row);
								resolve(false);
								return;
							}
			
							const manuDateObj = new Date(manuDate);
							const expyDateObj = new Date(expyDate);
			
							// 计算日期差
							const daysDiff = this.calculateDateDifference(manuDate, expyDate);
			
							// 验证有效期是否早于生产日期
							if (expyDateObj < manuDateObj) {
								this.$message.warning('有效日期不能早于生产日期，已自动清空！');
								
								// 清空有效日期
								this.$nextTick(() => {
									row.expyDate = '';
									this.clearDateValidationError(row);
									
									// 高亮显示已清空的字段
									this.highlightAndClearDateField(row);
								});
								
								resolve(false);
								return;
							}
			
							// 可以添加额外的验证逻辑，比如有效期不能过长等
							if (daysDiff !== null && daysDiff > 365 * 5) { // 5年
								this.$message.warning('有效日期过长，请确认是否正确');
							}
			
							console.log('日期验证通过:', {
								生产日期: manuDate,
								有效日期: expyDate,
								天数差: daysDiff
							});
			
							resolve(true);
							
						} catch (error) {
							console.error('日期验证失败:', error);
							this.$message.error('日期验证失败，请手动检查');
							resolve(false);
						}
					});
				},
			
				// 新增：清除日期验证错误
				clearDateValidationError(row) {
					if (row && row.$errors) {
						// 清除日期相关的错误
						if (row.$errors.manuDate) {
							this.$set(row.$errors, 'manuDate', null);
						}
						if (row.$errors.expyDate) {
							this.$set(row.$errors, 'expyDate', null);
						}
					}
					
					// 清除视觉上的错误高亮
					this.$nextTick(() => {
						const datePickers = document.querySelectorAll(`[data-row-id="${row?.id}"] .date-picker-error`);
						datePickers.forEach(picker => {
							picker.classList.remove('date-picker-error');
						});
					});
				},
			
				// 新增：高亮无效的日期字段
				highlightInvalidDateField(row) {
					this.$nextTick(() => {
						const datePickers = document.querySelectorAll(`[data-row-id="${row?.id}"] .el-date-editor`);
						datePickers.forEach(picker => {
							picker.classList.add('date-picker-error');
						});
					});
				},
			
				// 新增：高亮并清空日期字段
				highlightAndClearDateField(row) {
					this.$nextTick(() => {
						const expyDatePicker = document.querySelector(`[data-row-id="${row?.id}"] [data-field="expyDate"] .el-date-editor`);
						if (expyDatePicker) {
							expyDatePicker.classList.add('date-picker-error');
							setTimeout(() => {
								expyDatePicker.classList.remove('date-picker-error');
							}, 3000);
						}
					});
				},
			// 修改：处理无效的有效期 - 统一清空逻辑
			async handleInvalidExpiryDate(row, manuDate, invalidExpyDate) {
			    console.log('处理无效的有效期:', { 生产日期: manuDate, 无效有效期: invalidExpyDate });
			    
			    try {
			        // 计算日期差异
			        const daysDiff = this.calculateDateDifference(manuDate, invalidExpyDate);
			        const errorMessage = `有效期不能早于生产日期（相差 ${Math.abs(daysDiff)} 天），已自动清空`;
			        
			        // 关键修改：立即清空有效期字段
			        this.$set(row, 'expyDate', '');
			        
			        // 显示警告提示
			        this.$message.warning(errorMessage);
			        
			        // 设置错误状态
			        if (!row.$errors) {
			            this.$set(row, '$errors', {});
			        }
			        this.$set(row.$errors, 'expyDate', errorMessage);
			        
			        // 添加高亮效果
			        this.highlightAndClearDateField(row);
			        
			        console.log('有效期已自动清空');
			        
			    } catch (error) {
			        console.error('处理无效有效期失败:', error);
			        // 如果自动清空失败，使用原来的错误提示方式
			        this.showDateValidationError('有效期不能早于生产日期，请手动修正', row);
			    }
			},
			
			// 修改：显示日期验证错误 - 统一使用自动清空逻辑
			showDateValidationError(errorMessage, row) {
			    // 设置错误状态
			    if (!row.$errors) {
			        this.$set(row, '$errors', {});
			    }
			    this.$set(row.$errors, 'expyDate', errorMessage);
			    
			    // 显示错误提示
			    this.$message.warning(errorMessage);
			    
			    // 确保有效期字段被清空
			    if (row.expyDate) {
			        this.$set(row, 'expyDate', '');
			    }
			    
			    // 高亮显示有问题的字段
			    this.highlightInvalidDateField(row);
			},
			
			// 生产日期变化处理
			async handleManuDateChange(date, row) {
					console.log('生产日期变化:', date, '当前行:', row);
					
					try {
						// 保存旧的生产日期
						const oldManuDate = row.manuDate;
						
						// 设置新的生产日期
						row.manuDate = date;
						
						// 先清空验证错误
						this.clearDateValidationError(row);
						
						// 验证日期格式
						if (date && !this.validateDateFormat(date)) {
							this.$message.warning('生产日期格式不正确，请检查！');
							this.$set(row.$errors, 'manuDate', '日期格式不正确');
							this.highlightInvalidDateField(row);
							return;
						}
						
						// 如果生产日期发生变化，且存在有效期，立即验证
						if (date && row.expyDate) {
							const isValid = await this.validateExpiryDateAfterManufacture(date, row.expyDate, row);
							
							// 如果验证失败（有效期被清空），不需要额外处理
						}
						
						// 如果生产日期被清空，但有效期存在，清除错误状态
						if (!date && row.expyDate) {
							this.clearDateValidationError(row);
						}
						
						// 如果有药品ID，加载生产厂家和有效期信息
						if (date && row.drugId) {
							const selectedDrug = this.drugOptions.find(drug => drug.id === row.drugId);
							if (selectedDrug) {
								await this.loadManufacturerAndExpiryDate(row.drugId, date, row);
							}
						}
						
						// 重新计算所有金额
						await this.recalculateAllAmounts(row);
						
						// 验证字段
						this.validateField('manuDate', row);
						
					} catch (error) {
						console.error('处理生产日期变化失败:', error);
						this.$message.error('处理生产日期失败');
					}
				},
			
				// 修改：有效日期变化处理
				async handleExpiryDateChange(date, row) {
					console.log('有效日期变化:', date, '当前行:', row);
					
					try {
						// 先清空验证错误
						this.clearDateValidationError(row);
						
						// 如果用户手动清空有效期，直接通过验证
						if (!date) {
							row.expyDate = '';
							this.validateField('expyDate', row);
							return;
						}
						
						// 验证日期格式
						if (!this.validateDateFormat(date)) {
							this.$message.warning('有效日期格式不正确，请检查！');
							this.$set(row.$errors, 'expyDate', '日期格式不正确');
							this.highlightInvalidDateField(row);
							return;
						}
						
						// 设置有效日期
						row.expyDate = date;
						
						// 验证有效期是否晚于生产日期
						if (date && row.manuDate) {
							await this.validateExpiryDateAfterManufacture(row.manuDate, date, row);
						} else if (date && !row.manuDate) {
							// 如果有有效期但没有生产日期，提示用户先设置生产日期
							this.$message.warning('请先设置生产日期');
						}
						
						// 重新计算所有金额
						await this.recalculateAllAmounts(row);
						
						// 验证字段
						this.validateField('expyDate', row);
						
					} catch (error) {
						console.error('处理有效日期变化失败:', error);
						this.$message.error('处理有效日期失败');
					}
				},

			// 新增：包装数量失去焦点处理
			handlePacCntBlur(row) {
				console.log('包装数量失去焦点:', row.pacCnt, '库存类型:', row.purcType);

				// 如果当前库存类型是最小单位，需要重新计算成本单价
				if (row.purcType == '1') {
					this.recalculateCostPriceByPacCnt(row);
				}
			},

			// 新增：根据包装数量重新计算成本单价
			recalculateCostPriceByPacCnt(row) {
				if (!row.baseCostPric || !row.pacCnt) {
					console.warn('缺少基准成本单价或包装数量，无法重新计算');
					return;
				}

				try {
					const baseCostPrice = parseFloat(row.baseCostPric);
					const pacCnt = parseInt(row.pacCnt);

					if (isNaN(baseCostPrice) || isNaN(pacCnt) || pacCnt <= 0) {
						console.warn('基准成本单价或包装数量格式错误');
						return;
					}

					// 最小单位模式：成本单价 = 基准成本单价 / 包装数量
					row.purcPric = (baseCostPrice / pacCnt).toFixed(8);

					// 重新计算零售单价和金额
					this.calculateSalePrice(row);
					this.calculateAmounts(row);

					console.log(`包装数量变化重新计算完成: 基准=${baseCostPrice}, 数量=${pacCnt}, 新成本单价=${row.purcPric}`);
				} catch (error) {
					console.error('包装数量变化计算失败:', error);
				}
			},
			// 获取入库方式文本
			getPutinTypeText(typeId) {
				if (!typeId) return '未知';

				// 从putinOption中查找对应的入库方式名称
				const putinType = this.putinOption.find(item =>
					item.id === typeId || item.value === typeId
				);

				return putinType ? putinType.name : '未知';
			},
			// 新增：表格行类名
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.$errors && Object.keys(row.$errors).some(key => row.$errors[key])) {
					return 'error-row';
				}
				return '';
			},
			// 处理导入采购计划数据
			async handleImportPurchasePlans(planIds) {
				// 设置跳转模式标识
				this.isFromPlanTransfer = true;
				this.globalLoading = true;

				try {
					// 1秒的加载时间，确保页面完全渲染
					await new Promise(resolve => setTimeout(resolve, 1000));

					// 分割ID字符串为数组
					const ids = planIds.split(',').map(id => parseInt(id));

					// 调用接口获取采购计划详情
					const planDetails = [];
					for (const id of ids) {
						const response = await getPlanData({
							id: id
						});
						if (response.code === 200 && response.data) {
							planDetails.push(response.data);
						}
					}

					if (planDetails.length > 0) {
						// 先加载药品选项数据
						await Promise.all([
							this.loadDrugOptions(),
							this.loadputinOptions(),
							this.loadSupplierOptions(),
							this.loadPurchasePlanOptions()
						]);

						// 打开采购入库模态框
						this.currentStorageType = 'purchase';
						this.purchaseDialogVisible = true;

						// 填充采购计划数据到表单
						await this.fillPurchaseFormFromPlans(planDetails);

						// 自动选择对应的采购计划单
						await this.autoSelectPurchasePlan(planDetails);

						this.$message.success(`成功导入 ${planDetails.length} 个采购计划数据`);
					} else {
						this.$message.warning('未获取到有效的采购计划数据');
						// 即使没有数据也打开采购入库对话框
						this.openPurchaseDialogWithDefault();
					}
				} catch (error) {
					////console.error('导入采购计划数据失败:', error);
					this.$message.error('导入采购计划数据失败');
					// 出错时也打开采购入库对话框
					this.openPurchaseDialogWithDefault();
				} finally {
					this.globalLoading = false;
				}
			},
			// 新增：自动选择采购计划单
			async autoSelectPurchasePlan(planDetails) {
				if (!planDetails || planDetails.length === 0) return;

				try {
					// 获取第一个采购计划的ID
					const firstPlanId = planDetails[0].id;

					// 确保采购计划选项已加载
					if (this.purchasePlanOptions.length === 0) {
						await this.loadPurchasePlanOptions();
					}

					// 查找对应的采购计划选项
					const planOption = this.purchasePlanOptions.find(plan => plan.id === firstPlanId);

					if (planOption) {
						// 自动选择采购计划单
						this.purchaseForm.docNum = firstPlanId;

						this.$nextTick(() => {
							// 触发采购计划选择变化事件
							this.handlePlanCodeChange(firstPlanId);
						});

						this.$message.success(`已自动选择采购计划单: ${planOption.docNum}`);
					}
				} catch (error) {
					////console.error('自动选择采购计划单失败:', error);
				}
			},

			// 新增：打开默认采购入库对话框
			async openPurchaseDialogWithDefault() {
				this.currentStorageType = 'purchase';
				this.purchaseDialogVisible = true;

				// 加载必要的数据
				await Promise.all([
					this.loadDrugOptions(),
					this.loadputinOptions(),
					this.loadSupplierOptions(),
					this.loadPurchasePlanOptions()
				]);

				// 设置默认值
				this.purchaseForm = {
					warehouse: this.$route.query.warehouse || 1,
					busDate: new Date().toISOString().split('T')[0],
					supplierId: '',
					supplierName: '',
					purcInvoCodg: '',
					supplyCode: '',
					putinTypeId: 1,
					remark: '由采购计划生成',
					totalAmt: '0.00',
					docNum: ''
				};
			},
			// 从采购计划数据填充采购表单
			// 优化 fillPurchaseFormFromPlans 方法，添加采购计划选择逻辑
			async fillPurchaseFormFromPlans(planDetails) {
				try {
					// 清空现有的药品列表
					this.goodsList = [];

					// 使用第一个采购计划的信息填充表单
					const firstPlan = planDetails[0];
					if (firstPlan) {
						this.purchaseForm = {
							warehouse: this.$route.query.warehouse || 1,
							busDate: new Date().toISOString().split('T')[0],
							supplierId: firstPlan.supplyCandidateId || '',
							supplierName: firstPlan.supplierName || '',
							purcInvoCodg: '',
							supplyCode: '',
							putinTypeId: 1,
							remark: `由采购计划 ${planDetails.map(p => p.docNum).join(', ')} 生成`,
							totalAmt: '0.00',
							planData: firstPlan,
							docNum: firstPlan.id // 设置采购计划ID
						};
					}

					// 合并所有采购计划的药品明细
					const allGoods = [];
					for (const plan of planDetails) {
						if (plan.list && Array.isArray(plan.list)) {
							for (const item of plan.list) {
								// 检查是否已存在相同药品
								const existingIndex = allGoods.findIndex(g =>
									g.drugId === item.drugId && g.prodentpNameId === item.prodentpNameId
								);

								if (existingIndex >= 0) {
									// 合并数量
									allGoods[existingIndex].purcCnt += item.purcCnt || 0;
								} else {
									// 添加新药品
									allGoods.push({
										id: Date.now() + Math.random(),
										drugId: item.drugId,
										name: item.name,
										drugSpecifications: item.drugSpecifications,
										pacSpec: item.pacSpec,
										purcCnt: item.purcCnt || 1,
										purcPric: item.purcPric || 0,
										salePric: item.salePric || 0,
										purcAmt: '0.00',
										saleAmt: '0.00',
										manuLotnum: item.manuLotnum || '',
										manuDate: item.manuDate || '',
										expyDate: item.expyDate || '',
										prodentpNameId: item.prodentpNameId || '',
										manufacturerOptions: [],
										purcType: item.purcType?.toString() || '2',
										markUpId: item.markUpId?.toString() || '1',
										markUpRate: item.markUpRate || 0,
										markUpPric: item.markUpPric || 0,
										dosUnt: item.dosUnt || '---',
										pacUnt: item.pacUnt || '---',
										pacCnt: item.pacCnt || 1,
										putinTypeId: 1,
										$errors: {}
									});
								}
							}
						}
					}

					// 加载药品详细信息和生产厂家
					for (const goods of allGoods) {
						if (goods.drugId) {
							await this.loadDrugDetails(goods.drugId, goods);
						}

						// 添加到商品列表
						this.goodsList.push(goods);

						// 计算金额
						this.calculateAmounts(goods);
					}

					// 更新合计金额
					this.calculateTotalCost();
					this.calculateTotalSale();

				} catch (error) {
					////console.error('填充采购表单失败:', error);
					this.$message.error('填充采购表单失败');
				}
			},
			// 格式化规格文本，过长时显示省略号
			formatSpecText(text) {
				if (!text) return '--';

				// 采购计划列表表格：最大显示8个字符
				if (text.length > 8) {
					return text.substring(0, 8) + '...';
				}

				// 抽屉表格：最大显示10个字符
				if (text.length > 10) {
					return text.substring(0, 10) + '...';
				}

				return text;
			},
			// 新增：字段验证
			validateField(field, row) {
					const rule = this.validationRules[field];
					if (rule && rule.required) {
						// 对于日期字段的特殊处理
						if (field === 'manuDate' || field === 'expyDate') {
							if (!row[field] || (typeof row[field] === 'string' && row[field].trim() === '')) {
								if (!row.$errors) {
									this.$set(row, '$errors', {});
								}
								this.$set(row.$errors, field, rule.message);
							} else {
								// 验证日期格式
								if (!this.validateDateFormat(row[field])) {
									if (!row.$errors) {
										this.$set(row, '$errors', {});
									}
									this.$set(row.$errors, field, '日期格式不正确');
								} else {
									// 清除验证错误
									this.clearDateValidationError(row);
								}
							}
						} else if (field === 'purcCnt') {
							// 对于purcCnt字段，只要不为空且大于0即可
							const value = row[field];
							const isValid = value !== null &&
								value !== undefined &&
								value !== '' &&
								Number(value) > 0;
							
							if (!isValid) {
								if (!row.$errors) {
									this.$set(row, '$errors', {});
								}
								this.$set(row.$errors, field, rule.message);
							} else {
								if (row.$errors && row.$errors[field]) {
									this.$set(row.$errors, field, null);
								}
							}
						} else {
							// 其他字段保持原有验证逻辑
							if (!row[field] || (typeof row[field] === 'string' && row[field].trim() === '')) {
								if (!row.$errors) {
									this.$set(row, '$errors', {});
								}
								this.$set(row.$errors, field, rule.message);
							} else {
								if (row.$errors && row.$errors[field]) {
									this.$set(row.$errors, field, null);
								}
							}
						}
					}
					this.checkAllRowsCompletion();
				},

			// 修改：获取加成方式标签
			getMarkUpLabel(row) {
				if (!row || !row.markUpId) return '加成率';

				const markUpId = row.markUpId.toString();
				const labelMap = {
					'1': '加成率',
					'2': '加成金额',
					'3': '加成率（%）',
					'4': '不加成'
				};
				return labelMap[markUpId] || '加成率';
			},

			// 修改：获取加成值字段
			getMarkUpValueField(row) {
				if (!row) return 0;

				const markUpId = row.markUpId ? row.markUpId.toString() : '1';
				switch (markUpId) {
					case '1': // 比例加成
					case '3': // 手工比例
						return row.markUpRate || 0;
					case '2': // 固定加成
						return row.markUpPric || 0;
					case '4': // 不加成
						return 0;
					default:
						return 0;
				}
			},

			// 修改：获取加成值精度
			getMarkUpPrecision(markUpId) {
				if (!markUpId) return 4;

				const id = markUpId.toString();
				const precisionMap = {
					'1': 4, // 比例加成：4位小数
					'2': 4, // 固定加成：4位小数
					'3': 2, // 手工比例：2位小数（百分比）
					'4': 4 // 不加成：4位小数
				};
				return precisionMap[id] || 4;
			},

			// 新增：设置加成值字段
			setMarkUpValueField(row, value) {
				if (!row) return;

				switch (row.markUpId) {
					case 1: // 比例加成
					case 3: // 手工比例
						row.markUpRate = value;
						break;
					case 2: // 固定加成
						row.markUpPric = value;
						break;
					case 4: // 不加成
						row.markUpRate = 0;
						row.markUpPric = 0;
						break;
				}
			},


			// 检查行完成状态
			checkRowCompletion(row) {
				// 检查所有必填字段
				const requiredFields = ['drugId', 'purcCnt', 'manuLotnum', 'manuDate', 'expyDate', 'prodentpNameId'];
				const isComplete = requiredFields.every(field => {
					if (field === 'purcCnt') {
						// 对于purcCnt字段，只要不为空且大于0即可
						return row[field] !== null && row[field] !== undefined && row[field] !== '' && Number(row[
							field]) > 0;
					}
					return row[field] && (typeof row[field] !== 'string' || row[field].trim() !== '');
				});

				// 清除错误状态
				if (isComplete && row.$errors) {
					requiredFields.forEach(field => {
						if (row.$errors[field]) {
							this.$set(row.$errors, field, null);
						}
					});
				}

				this.checkAllRowsCompletion();
				return isComplete;
			},

			// 获取药品信息提示内容
			getDrugInfoTooltip(drugList) {
				if (!drugList || drugList.length === 0) return '无药品信息';

				return drugList.map(item => {
					const name = item.name || '未知药品';
					const quantity = item.purcCnt || item.purCnt || 0;
					const unit = item.purcType === '1' ? (item.dosUnt || '') : (item.pacUnt || '');
					return `${name} × ${quantity}${unit}`;
				}).join('\n');
			},

			// 获取第一个药品名称
			getFirstDrugName(drugList) {
				if (!drugList || drugList.length === 0) return '/';
				return drugList[0].name || '未知药品';
			},

			// 检查所有行完成状态
			checkAllRowsCompletion() {
				if (this.goodsList.length === 0) {
					return false;
				}

				// 检查供货单位是否已选择
				const hasSupplier = !!this.purchaseForm.supplierId;

				// 检查所有行是否都完成了必填字段且没有错误
				const allComplete = this.goodsList.every(row => {
					const requiredFields = ['drugId', 'purcCnt', 'manuLotnum', 'manuDate', 'expyDate',
						'prodentpNameId'
					];

					// 对每个必填字段进行检查
					const fieldsComplete = requiredFields.every(field => {
						// 对于purcCnt字段，只要不为空且大于0即可
						if (field === 'purcCnt') {
							const value = row[field];
							return value !== null &&
								value !== undefined &&
								value !== '' &&
								Number(value) > 0;
						}

						// 对于其他字段，检查是否存在且不为空字符串
						return row[field] && (typeof row[field] !== 'string' || row[field].trim() !== '');
					});

					// 检查是否有错误
					const noErrors = !row.$errors || !Object.keys(row.$errors).some(key => row.$errors[key]);

					return fieldsComplete && noErrors;
				});

				return allComplete && hasSupplier;
			},

			// 确保在打开模态框前加载完成
			async loadDrugOptions() {
				let pamr = {
				  name: this.searchValue,
				  pageNum: this.pageNum,
				  pageSize : this.pageSize
				}
				try {
					const response = await getWareZY(pamr);
					if (response.code === 200) {
						// 处理返回的数据，确保单位字段存在
						this.drugOptions = (response.data.content || response.data.list || []).map(drug => {
							return {
								...drug,
								// 确保单位字段有值
								dosUnt: drug.dosUnt || '最小单位',
								pacUnt: drug.pacUnt || '包装单位',
								pacCnt: drug.pacCnt || 1,
								// 确保markUpId是字符串类型
								markUpId: drug.markUpId ? drug.markUpId.toString() : '1'
							};
						});
					} else {
						this.$message.error(response.message || '获取药品列表失败');
						this.drugOptions = [];
					}
				} catch (error) {
					console.error('加载药品选项失败:', error);
					this.$message.error('加载药品选项失败');
					this.drugOptions = [];
				}
			},
			// 处理快捷调拨确认
			async handleQuickTransferConfirm() {
				if (!this.currentRow) {
					this.$message.error('未找到要调拨的数据');
					return;
				}

				try {
					this.$confirm('确定要对该入库单进行快捷调拨吗？', '确认调拨', {
						type: 'warning',
						confirmButtonText: '确认无误，快捷调拨',
						cancelButtonText: '取消'
					}).then(async () => {
						// 显示加载中
						this.transferLoading = true;

						// 调用快捷调拨接口
						const response = await ZYfastTransfer({
							id: this.currentRow.id
						});

						if (response.code === 200) {
							this.$message.success('快捷调拨成功');

							// 关闭详情对话框
							this.detailDialogVisible = false;

							// 数据驱动更新采购入库列表
							this.loadData();

							// 清除当前行记录
							this.currentRow = null;
							this.detailMode = 'view';
						} else {
							this.$message.error(response.message || '快捷调拨失败');
						}
					}).catch(() => {
						this.$message.info('已取消快捷调拨操作');
					});

				} catch (error) {
					console.error('快捷调拨操作失败:', error);
					this.$message.error('快捷调拨失败，请检查网络连接');
				} finally {
					this.transferLoading = false;
				}
			},
			getRejectButtonVisible(state) {
				// 状态为0(草稿)、2(提交)、5(过单)时不显示拒绝按钮
				// return );
			},
			// 修改：处理采购退库按钮点击 - 添加选中的数据传递
			handlePurchaseReturn() {
				// 检查是否已选择药库
				if (!this.queryForm.warehouse) {
					this.$message.warning('请先选择药库类型');
					return;
				}

				// 检查是否有选中的数据
				if (this.selectedRows.length === 0) {
					this.$router.push({
						path: '/PSI/XyRet',
					});
				}

				// 添加zoom-out动画效果
				this.$el.style.transition = 'all 0.3s ease';
				this.$el.style.transform = 'scale(0.95)';
				this.$el.style.opacity = '0.8';

				// 准备选中的数据ID
				const selectedIds = this.selectedRows.map(row => row.id);

				// 延迟执行路由跳转，让动画效果可见
				setTimeout(() => {
					if (this.queryForm.warehouse === 2) {
						// 中药库 - 跳转到中药采购退库页面
						this.$router.push({
							path: '/PSI/ZyRet',
							query: {
								warehouse: this.queryForm.warehouse,
								warehouseName: this.getWarehouseName(this.queryForm.warehouse),
								hasSelectedData: true, // 标记有选中数据
								selectedIds: JSON.stringify(selectedIds) // 传递选中ID数组
							}
						});
					} 
				}, 300);
			},

			// 新增：获取选中的行数据用于退库
			getSelectedRowsForReturn() {
				if (!this.selectedRows || this.selectedRows.length === 0) {
					return null;
				}

				// 只选择状态为5（已过单）的行进行退库
				const validRows = this.selectedRows.filter(row => row.state === 5);
				if (validRows.length === 0) {
					this.$message.warning('请选择已过单的入库单进行退库操作');
					return null;
				}

				// 直接返回选中行的外层ID和其他必要信息
				return validRows.map(row => ({
					id: row.id, // 关键修改：直接使用行的外层ID
					docNum: row.docNum,
					supplierName: row.supplierName,
					costAmt: row.costAmt,
					saleAmt: row.saleAmt,
					createTime: row.createTime,
					state: row.state
					// 注意：不在这里获取药品明细，在第二个文件中通过ID调用接口获取
				}));
			},

			// 从采购计划跳转过来打开采购入库单模态框
			openPurchaseOrderFromPlan(planInfo) {
				// 设置来源标识
				this.fromPurchasePlan = true;

				// 打开采购入库单模态框
				this.handleAddPurchaseOrder();

				// 可以在这里预填充采购计划的数据
				if (planInfo.selectedPlanIds) {
					this.selectedPlanIds = planInfo.selectedPlanIds;
					// 加载采购计划数据到表单
					this.loadPlanDataToForm(planInfo.selectedPlanIds);
				}
			},

			// 修改采购入库单保存成功后的处理
			handlePurchaseOrderSuccess() {
				if (this.fromPurchasePlan) {
					// 从采购计划跳转过来的，保持模态框打开状态，停留在采购入库界面
					this.$message.success('采购入库单新增成功');
					// 可以在这里添加其他逻辑，比如清空表单等
				} else {
					// 正常从采购入库页面打开的，关闭模态框
					this.purchaseOrderDialogVisible = false;
					this.$message.success('采购入库单新增成功');
					this.loadData(); // 重新加载数据
				}
			},

			// 修改采购入库单取消或关闭的处理
			handlePurchaseOrderCancel() {
				// 无论从哪来，取消时都关闭模态框，停留在采购入库界面
				this.purchaseOrderDialogVisible = false;
				this.fromPurchasePlan = false; // 重置标识
			},
			// 新增：获取药库名称的辅助方法
			getWarehouseName(warehouseId) {
				const warehouseMap = {
					2: '中药库',
					4: '中药房'
				};
				return warehouseMap[warehouseId] || '未知药库';
			},


			// 修改：处理返回按钮点击（从退库页面返回）
			handleReturnBack() {
				// 使用缩放动画返回主页面
				this.isReturnMode = false;
			},

			// 新增：处理单个退库操作
			handleSingleReturn(row) {
				if (row.state !== 5) {
					this.$message.warning('只有已过单的入库单才能进行退库操作');
					return;
				}

				this.returnForm = {
					id: row.id,
					docNum: row.docNum,
					drugInfo: this.getDrugInfoTooltip(row.list),
					currentStock: row.purcCnt || 0,
					returnQuantity: 1,
					returnReason: ''
				};

				this.returnDialogVisible = true;
			},

			// 新增：处理批量退库
			handleBatchReturn() {
				if (this.selectedRows.length === 0) {
					this.$message.warning('请选择要退库的入库单');
					return;
				}

				// 检查所选行是否都是已过单状态
				const invalidRows = this.selectedRows.filter(row => row.state !== 5);
				if (invalidRows.length > 0) {
					this.$message.warning('只能选择已过单的入库单进行退库操作');
					return;
				}

				this.$confirm(`确定要批量退库选中的 ${this.selectedRows.length} 条入库单吗？`, '提示', {
					type: 'warning'
				}).then(() => {
					this.batchReturnItems();
				});
			},

			// 新增：批量退库操作
			async batchReturnItems() {
				try {
					this.returnLoading = true;

					// 准备批量退库数据
					const returnData = this.selectedRows.map(row => ({
						id: row.id,
						returnQuantity: row.purcCnt || 0, // 默认退全部数量
						returnReason: '批量退库操作'
					}));

					// 调用批量退库接口
					const response = await batchReturnStorage(returnData);

					if (response.code === 200) {
						this.$message.success(`成功退库 ${this.selectedRows.length} 条入库单`);
						this.selectedRows = [];
						this.loadData();
					} else {
						this.$message.error(response.message || '批量退库失败');
					}
				} catch (error) {
					////console.error('批量退库失败:', error);
					this.$message.error('批量退库失败');
				} finally {
					this.returnLoading = false;
				}
			},

			// 新增：确认退库操作
			async handleConfirmReturn() {
				try {
					this.returnLoading = true;

					// 调用退库接口
					const response = await returnStorage({
						id: this.returnForm.id,
						returnQuantity: this.returnForm.returnQuantity,
						returnReason: this.returnForm.returnReason
					});

					if (response.code === 200) {
						this.$message.success('退库成功');
						this.returnDialogVisible = false;
						this.loadData();
					} else {
						this.$message.error(response.message || '退库失败');
					}
				} catch (error) {
					////console.error('退库操作失败:', error);
					this.$message.error('退库失败');
				} finally {
					this.returnLoading = false;
				}
			},
			// 加载供货单位选项
			async loadSupplierOptions() {
				try {
					const response = await selectDropDownList();
					if (response.code === 200) {
						this.gysOption = response.data.content || response.data.list || [];
					} else {
						this.$message.error(response.message || '获取供货单位列表失败');
						this.gysOption = [];
					}
				} catch (error) {
					////console.error('加载供货单位选项失败:', error);
					this.$message.error('加载供货单位选项失败');
					this.gysOption = [];
				}
			},
			// 加载入库方式选项
			async loadputinOptions() {
				try {
					const response = await getPutin();
					if (response.code === 200) {
						this.putinOption = response.data || response.data.content || [];
					} else {
						this.$message.error(response.message || '获取入库方式列表失败');
						this.putinOption = [];
					}
				} catch (error) {
					////console.error('加载入库方式选项失败:', error);
					this.$message.error('加载入库方式选项失败');
					this.putinOption = [];
				}
			},
			// 更新提交按钮状态
			updateSubmitButtonState() {
				this.$nextTick(() => {
					// 强制重新计算计算属性
					this.$forceUpdate();
				});
			},
			// 新增：根据成本单价计算零售单价（调用接口）
			async calculateSalePriceWithMarkUp(row) {
				try {
					// 如果成本单价为空或为0，不进行计算
					if (!row.purcPric || Number(row.purcPric) <= 0) {
						row.salePric = '0.00000000';
						return;
					}

					// 调用接口获取加成率和销售单价
					const response = await docMarkById({
						costPric: Number(row.purcPric),
						drugType: 9 // 固定为9，表示中药
					});

					if (response.code === 200 && response.data) {
						const markUpData = response.data;

						// 更新加成率和销售单价
						row.markUpRate = markUpData.markUpRate || 0;
						row.salePric = markUpData.salePric ? Number(markUpData.salePric).toFixed(8) : '0.00000000';

						// 重新计算金额
						this.calculateAmounts(row);

						this.$message.success('已自动计算零售单价');
					} else {
						// 如果接口调用失败，使用默认计算方法
						this.calculateSalePrice(row);
						this.$message.warning('使用默认加成方式计算零售单价');
					}
				} catch (error) {
					////console.error('计算零售单价失败:', error);
					// 出错时使用默认计算方法
					this.calculateSalePrice(row);
					this.$message.error('计算零售单价失败，使用默认方式');
				}
			},
			// 处理字段变化时调用此方法
			handleFieldChange(field, row) {
				if (field === 'purcCnt') {
					this.validatePurcCntField(row);
				}

				this.checkAllRowsCompletion();
			},
			// 成本单价验证方法
			validateCostPrice(value) {
				if (value === null || value === undefined || value === '') return false;

				// 转换为数字
				const num = Number(value);
				if (isNaN(num) || num < 0) return false;

				// 检查小数点后位数（最多8位）
				const strValue = value.toString();
				const decimalIndex = strValue.indexOf('.');
				if (decimalIndex !== -1 && strValue.length - decimalIndex - 1 > 8) {
					return false;
				}

				return true;
			},

			// 加成金额验证方法
			validateMarkUpPric(value) {
				if (value === null || value === undefined || value === '') return false;

				const num = Number(value);
				if (isNaN(num) || num < 0) return false;

				// 检查小数点后位数（最多4位）
				const strValue = value.toString();
				const decimalIndex = strValue.indexOf('.');
				if (decimalIndex !== -1 && strValue.length - decimalIndex - 1 > 8) {
					return false;
				}

				return true;
			},
			// 修改：获取当前行的加成标签（用于列头）
			getCurrentMarkUpLabel() {
				if (this.goodsList.length > 0 && this.goodsList[0].markUpId) {
					const markUpId = this.goodsList[0].markUpId.toString();
					const labelMap = {
						'1': '加成率',
						'2': '加成金额',
						'3': '加成率（%）',
						'4': '不加成'
					};
					return labelMap[markUpId] || '加成值';
				}
				return '加成值';
			},

			// 修改：获取加成显示值
			getMarkUpDisplayValue(row) {
				if (!row || !row.markUpId) return '--';

				const markUpId = row.markUpId.toString();
				switch (markUpId) {
					case '1': // 比例加成
						return row.markUpRate ? `${(row.markUpRate)}` : '--';
					case '2': // 固定加成
						return row.markUpPric ? `¥${Number(row.markUpPric).toFixed(8)}` : '--';
					case '3': // 手工比例
						return row.markUpRate ? `${Number(row.markUpRate).toFixed(8)}%` : '--';
					case '4': // 不加成
						return '--';
					default:
						return '--';
				}
			},
			// 修改：计算零售单价方法
			calculateSalePrice(row) {
			  if (!row.purcPric || !row.markUpId) {
			    row.salePric = '0.00000000';
			    return;
			  }
			
			  const costPrice = Number(row.purcPric);
			  const markUpId = row.markUpId.toString();
			
			  switch (markUpId) {
			    case '1': // 比例加成：零售单价 = 成本单价 × 加成率
			      const rate1 = Number(row.markUpRate || 0);
			      row.salePric = (costPrice * rate1).toFixed(8);
			      break;
			
			    case '2': // 固定加成：零售单价 = 成本单价 + 加成金额
			      const markUpPric = Number(row.markUpPric || 0);
			      row.salePric = (costPrice + markUpPric).toFixed(8);
			      break;
			
			    case '3': // 手工比例加成：零售单价 = 成本单价 × (1 + 加成率/100)
			      // 关键修改：接口返回的加成率是百分比数值，需要除以100
			      const manualRate = Number(row.markUpRate || 0);
			      const multiplier = 1 + (manualRate / 100);
			      row.salePric = (costPrice * multiplier).toFixed(8);
			      console.log(`手工比例加成计算: ${costPrice} × (1 + ${manualRate} ÷ 100) = ${costPrice} × ${multiplier} = ${row.salePric}`);
			      break;
			
			    case '4': // 不加成：零售单价 = 成本单价
			      row.salePric = costPrice.toFixed(8);
			      break;
			
			    default:
			      row.salePric = costPrice.toFixed(8);
			  }
			
			  // 确保零售单价不为负数
			  if (Number(row.salePric) < 0) {
			    row.salePric = '0.00000000';
			  }
			},
			
			// 新增：加载生产厂家和有效期信息
			async loadManufacturerAndExpiryDate(drugId, manuDate, row) {
				try {
					const response = await getProdentZY({
						drugId: drugId
					});
					if (response.code === 200) {
						const manufacturers = response.data || response.data.list || [];
						row.manufacturerOptions = manufacturers;

						// 从接口响应中获取有效期天数
						if (manufacturers.length > 0) {
							const firstManufacturer = manufacturers[0];

							// 检查是否有 expyDate 字段（有效期天数）
							if (firstManufacturer.expyDate) {
								// 计算有效日期：生产日期 + 有效期天数
								const manuDateObj = new Date(manuDate);
								const expyDateObj = new Date(manuDateObj.getTime() + (firstManufacturer.expyDate * 24 *
									60 * 60 * 1000));

								// 格式化为 yyyy-MM-dd
								const year = expyDateObj.getFullYear();
								const month = String(expyDateObj.getMonth() + 1).padStart(2, '0');
								const day = String(expyDateObj.getDate()).padStart(2, '0');

								row.expyDate = `${year}-${month}-${day}`;

								this.$message.success(`已根据有效期${firstManufacturer.expyDate}天自动计算有效日期`);
							} else {
								// 如果没有有效期信息，提示用户手动输入
								this.$message.info('未找到有效期信息，请手动输入有效日期');
							}

							// 如果只有一个厂家，自动选择
							if (manufacturers.length === 1) {
								row.prodentpNameId = firstManufacturer.id;
								this.$message.success(`已自动选择生产厂家: ${firstManufacturer.prodentpName}`);
							}
						} else {
							this.$message.warning('未找到相关生产厂家信息');
						}
					} else {
						this.$message.error(response.message || '获取生产厂家信息失败');
					}
				} catch (error) {
					////console.error('加载生产厂家和有效期信息失败:', error);
					this.$message.error('加载生产厂家和有效期信息失败');
				}
			},

			// 修改：加载生产厂家选项
			async loadManufacturerOptions(drugId, row) {
				try {
					row.manufacturerLoading = true;

					const response = await getProdentZY({
						drugId: drugId
					});

					if (response.code === 200) {
						const manufacturers = response.data || response.data.list || [];
						row.manufacturerOptions = manufacturers;

						// 如果当前行已经有选中的生产厂家ID，确保该厂家在选项中
						if (row.prodentpNameId) {
							const selectedManufacturer = manufacturers.find(prod => prod.id === row.prodentpNameId);
							//console.warn('选中的生产厂家不在选项中:', row.prodentpNameId);
							//console.warn('selectedManufacturerselectedManufacturerselectedManufacturer:', selectedManufacturer);
							if (!selectedManufacturer) {
								// 如果选中的厂家不在选项中，可能需要重新获取或提示用户
								////console.warn('选中的生产厂家不在选项中:', row.prodentpNameId);
								// 可以尝试从其他途径获取厂家信息
								await this.tryFindManufacturerInfo(row.prodentpNameId, row);
							}
						}
					} else {
						this.$message.error(response.message || '获取生产厂家失败');
						row.manufacturerOptions = [];
					}
				} catch (error) {
					////console.error('加载生产厂家选项失败:', error);
					this.$message.error('加载生产厂家选项失败');
					row.manufacturerOptions = [];
				} finally {
					row.manufacturerLoading = false;
				}
			},

			// 修改：尝试从其他途径获取厂家信息
			async tryFindManufacturerInfo(manufacturerId, row) {
				manufacturerId = parseInt(manufacturerId);
				//console.log(manufacturerId,'manufacturerIdmanufacturerId');
				try {
					// 首先尝试从全局的生产厂家列表中查找
					const globalManufacturers = this.prodentOption || [];
					let foundManufacturer = globalManufacturers.find(prod => prod.id === manufacturerId);
					// 如果全局列表中没有，尝试调用接口获取厂家详情
					if (!foundManufacturer) {
						try {
							// 这里需要根据实际情况调用获取厂家详情的接口
							const manufacturerResponse = await getManufacturerById({
								id: manufacturerId
							});
							if (manufacturerResponse.code === 200) {
								foundManufacturer = manufacturerResponse.data;
								//console.log(foundManufacturer,'jidaskdjaoisfoundManufacturerfoundManufacturer');
							}
						} catch (apiError) {
							//console.warn('调用厂家详情接口失败:', apiError);
						}
					}
				} catch (error) {
					//console.error('查找生产厂家信息失败:', error);
				}
			},

			// 新增：生产厂家选择变化处理
			handleManufacturerChange(manufacturerId, row) {
				// 确保选中的值是数字类型
				const selectedId = this.safeParseInt(manufacturerId);
				row.prodentpNameId = selectedId;

				const selectedManufacturer = row.manufacturerOptions.find(prod => prod.id === selectedId);
				if (selectedManufacturer) {
					//console.log('选中生产厂家:', selectedManufacturer.prodentpName);
				}

				this.validateField('prodentpNameId', row);
			},

			// 修改：处理编辑按钮点击
			async handleEdit(row) {
				try {
					// 设置编辑模式
					this.isEditMode = true;
					this.currentEditId = row.id;

					// 打开采购入库模态框
					this.purchaseDialogVisible = true;

					// 加载选项数据
					await Promise.all([
						this.loadDrugOptions(),
						this.loadputinOptions(),
						this.loadSupplierOptions(),
						this.loadPurchasePlanOptions()
					]);

					// 加载编辑数据 - 这里也会调用 dugDocgetZYFDrugDetails 接口
					await this.loadEditData(row.id);

					this.$message.success('已加载编辑数据');
				} catch (error) {
					console.error('打开编辑模式失败:', error);
					this.$message.error('加载编辑数据失败');
					this.isEditMode = false;
					this.currentEditId = null;
				}
			},

			handleAddGoods() {
				const newRow = {
					id: Date.now(),
					drugId: '',
					name: '',
					drugSpecifications: '',
					pacSpec: '',
					purcCnt: 1,
					purcPric: 0,
					salePric: 0,
					purcAmt: '0.00',
					saleAmt: '0.00',
					manuLotnum: '',
					manuDate: '',
					expyDate: '',
					prodentpNameId: '',
					manufacturerOptions: [],
					drugLoading: false,
					priceLoading: false,
					purcType: '2', // 默认库存类型为2（包装单位）
					markUpId: '',
					markUpRate: 0,
					markUpPric: 0,
					// 关键修改：设置默认单位
					dosUnt: '最小单位', // 默认最小单位
					pacUnt: '包装单位', // 默认包装单位
					pacCnt: 1,
					unitDisplay: '包装单位', // 初始显示包装单位
					putinTypeId: 1,
					$errors: {}
				};

				this.goodsList.push(newRow);
			},

			// 新增：处理输入框实时变化
			handleInputChange(field, row) {
				// 立即验证字段
				this.validateField(field, row);
				// 立即检查所有行完成状态
				this.checkAllRowsCompletion();
			},

			// 新增：验证入库数量字段
			validatePurcCntField(row) {
				const value = row.purcCnt;
				const isValid = value !== null &&
					value !== undefined &&
					value !== '' &&
					!isNaN(Number(value)) &&
					Number(value) > 0;

				if (!isValid) {
					if (!row.$errors) {
						this.$set(row, '$errors', {});
					}
					this.$set(row.$errors, 'purcCnt', '入库数量必须大于0');
				} else {
					if (row.$errors && row.$errors.purcCnt) {
						this.$set(row.$errors, 'purcCnt', null);
					}
				}

				return isValid;
			},
			// 新增方法：处理供货单位变化
			handleSupplierChange(value) {
				const selectedSupplier = this.gysOption.find(item => item.id === value);
				if (selectedSupplier) {
					this.purchaseForm.supplierName = selectedSupplier.label;
				}
			},

			// 商品金额变化处理
			handleGoodsAmountChange(row) {
				this.calculateAmounts(row);
				this.validateField('purcCnt', row);
			},

			// 新增：库存类型变化处理
			async handlePurcTypeChange(newType, row) {
				console.log('库存类型切换处理开始:', {
					药品: row.name,
					旧类型: row.purcType,
					新类型: newType,
					当前成本单价: row.purcPric
				});

				try {
					this.isCalculating = true;

					// 如果类型没有变化，直接返回
					if (row.purcType === newType) {
						console.log('库存类型未变化，跳过处理');
						return;
					}

					const oldType = row.purcType;

					// 关键修改：确保基准价格存在
					await this.ensureBasePricesExist(row);

					// 根据新类型切换显示价格
					if (newType === '1') {
						// 切换到最小单位：显示最小基准价格
						row.purcPric = row.minPurcPric || '0.00000000';
						row.salePric = row.minSalePric || '0.00000000';
						console.log('切换到最小单位模式:', {
							最小成本单价: row.purcPric,
							最小零售单价: row.salePric
						});
					} else {
						// 切换到包装单位：显示最大基准价格
						row.purcPric = row.maxPurcPric || '0.00000000';
						row.salePric = row.maxSalePric || '0.00000000';
						console.log('切换到包装单位模式:', {
							最大成本单价: row.purcPric,
							最大零售单价: row.salePric
						});
					}

					// 更新库存类型
					row.purcType = newType;

					// 重新计算金额（数量不变，单价变了）
					this.calculateAmounts(row);

					// 更新单位显示
					this.updateUnitDisplay(row);

					console.log('库存类型切换完成:', {
						药品: row.name,
						新类型: newType,
						显示成本单价: row.purcPric,
						显示零售单价: row.salePric,
						最小基准成本: row.minPurcPric,
						最大基准成本: row.maxPurcPric
					});

				} catch (error) {
					console.error('库存类型切换失败:', error);
					this.$message.error('切换失败，请检查数据');
				} finally {
					this.isCalculating = false;
				}
			},

			//  加成金额变化处理（仅对固定加成方式有效）
			handleMarkUpValueChange(row) {
				// 只对固定加成方式（markUpId=2）进行处理
				if (row.markUpId !== '2') return;

				// 验证加成金额格式
				if (!this.validateMarkUpPric(row.markUpPric)) {
					this.$message.warning('加成金额格式不正确，必须是正数且小数点后最多4位');
					row.markUpPric = 0;
					return;
				}

				// 重新计算零售单价
				this.calculateSalePrice(row);

				// 重新计算金额
				this.calculateAmounts(row);

				// 更新合计金额
				this.calculateTotalCost();
				this.calculateTotalSale();
			},

			// 计算价格（包含库存类型和加成方式）
			// 新增：计算价格（包含库存类型和单位更新）
			calculatePrices(row) {
				if (!row.drugId || !row.purcPric) return;

				const selectedDrug = this.drugOptions.find(drug => drug.id === row.drugId);
				if (!selectedDrug) return;

				// 计算成本单价（根据库存类型）
				if (row.purcType === '1') {
					// 最小单位：成本单价 = 原始成本单价 / 包装数量
					row.minPurcPric = (row.purcPric / selectedDrug.pacCnt).toFixed(8);
					row.maxPurcPric = row.purcPric;

					// 更新单位显示
					row.unitDisplay = row.dosUnt || selectedDrug.pacUnt || '--';
				} else {
					// 包装单位：成本单价 = 原始成本单价
					row.minPurcPric = (row.purcPric / selectedDrug.pacCnt).toFixed(8);
					row.maxPurcPric = row.purcPric;

					// 更新单位显示
					row.unitDisplay = row.pacUnt || selectedDrug.dosUnt || '--';
				}

				// 计算零售单价（根据加成方式）
				this.calculateSalePrice(row);

				// 计算金额
				this.calculateAmounts(row);
			},


			// 修改：删除药品方法
			handleRemoveGoods(index) {
				this.goodsList.splice(index, 1);
				this.calculateTotalCost();
				this.checkAllRowsCompletion();
			},

			// 采购表单提交
			async handlePurchaseSubmit() {
				try {
					// 先验证供货单位
					if (!this.purchaseForm.supplierId) {
						this.$message.error('请先选择对应的供货单位！');
						return;
					}

					// 验证所有必填字段
					let hasErrors = false;
					this.goodsList.forEach(row => {
						const requiredFields = ['drugId', 'purcCnt', 'manuLotnum', 'manuDate', 'expyDate',
							'prodentpNameId'
						];
						requiredFields.forEach(field => {
							this.validateField(field, row);
							if (row.$errors && row.$errors[field]) {
								hasErrors = true;
							}
						});
					});

					if (hasErrors) {
						this.$message.error('请先完成所有必填字段');
						return;
					}

					await this.$refs.purchaseForm.validate();

					if (this.goodsList.length === 0) {
						this.$message.error('请至少添加一条药品明细');
						return;
					}

					this.submitLoading = true;

					// 准备提交数据
					const submitData = {
						costAmt: this.calculateTotalCost(),
						invoDate: this.purchaseForm.busDate,
						list: this.goodsList.map(item => ({
							drugId: item.drugId,
							expyDate: item.expyDate,
							manuDate: item.manuDate,
							manuLotnum: item.manuLotnum,
							markUpPric: item.markUpPric || 0,
							markUpRate: item.markUpRate || 0,
							maxPurcPric: item.maxPurcPric || item.purcPric,
							maxSalePric: item.maxSalePric || item.salePric,
							minPurcPric: item.minPurcPric || (item.purcPric / item.pacCnt),
							minSalePric: item.minSalePric || (item.salePric / item.pacCnt),
							planId: this.purchaseForm.planId || '',
							prodentpName: item.manufacturerOptions?.find(prod => prod.id === item
								.prodentpNameId)?.prodentpName || '',
							prodentpNameId: item.prodentpNameId,
							purcAmt: item.purcAmt,
							purcCnt: item.purcCnt,
							purcPric: item.purcPric,
							purcType: item.purcType,
							saleAmt: item.saleAmt,
							salePric: item.salePric
						})),
						printCnt: 0,
						purcInvoCodg: this.purchaseForm.purcInvoCodg,
						putinTypeId: this.purchaseForm.putinTypeId || 1,
						remarks: this.purchaseForm.remark,
						saleAmt: this.calculateTotalSale(),
						shedId: this.purchaseForm.warehouse,
						state: 0,
						supplyCandidateId: this.purchaseForm.supplierId,
						supplyCode: this.purchaseForm.supplyCode
					};

					let response;
					// 根据选择的库房调用不同的接口
					if (this.purchaseForm.warehouse == 4) {
						// 中药库
						response = await dugDocZYFInsert(submitData);
					} 

					if (response.code === 200) {
						this.$message.success('添加成功');
						this.purchaseDialogVisible = false;

						// 重新加载数据（会根据当前queryForm.warehouse自动选择接口）
						this.loadData();
					} else {
						this.$message.error(response.message || '添加失败');
					}

				} catch (error) {
					console.error('提交失败:', error);
					this.$message.error('表单验证失败，请检查输入');
				} finally {
					this.submitLoading = false;
				}
			},

			// 模态框关闭处理
			handlePurchaseDialogClose() {
				if (this.$refs.purchaseForm) {
					this.$refs.purchaseForm.resetFields();
				}
				this.goodsList = [];
				this.submitLoading = false;
				this.purchaseForm.totalAmt = '0.00';
				// 重置编辑模式
				this.isEditMode = false;
				this.currentEditId = null;

				// 如果是从采购计划跳转过来的，点击取消后返回采购计划页面
				if (this.isFromPlanTransfer) {
					this.isFromPlanTransfer = false;

					// 使用路由返回采购计划页面
					this.$router.push({
						path: '/PSI/shopPlan',
						query: {
							warehouse: this.$route.query.warehouse || 1
						}
					});
				} else {
					// 关键修改：如果不是从采购计划跳转，关闭后重新加载当前库房数据
					this.loadData();
				}
			},

			// 正常的添加采购入库方法，确保不会误触发跳转
			async handleAddPurchase() {
				this.currentStorageType = 'purchase';
				this.isEditMode = false;
				this.currentEditId = null;
				this.isFromPlanTransfer = false; // 明确设置为非跳转模式

				// 先加载药品选项数据
				await this.loadDrugOptions();

				await this.openPurchaseDialog(1);
			},

			// 修改：添加其他入库方法，重置编辑模式
			async handleAddOther() {
				this.currentStorageType = 'other';
				this.isEditMode = false;
				this.currentEditId = null;
				await this.openPurchaseDialog(2);
			},


			// 统一的打开采购对话框方法，添加加载状态
			async openPurchaseDialog(defaultPutinType = 1) {
				this.purchaseForm.warehouse = this.queryForm.warehouse; // 默认使用查询条件的库房
				this.previousWarehouse = this.purchaseForm.warehouse; // 记录初始值
				this.purchaseForm.docNum = '';
				this.purchaseForm.planData = null;
				this.purchaseForm.putinTypeId = defaultPutinType;

				// 如果药品选项尚未加载，则加载
				if (this.drugOptions.length === 0) {
					await this.loadDrugOptions();
				}

				// 加载其他选项数据
				await Promise.all([
					this.loadputinOptions(),
					this.loadSupplierOptions(),
					this.loadPurchasePlanOptions()
				]);

				this.purchaseDialogVisible = true;
			},

			// 新增：处理添加供货单位按钮点击
			handleAddSupplier() {
				this.supplierForm = {
					supplierName: '',
					supplierCode: '',
					contact: '',
					contactPhone: '',
					address: '',
					remark: ''
				};
				this.supplierDialogVisible = true;

				// 清除表单验证
				if (this.$refs.supplierForm) {
					this.$refs.supplierForm.clearValidate();
				}
			},

			// 新增：供货单位表单提交
			async handleSupplierSubmit() {
				try {
					await this.$refs.supplierForm.validate();

					this.supplierLoading = true;

					// 调用实际的API添加供货单位
					const response = await addSupplierEntity(this.supplierForm);

					if (response.code === 200) {
						this.$message.success('供货单位添加成功');
						this.supplierDialogVisible = false;
						// 重新加载供货单位列表
						await this.loadSupplierOptions();

						// 自动选择新添加的供货单位
						if (response.data && response.data.id) {
							this.purchaseForm.supplierId = response.data.id;
						}
					} else {
						this.$message.error(response.message || '添加失败');
					}
				} catch (error) {
					////console.error('添加供货单位失败:', error);
					if (error instanceof Error) {
						this.$message.error('表单验证失败，请检查输入');
					}
				} finally {
					this.supplierLoading = false;
				}
			},

			// 新增：加载采购计划选项
			async loadPurchasePlanOptions() {
				try {
					const params = {
						state: 5, // 只获取已过单的采购计划
						warehouse: this.queryForm.warehouse,
						pageNum: 1,
						pageSize: 50 // 获取前50条用于下拉选择
					};

					const response = await getPurchasingPlanZY(params);

					if (response.code === 200) {
						this.purchasePlanOptions = response.data.content || response.data.list || [];
					} else {
						this.purchasePlanOptions = [];
					}
				} catch (error) {
					////console.error('加载采购计划选项失败:', error);
					this.purchasePlanOptions = [];
				}
			},

			// 修改：加载数据方法，正确处理状态参数
			async loadData() {
				try {
					this.tableLoading = true;

					// 准备查询参数
					const params = {
						warehouse: this.queryForm.warehouse,
						docNum: this.queryForm.docNum,
						name: this.queryForm.goodsInfo,
						startDate: this.queryForm.createTime[0] ? this.formatDateForApi(this.queryForm.createTime[
							0]) : '',
						endDate: this.queryForm.createTime[1] ? this.formatDateForApi(this.queryForm.createTime[
							1]) : '',
						putinTypeId: this.getPutinTypeIdForApi(),
						supplierName: this.queryForm.supplier,
						pageNum: this.pagination.currentPage,
						pageSize: this.pagination.pageSize,
						state: this.queryForm.state === '' ? '' : this.queryForm.state
					};

					// 移除不需要的参数
					Object.keys(params).forEach(key => {
						if (params[key] === '' || params[key] === null || params[key] === undefined) {
							delete params[key];
						}
					});

					let response;
					// 根据选择的库房调用不同的接口
					if (this.queryForm.warehouse == 4) {
						// 中药房
						response = await tcmDocPage(params);
					} 

					if (response.code === 200) {
						this.tableData = response.data.content || response.data.list || [];
						this.pagination.total = response.data.totalSize || response.data.total || 0;
					} else {
						this.$message.error(response.message || '获取数据失败');
						this.tableData = [];
						this.pagination.total = 0;
					}
				} catch (error) {
					console.error('加载数据失败:', error);
					this.$message.error('加载数据失败');
					this.tableData = [];
					this.pagination.total = 0;
				} finally {
					this.tableLoading = false;
				}
			},

			// 将入库类型转换为接口需要的putinTypeId
			getPutinTypeIdForApi() {
				const storageType = this.queryForm.storageType;

				// 如果是"全部类型"，返回空字符串或不传该参数
				if (storageType === 'all' || !storageType) {
					return '';
				}

				// 直接使用选择的入库类型值，因为storageTypeOptions已经从接口获取
				// 确保storageTypeOptions中的id与接口需要的putinTypeId一致
				return storageType;
			},

			// 修改：根据putinTypeId获取对应的入库类型标签（用于显示）
			getStorageTypeLabel(putinTypeId) {
				if (!putinTypeId) return '未知类型';

				// 从storageTypeOptions中查找对应的标签
				const typeOption = this.storageTypeOptions.find(item =>
					item.id === putinTypeId || item.value === putinTypeId
				);

				return typeOption ? typeOption.label : '未知类型';
			},

			// 新增：格式化日期为API需要的格式
			formatDateForApi(dateString) {
				if (!dateString) return '';
				const date = new Date(dateString);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},

			// 新增：根据状态筛选值获取state参数
			getStateByStatus(status) {
				// 如果状态是 'all' 或空值，返回空字符串表示获取全部
				if (!status || status === 'all') {
					return '';
				}
				// 直接返回对应的状态值
				return status;
			},

			// 新增：打开采购计划抽屉
			openPurchasePlanDrawer() {
				this.purchasePlanDrawerVisible = true;
				this.loadPurchasePlans();
			},

			// 新增：加载采购计划数据
			async loadPurchasePlans() {
				try {
					this.planLoading = true;

					const params = {
						state: 5, // 只获取已过单的采购计划
						warehouse: this.queryForm.warehouse,
						docNum: this.planQueryForm.docNum,
						supplier: this.planQueryForm.supplier,
						pageNum: this.planPagination.currentPage,
						pageSize: this.planPagination.pageSize
					};

					const response = await getPurchasingPlanZY(params);

					if (response.code === 200) {
						this.purchasePlanList = response.data.content || response.data.list || [];
						this.planPagination.total = response.data.totalSize || response.data.total || 0;

						// 同时更新下拉选项
						this.purchasePlanOptions = this.purchasePlanList;
					} else {
						this.$message.error(response.message || '获取采购计划失败');
						this.purchasePlanList = [];
						this.purchasePlanOptions = [];
					}
				} catch (error) {
					////console.error('加载采购计划失败:', error);
					this.$message.error('加载采购计划失败');
					this.purchasePlanList = [];
					this.purchasePlanOptions = [];
				} finally {
					this.planLoading = false;
				}
			},
			// 新增：采购计划查询
			handlePlanQuery() {
				this.planPagination.currentPage = 1;
				this.loadPurchasePlans();
			},

			// 新增：重置采购计划查询
			resetPlanQuery() {
				this.planQueryForm = {
					docNum: '',
					supplier: ''
				};
				this.planPagination.currentPage = 1;
				this.loadPurchasePlans();
			},

			// 新增：采购计划分页变化
			handlePlanPageChange(page) {
				this.planPagination.currentPage = page;
				this.loadPurchasePlans();
			},

			// 新增：选择采购计划
			async selectPurchasePlan(plan) {
				try {
					this.purchaseForm.docNum = plan.id;
					this.purchaseForm.planData = plan;

					// 调用接口获取采购计划详情
					const response = await getPlanData({
						id: plan.id
					});

					if (response.code === 200 && response.data) {
						// 填充药品明细信息
						await this.fillGoodsListFromPlan(response.data);
						this.$message.success(`已选择采购计划: ${plan.docNum}，并自动填充药品明细`);
					} else {
						this.$message.error('获取采购计划详情失败');
					}
				} catch (error) {
					////console.error('获取采购计划详情失败:', error);
					this.$message.error('获取采购计划详情失败');
				} finally {
					this.purchasePlanDrawerVisible = false;
				}
			},

			// 调拨采购单按钮点击事件 - 使用路由跳转
			async handleAuditTransfer() {
				try {
					// 添加缩放动画效果
					this.$el.style.transition = 'all 0.3s ease';
					this.$el.style.transform = 'scale(0.95)';
					this.$el.style.opacity = '0.8';

					// 延迟执行路由跳转，让动画效果可见
					setTimeout(() => {
						this.$router.push({
							path: '/PSI/allocate',
							query: {
								warehouse: this.queryForm.warehouse,
								warehouseName: this.getWarehouseName(this.queryForm.warehouse)
							}
						});
					}, 300);
				} catch (error) {
					console.error('跳转到调拨单页面失败:', error);
					this.$message.error('跳转到调拨单页面失败');

					// 恢复原状
					this.$el.style.transform = 'scale(1)';
					this.$el.style.opacity = '1';
				}
			},


			// 修改：创建新药品行 - 确保正确初始化基准价格
			createNewGoodsRow() {
				const newRow = {
					id: Date.now(),
					drugId: '',
					name: '',
					drugSpecifications: '',
					pacSpec: '',
					purcCnt: 1,
					purcPric: '0.00000000',
					salePric: '0.00000000',
					purcAmt: '0.00',
					saleAmt: '0.00',
					manuLotnum: '',
					manuDate: '',
					expyDate: '',
					prodentpNameId: '',
					manufacturerOptions: [],
					purcType: '2', // 默认包装单位
					markUpId: '1', // 默认比例加成
					markUpRate: 0,
					markUpPric: 0,
					dosUnt: '粒',
					pacUnt: '盒',
					pacCnt: 1,
					// 基准价格字段 - 新增初始化
					minPurcPric: '0.00000000',
					maxPurcPric: '0.00000000',
					minSalePric: '0.00000000',
					maxSalePric: '0.00000000',
					unitDisplay: '包装单位',
					$errors: {},
					isCalculating: false
				};

				// 关键修改：初始化基准价格
				this.initializeNewRowPrices(newRow);

				return newRow;
			},

			// 新增：初始化新行的价格
			initializeNewRowPrices(row) {
				// 设置默认基准价格
				row.minPurcPric = '0.00000000';
				row.maxPurcPric = '0.00000000';
				row.minSalePric = '0.00000000';
				row.maxSalePric = '0.00000000';

				// 根据库存类型设置显示价格
				if (row.purcType === '1') {
					row.purcPric = row.minPurcPric;
					row.salePric = row.minSalePric;
				} else {
					row.purcPric = row.maxPurcPric;
					row.salePric = row.maxSalePric;
				}

				console.log('新行价格初始化完成:', {
					库存类型: row.purcType,
					显示成本单价: row.purcPric,
					最小成本单价: row.minPurcPric,
					最大成本单价: row.maxPurcPric
				});
			},

			// 新增：入库数量聚焦处理
			handlePurcCntFocus(row) {
				this.isCalculating = true;
				// 保存原始值
				this.originalPurcCnt = row.purcCnt;
			},

			// 新增：入库数量失焦处理
			handlePurcCntBlur(row) {
				// 如果值没有变化，直接启用按钮
				if (row.purcCnt === this.originalPurcCnt) {
					this.isCalculating = false;
					return;
				}

				// 触发变化处理
				this.handlePurcCntChange(row.purcCnt, row);
			},
			// 修改 handleCreateTransfer 方法
			handleCreateTransfer() {
				this.currentTransferOperation = 'create';
				this.transferOpenSource = 'create'; // 明确设置为新建来源

				// 打开空白调拨单对话框
				this.openEmptyTransferDialog();
			},

			// 修改 openEmptyTransferDialog 方法
			openEmptyTransferDialog() {
				this.allocateDialogVisible = true;
				this.selectedTransferRows = [];

				this.$nextTick(() => {
					if (this.$refs.allocateDialog) {
						// 关键修改：明确传递 openSource 为 'create'
						this.$refs.allocateDialog.open(null, 'create', 'create');
					}
				});
			},

			// 修改 openTransferDialogWithSelectedRow 方法
			async openTransferDialogWithSelectedRow(row, openSource = 'generate') {
				if (!row) {
					this.$message.warning('未找到选中的入库单数据');
					return;
				}

				this.selectedTransferRows = [row];
				this.allocateDialogVisible = true;

				this.$nextTick(() => {
					if (this.$refs.allocateDialog) {
						// 关键修改：明确传递 openSource
						this.$refs.allocateDialog.open(this.selectedTransferRows, 'generate', openSource);
					}
				});
			},


			// 新增：获取显示行号（从1开始）
			getDisplayRowNumber(row, index) {
				// 优先使用row中的rowNumber，如果没有则使用索引+1
				if (row.rowNumber !== undefined && row.rowNumber !== null) {
					return parseInt(row.rowNumber) + 1;
				}
				return index + 1;
			},

			// 新增：获取选中采购计划信息
			getSelectedPlanInfo() {
				if (!this.purchaseForm.docNum) return '';

				const selectedPlan = this.purchasePlanOptions.find(plan => plan.id === this.purchaseForm.docNum);
				if (selectedPlan) {
					return `${selectedPlan.docNum} - ${selectedPlan.supplierName}`;
				}
				return '';
			},
			// 新增：获取选中的生产厂家名称
			getSelectedManufacturerName(row) {
				if (!row.prodentpNameId || !row.manufacturerOptions) return '';

				const selectedManufacturer = row.manufacturerOptions.find(
					item => item.id === row.prodentpNameId
				);

				return selectedManufacturer ? selectedManufacturer.prodentpName : '未知厂家';
			},

			// 新增：加载药品详细信息
			async loadDrugDetails(drugId, row) {
				let pamr = {
				  name: this.searchValue,
				  pageNum: this.pageNum,
				  pageSize : this.pageSize
				}
				try {
					// 加载药品选项信息
					const drugResponse = await getWareZY(pamr);
					if (drugResponse.code === 200) {
						const drugOptions = drugResponse.data.content || drugResponse.data.list || [];
						const selectedDrug = drugOptions.find(drug => drug.id === drugId);

						if (selectedDrug) {
							// 更新药品信息
							row.name = selectedDrug.name || row.name;
							row.drugSpecifications = selectedDrug.drugSpecifications || row.drugSpecifications;
							row.pacSpec = selectedDrug.pacSpec || row.pacSpec;
							row.dosUnt = selectedDrug.dosUnt || '粒';
							row.pacUnt = selectedDrug.pacUnt || '盒';
							row.pacCnt = selectedDrug.pacCnt || 1;

							// 设置加成方式
							if (selectedDrug.markUpId) {
								row.markUpId = selectedDrug.markUpId.toString();
								row.markUpRate = selectedDrug.markUpRate || 0;
								row.markUpPric = selectedDrug.markUpPric || 0;
							}
						}
					}

					// 加载生产厂家选项
					await this.loadManufacturerOptions(drugId, row);

				} catch (error) {
					////console.error('加载药品详细信息失败:', error);
				}
			},

			// 新增：采购计划行点击
			handlePlanRowClick(row) {
				this.selectPurchasePlan(row);
			},

			// 优化：处理采购计划选择变化
			async handlePlanCodeChange(value) {
				if (!value) {
					// 清空选择时，清空药品列表
					this.goodsList = [];
					this.purchaseForm.planData = null;
					return;
				}

				const selectedPlan = this.purchasePlanOptions.find(plan => plan.id === value);
				if (selectedPlan) {
					this.purchaseForm.planData = selectedPlan;

					// 自动填充供应商信息
					this.purchaseForm.supplierId = selectedPlan.supplierId;

					// 调用接口获取采购计划详情并填充药品明细
					try {
						const response = await getPlanData({
							id: value
						});
						if (response.code === 200 && response.data) {
							await this.fillGoodsListFromPlan(response.data);
							this.$message.success(`已加载采购计划: ${selectedPlan.docNum} 的药品明细`);
						}
					} catch (error) {
						////console.error('获取采购计划详情失败:', error);
						this.$message.error('获取采购计划详情失败');
					}
				}
			},
			// 新增：采购入库表格行点击事件
			handlePurchaseRowClick(row, column, event) {
				// 如果点击的是操作列，不触发勾选
				if (column && column.property === 'operation') {
					return;
				}

				// 切换当前行的选中状态
				this.$refs.purchaseTable.toggleRowSelection(row);
			},

			// 新增：抽屉关闭处理
			handleDrawerClose(done) {
				this.purchasePlanDrawerVisible = false;
				done();
			},

			// 保留原有的工具方法
			getCreatorName(row) {
				return row.creater || row.createName || row.createUser || row.createName || '--';
			},

			// 采购入库表格行点击事件 - 确保方法正确实现
			handleRowClick(row, column, event) {
				// 确保表格引用存在且正确
				if (this.$refs.purchaseTable) {
					// 切换当前行的选中状态
					this.$refs.purchaseTable.toggleRowSelection(row);
				}

				// 更新快速调拨按钮状态
				this.updateQuickTransferButtonState();
			},
			// 新增：处理成本单价失去焦点事件
			handleCostPriceBlur(row) {
				if (row.purcPric) {
					const numValue = this.getValidNumber(row.purcPric, 8);
					// 存储8位精度的原始值
					row._purcPricRaw = this.formatToDecimal(numValue, 8);
					// 显示智能格式化值
					const displayValue = this.smartFormatPrice(numValue);
					// 使用$nextTick确保DOM更新
					this.$nextTick(() => {
						row.purcPric = displayValue;
					});
				}
			},
			
			// 新增：处理成本单价获得焦点事件
			handleCostPriceFocus(row) {
				// 获取焦点时，如果有原始8位精度值，显示原始值
				if (row._purcPricRaw) {
					this.$nextTick(() => {
						row.purcPric = row._purcPricRaw;
					});
				}
			},
			
			// 新增：处理加成值失去焦点
			handleMarkUpValueBlur(row) {
				if (row.markUpPric) {
					const numValue = this.getValidNumber(row.markUpPric, 8);
					// 存储8位精度的原始值
					row._markUpPricRaw = this.formatToDecimal(numValue, 8);
					// 显示智能格式化值
					const displayValue = this.smartFormatPrice(numValue);
					this.$nextTick(() => {
						row.markUpPric = displayValue;
					});
				}
			},
			// 新增：更新快速调拨按钮状态
			updateQuickTransferButtonState() {
				const hasValidSelection = this.selectedRows.some(row => row.state === 5);
				this.isQuickTransferEnabled = hasValidSelection;
			},

			formatDate(dateString) {
				if (!dateString || dateString === '--') return '--';
				const date = new Date(dateString);
				const month = (date.getMonth() + 1).toString().padStart(2, '0');
				const day = date.getDate().toString().padStart(2, '0');
				return `${month}-${day} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
			},

			formatDateTime(dateString) {
				if (!dateString || dateString === '--') return '--';
				const date = new Date(dateString);
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0');
				const day = date.getDate().toString().padStart(2, '0');
				const hours = date.getHours().toString().padStart(2, '0');
				const minutes = date.getMinutes().toString().padStart(2, '0');
				const seconds = date.getSeconds().toString().padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},

			getStorageTypeTagType(type) {
				const typeMap = {
					'采购入库': 'primary',
					'盘点入库': 'success',
					'调拨入库': 'info',
					'其他入库': 'warning',
					'赠送入库': 'danger',
					'系统切换入库': 'danger',
				};
				return typeMap[type] || 'info';
			},

			getStorageTypeText(type) {
				const textMap = {
					'purchase': '采购',
					'transfer': '调拨',
					'other': '其他',
					'inventory': '盘点'
				};
				return textMap[type] || type;
			},

			getStatusType(status) {
				const typeMap = {
					0: 'info',
					2: 'primary',
					4: 'warning',
					5: 'success',
					6: 'danger'
				};
				return typeMap[status] || 'info';
			},

			getStatusText(status) {
				const textMap = {
					0: '草稿',
					1: '回退提交',
					2: '已提交',
					3: '回退审核',
					4: '已审核',
					5: '已过单',
					6: '已冲销'
				};
				return textMap[status] || status;
			},

			// 新增：处理子组件操作成功事件
			handleDetailOperationSuccess(resultData) {
				// ////console.log('收到子组件操作成功通知:', resultData);

				// 根据操作类型显示不同的提示
				const operationTexts = {
					submit: '提交',
					audit: '审核',
					pass: '过单',
					reject: '驳回'
				};

				const operationText = operationTexts[resultData.type] || '操作';

				this.$message.success(`${operationText}成功，正在刷新数据...`);

				// 延迟一下让用户看到提示信息
				setTimeout(() => {
					// 重新加载采购入库列表数据
					this.loadData();

					// 如果调拨单表格是打开的，也重新加载调拨单数据
					if (this.showTransferTable) {
						this.loadTransferData();
					}

					// 清除选中状态
					this.selectedRows = [];

					this.$message.success('数据已刷新');
				}, 500);
			},

			// 保留其他原有方法
			changeStatus(status) {
				this.currentStatus = status;
				this.pagination.currentPage = 1;
				this.loadData();
			},

			// 查询按钮点击处理
			handleQuery() {
				this.pagination.currentPage = 1;
				this.loadData();
			},

			// 新增：获取表格标题
			getTableTitle() {
				const warehouseType = this.queryForm.warehouse == 2 ? '中药库' : '中药房';
				return `【${warehouseType}】采购入库列表`;
			},

			// 修改：处理入库库房变化
			handleWarehouseChange(value) {
				this.queryForm.warehouse = value;
				this.pagination.currentPage = 1;
				this.loadData();
			},

			// 新增：处理采购药库变化
			async handlePurchaseWarehouseChange(value) {
				if (this.goodsList.length > 0) {
					const warehouseName = value == 1 ? '药库' : '药房';
					const message = value == 1 ?
						'当前操作会将已有数据添加至药库，是否确认继续？' :
						'该操作将直接将药品添加至药房，是否确认继续？';

					try {
						await this.$confirm(message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						});
					} catch (cancel) {
						// 用户取消操作，恢复原来的值
						this.purchaseForm.warehouse = this.previousWarehouse;
						return;
					}
				}
				this.previousWarehouse = value;
			},

			// 处理选中状态变化
			handlePageChange(page) {
				this.pagination.currentPage = page;
				this.loadData();
			},

			handleSelectionChange(selection) {
				this.selectedRows = selection;

				// 检查是否至少选中一条state=5的数据
				const hasValidSelection = selection.some(row => row.state === 5);
				this.isQuickTransferEnabled = hasValidSelection;

				console.log('选中行数据:', selection.map(row => ({
					id: row.id,
					docNum: row.docNum,
					state: row.state
				})));
			},
			// 新增：处理批量生成调拨单
			async handleBatchTransfer() {
				if (this.selectedRows.length <= 1) {
					this.$message.warning('请至少选择两条入库单进行批量调拨');
					return;
				}

				// 检查所选行是否都是已过单状态
				const invalidRows = this.selectedRows.filter(row => row.state !== 5);
				if (invalidRows.length > 0) {
					this.$message.warning('只能选择已过单的入库单进行调拨操作');
					return;
				}

				// 打开调拨对话框
				this.openTransferDialog();
			},

			// 处理单个生成调拨单
			// 修改：处理单个生成调拨单
			async handleSingleTransfer(row) {
				if (row.state !== 5) {
					this.$message.warning('只有已过单的入库单才能生成调拨单');
					return;
				}

				this.currentTransferOperation = 'generate';
				this.transferOpenSource = 'generate';
				this.currentSelectedRow = row;

				// 打开调拨单对话框，指定入口来源为'generate'
				await this.openTransferDialogWithSelectedRow(row, 'generate');
			},

			// 新增：显示调拨单表格并开始loading
			async showTransferTableWithLoading() {
				// 先显示调拨单表格
				await this.loadTransferData();
				this.showTransferTable = true;

				// 开始2.8秒的loading
				this.startTransferLoading();

				// 添加动画效果
				this.$nextTick(() => {
					const transferTable = document.querySelector('.transfer-table');
					if (transferTable) {
						transferTable.style.animation = 'zoomInLeft 0.3s ease-out';
					}
				});
			},

			// 新增：开始调拨单loading
			startTransferLoading() {
				this.showTransferLoading = true;

				// 清除之前的计时器
				if (this.transferLoadingTimer) {
					clearTimeout(this.transferLoadingTimer);
				}

				// 设置2.8秒后结束loading并打开对话框
				this.transferLoadingTimer = setTimeout(() => {
					this.endTransferLoading();
				}, 2800);
			},

			// 新增：结束调拨单loading并打开对话框
			endTransferLoading() {
				this.showTransferLoading = false;

				if (this.currentTransferOperation === 'generate' && this.currentSelectedRow) {
					this.openTransferDialogWithSelectedRow();
				}
			},

			// 新增：处理去调拨按钮点击
			handleGoToTransfer() {
				// 打开新建调拨单模态框
				this.openTransferDialog();
			},

			// 修改：打开调拨对话框方法，添加动画效果
			openTransferDialog() {
				// 初始化调拨表单
				this.transferForm = {
					fromWarehouse: this.queryForm.warehouse,
					toWarehouse: '',
					busDate: new Date().toISOString().split('T')[0],
					docNum: this.generateTransferDocNum(),
					remark: ''
				};

				// 设置选中的调拨行
				this.selectedTransferRows = [...this.selectedRows];

				// 计算合计金额
				this.calculateTransferTotals();

				this.transferDialogVisible = true;
				this.isTransferSubmitEnabled = this.checkTransferSubmitEnabled();

				// 添加动画效果
				this.$nextTick(() => {
					const dialog = document.querySelector('.transfer-dialog');
					if (dialog) {
						dialog.style.animation = 'zoomInLeft 0.3s ease-out';
					}
				});
			},

			// 新增：计算调拨合计成本金额
			calculateTransferTotalCost() {
				const total = this.selectedTransferRows.reduce((sum, row) => {
					return sum + (Number(row.purcAmt) || 0);
				}, 0);
				return total.toFixed(8);
			},

			// 新增：计算调拨合计零售金额
			calculateTransferTotalSale() {
				const total = this.selectedTransferRows.reduce((sum, row) => {
					return sum + (Number(row.saleAmt) || 0);
				}, 0);
				return total.toFixed(8);
			},

			// 修改：计算调拨合计金额
			calculateTransferTotals() {
				let totalCost = 0;
				let totalSale = 0;

				this.transferTableDetailsData.forEach(item => {
					totalCost += Number(item.purcAmt) || 0;
					totalSale += Number(item.saleAmt) || 0;
				});

				this.totalCostAmount = totalCost.toFixed(8);
				this.totalSaleAmount = totalSale.toFixed(8);
			},
			// 修改：在采购入库模态框打开时，如果是查看模式，禁用编辑
			handlePurchaseDialogOpen() {
				if (this.detailMode === 'exam') { // 修复：将 detailDialogMode 改为 detailMode
					this.disableAllEditing();
				}
			},

			// 新增：禁用所有编辑功能
			disableAllEditing() {
				// 这里可以添加逻辑来禁用表单中的所有编辑控件
				// 例如：将输入框设置为只读，禁用按钮等
				this.isSubmitEnabled = false; // 禁用提交按钮
			},
			// 操作命令处理，添加调拨命令
			async handleOperationCommand(command, row) {
				switch (command) {
					case 'detail':
						await this.handleDetail(row);
						break;
					case 'submit':
						await this.handleSubmit(row);
						break;
					case 'edit':
						await this.handleEdit(row);
						break;
					case 'del':
						this.handleDelete(row);
						break;
					case 'audit':
						await this.handleAudit(row);
						break;
					case 'pass':
						await this.handlePass(row);
						break;
					case 'reverse':
						this.handleReverse(row);
						break;
					case 'transfer':
						await this.handleSingleTransfer(row);
						break;
				}
			},

			// 详情模态框相关方法
			handleDetailDialogVisibleChange(value) {
				this.detailDialogVisible = value;
				// 当对话框打开时，如果已经有加载的数据，直接传递给子组件
				if (value && this.currentPlanData) {
					this.$nextTick(() => {
						if (this.$refs.storePsiDetail) {
							this.$refs.storePsiDetail.setPlanData(this.currentPlanData);
						}
					});
				}
			},
			handleDetailDialogClose() {
				this.detailDialogVisible = false;
				this.currentPlanId = null;
			},

			// 刷新方法，确保数据一致性
			handleDetailDialogRefresh() {
				// 直接调用数据加载方法
				this.loadData();

				// 如果调拨单表格可见，也刷新调拨单数据
				if (this.showTransferTable) {
					this.loadTransferData();
				}

				this.$message.info('数据已刷新');
			},

			handleDetailDialogModeChange(mode) {
				this.detailMode = mode;
			},

			// 修改：创建编辑行数据 - 重点修改生产厂家ID的处理
			async createEditRow(item) {
				const newRow = {
					id: item.id || Date.now(),
					drugId: item.drugId,
					name: item.name,
					drugSpecifications: item.drugSpecifications,
					pacSpec: item.pacSpec,
					purcCnt: item.purcCnt || 1,
					purcPric: item.purcPric || 0,
					salePric: item.salePric || 0,
					purcAmt: item.purcAmt || '0.00',
					saleAmt: item.saleAmt || '0.00',
					manuLotnum: item.manuLotnum || '',
					manuDate: item.manuDate || '',
					expyDate: item.expyDate || '',
					// 关键修改：确保生产厂家ID是数字类型
					prodentpNameId: this.safeParseInt(item.prodentpNameId),
					manufacturerOptions: [],
					manufacturerLoading: false,
					drugLoading: false,
					purcType: item.purcType?.toString() || '2',
					dosUnt: item.dosUnt || '粒',
					pacUnt: item.pacUnt || '盒',
					unitDisplay: item.purcType?.toString() === '1' ?
						(item.dosUnt || '粒') : (item.pacUnt || '盒'),
					markUpId: item.markUpId?.toString() || '1',
					markUpRate: item.markUpRate || 0,
					markUpPric: item.markUpPric || 0,
					pacCnt: item.pacCnt || 1,
					putinTypeId: item.putinTypeId || 1,
					$errors: {}
				};

				// 如果有生产厂家ID，确保能够正确显示厂家名称
				if (newRow.prodentpNameId) {
					await this.ensureManufacturerDisplay(newRow.prodentpNameId, newRow);
				}

				// 加载药品对应的生产厂家选项
				if (newRow.drugId) {
					await this.loadManufacturerOptionsForEdit(newRow.drugId, newRow);
				}

				return newRow;
			},
			// 新增：确保生产厂家能够正确显示
			async ensureManufacturerDisplay(manufacturerId, row) {
				try {
					// 首先尝试从全局的生产厂家列表中查找
					const globalManufacturers = this.prodentOption || [];
					let foundManufacturer = globalManufacturers.find(prod => prod.id === manufacturerId);

					// 如果全局列表中没有，尝试调用接口获取厂家详情
					if (!foundManufacturer) {
						const response = await getManufacturerById({
							id: manufacturerId
						});

						if (response.code === 200 && response.data) {
							const manufacturerData = response.data;

							// 创建厂家选项对象
							const manufacturerOption = {
								id: manufacturerData.id || manufacturerData.prodentpId || manufacturerId,
								prodentpName: manufacturerData.manufacturerName || manufacturerData.prodentpName ||
									`厂家${manufacturerId}`,
								prodentpCode: manufacturerData.coding || manufacturerData.prodentpCode || ''
							};
							// 添加到选项中
							if (!row.manufacturerOptions) {
								row.manufacturerOptions = [];
							}

							// 检查是否已存在相同的选项
							const existingIndex = row.manufacturerOptions.findIndex(
								item => item.id === manufacturerOption.id
							);

							if (existingIndex === -1) {
								row.manufacturerOptions.push(manufacturerOption);
							}

							foundManufacturer = manufacturerOption;
							//console.log('生产厂家信息已从接口获1221211取:', manufacturerOption);
						} else {
							// 如果接口调用失败，创建一个默认选项
							this.createDefaultManufacturerOption(manufacturerId, row);
						}
					}

					// 如果找到了厂家信息，确保选中值正确
					if (foundManufacturer) {
						row.prodentpNameId = foundManufacturer.id;
					}
				} catch (error) {
					//console.error('确保生产厂家显示失败:', error);
					// 出错时创建默认选项
					this.createDefaultManufacturerOption(manufacturerId, row);
				}
			},
			// 修改：为编辑模式加载生产厂家选项
			async loadManufacturerOptionsForEdit(drugId, row) {
				try {
					row.manufacturerLoading = true;

					// 调用接口获取生产厂家信息
					const response = await getProdentZY({
						drugId: drugId
					});

					if (response.code === 200) {
						const manufacturers = response.data || response.data.list || [];

						// 转换数据结构，确保字段名正确，并且ID是数字类型
						const newOptions = manufacturers.map(manufacturer => ({
							id: this.safeParseInt(manufacturer.prodentpId || manufacturer.id),
							prodentpName: manufacturer.prodentpacUntName || manufacturer.name,
							prodentpCode: manufacturer.prodentpCode || manufacturer.code
						})).filter(option => option.id !== null); // 过滤掉无效的选项

						// 合并新选项到现有选项中
						if (!row.manufacturerOptions) {
							row.manufacturerOptions = [];
						}

						// 避免重复添加
						newOptions.forEach(newOption => {
							const existingIndex = row.manufacturerOptions.findIndex(
								item => item.id === newOption.id
							);
							if (existingIndex === -1) {
								row.manufacturerOptions.push(newOption);
							}
						});

						//console.log('加载药品生产厂家选项成功:', newOptions.length);
					} else {
						//console.warn('获取药品生产厂家失败:', response.message);
					}
				} catch (error) {
					//console.error('加载生产厂家选项失败:', error);
				} finally {
					row.manufacturerLoading = false;
				}
			},
			// 修改：加载编辑数据
			async loadEditData(id) {
				try {
					// 调用详情接口获取数据
					const response = await dugDocgetZYFDrugDetails({
						id: id
					});

					if (response.code === 200 && response.data) {
						const detailData = response.data;

						// 填充采购表单数据
						this.purchaseForm = {
							warehouse: detailData.shedId || this.queryForm.warehouse,
							busDate: detailData.invoDate || new Date().toISOString().split('T')[0],
							supplierId: detailData.supplyCandidateId || '',
							supplierName: detailData.supplierName || '',
							purcInvoCodg: detailData.purcInvoCodg || '',
							supplyCode: detailData.supplyCode || '',
							putinTypeId: Number(detailData.putinTypeId) || 1,
							remark: detailData.remarks || '',
							docNum: detailData.docNum || '', // 确保docNum有值
							totalAmt: detailData.costAmt || '0.00'
						};

						// 填充药品列表数据
						if (detailData.list && Array.isArray(detailData.list)) {
							this.goodsList = [];

							// 遍历药品列表，逐个加载数据
							for (const item of detailData.list) {
								// 关键修改：确保生产厂家ID是数字类型
								const processedItem = {
									...item,
									prodentpNameId: this.safeParseInt(item.prodentpNameId)
								};

								const newRow = await this.createEditRow(processedItem);

								// 特殊处理：确保厂家信息正确加载
								if (newRow.prodentpNameId && newRow.manufacturerOptions.length === 0) {
									//console.warn('厂家选项为空，尝试单独加载厂家信息');
									await this.loadManufacturerById(newRow.prodentpNameId, newRow);
								}

								this.goodsList.push(newRow);
							}
						}

						// 重新计算金额
						this.calculateTotalCost();
						this.calculateTotalSale();

						this.$message.success('编辑数据加载成功');
					} else {
						this.$message.error(response.message || '获取详情数据失败');
					}
				} catch (error) {
					//console.error('加载编辑数据失败:', error);
					this.$message.error('加载编辑数据失败');
				}
			},

			// 新增：处理采购修改提交
			async handlePurchaseEdit() {
				try {
					// 先验证供货单位
					if (!this.purchaseForm.supplierId) {
						this.$message.error('请先选择对应的供货单位！');
						return;
					}

					// 验证所有必填字段
					let hasErrors = false;
					this.goodsList.forEach(row => {
						const requiredFields = ['drugId', 'purcCnt', 'manuLotnum', 'manuDate', 'expyDate',
							'prodentpNameId'
						];
						requiredFields.forEach(field => {
							this.validateField(field, row);
							if (row.$errors && row.$errors[field]) {
								hasErrors = true;
							}
						});
					});

					if (hasErrors) {
						this.$message.error('请先完成所有必填字段');
						return;
					}

					await this.$refs.purchaseForm.validate();

					if (this.goodsList.length === 0) {
						this.$message.error('请至少添加一条药品明细');
						return;
					}

					this.submitLoading = true;

					// 准备修改数据
					const editData = {
						id: this.currentEditId,
						costAmt: this.calculateTotalCost(),
						invoDate: this.purchaseForm.busDate,
						list: this.goodsList.map(item => {
							const manufacturer = item.manufacturerOptions.find(prod => prod.id === item
								.prodentpNameId);
							return {
								id: item.id,
								drugId: item.drugId,
								expyDate: item.expyDate,
								manuDate: item.manuDate,
								manuLotnum: item.manuLotnum,
								markUpPric: item.markUpPric || 0,
								markUpRate: item.markUpRate || 0,
								maxPurcPric: item.maxPurcPric || item.purcPric,
								maxSalePric: item.maxSalePric || item.salePric,
								minPurcPric: item.minPurcPric || (item.purcPric / item.pacCnt),
								minSalePric: item.minSalePric || (item.salePric / item.pacCnt),
								planId: this.purchaseForm.planId || '',
								prodentpName: manufacturer ? manufacturer.prodentpName : '',
								prodentpNameId: item.prodentpNameId,
								purcAmt: item.purcAmt,
								purcCnt: item.purcCnt,
								purcPric: item.purcPric,
								purcType: item.purcType,
								saleAmt: item.saleAmt,
								salePric: item.salePric
							};
						}),
						printCnt: 0,
						purcInvoCodg: this.purchaseForm.purcInvoCodg,
						putinTypeId: this.purchaseForm.putinTypeId || 1,
						remarks: this.purchaseForm.remark,
						saleAmt: this.calculateTotalSale(),
						shedId: this.purchaseForm.warehouse,
						state: 0,
						supplyCandidateId: this.purchaseForm.supplierId,
						supplyCode: this.purchaseForm.supplyCode
					};

					let response = await editZYFdugDoc(editData);
					if (response.code === 200) {
						this.$message.success('修改成功');
						this.purchaseDialogVisible = false;
						this.loadData();
						this.isEditMode = false;
						this.currentEditId = null;
					} else {
						this.$message.error(response.message || '修改失败');
					}
				} catch (error) {
					console.error('修改失败:', error);
					this.$message.error('修改失败，请检查输入');
				} finally {
					this.submitLoading = false;
				}
			},
			// 删除操作 - 根据库房选择不同接口
			handleDelete(row) {
				this.$confirm('确定要删除此采购入库吗？此操作不可恢复', '提示', {
					type: 'error',
					confirmButtonText: '确定删除',
					cancelButtonText: '取消'
				}).then(() => {
					// 根据当前库房选择删除接口
					const deleteApi = this.queryForm.warehouse == 3 ? deleteByZYF : deleteZYFDoc;

					deleteApi({
						id: row.id
					}).then(response => {
						if (response.code === 200) {
							this.$message.success('删除成功');
							this.loadData();
						} else {
							this.$message.error(response.message || '删除失败');
						}
					}).catch(error => {
						console.error('删除失败:', error);
						this.$message.error('删除失败');
					});
				}).catch(() => {
					this.$message.info('已取消删除操作');
				});
			},

			// 修改提交方法，确保传递正确的库房信息
			async handleSubmit(row) {
				try {
					// 先关闭对话框（如果已打开）
					if (this.detailDialogVisible) {
						this.detailDialogVisible = false;
						await this.$nextTick();
					}

					this.currentPlanId = row.id;
					this.detailMode = 'exam';

					// 修复：直接传递库房信息给子组件
					this.$nextTick(() => {
						if (this.$refs.storePsiDetail) {
							this.$refs.storePsiDetail.currentWarehouse = this.queryForm.warehouse;
						}
					});

					// 添加延迟，确保DOM更新完成
					setTimeout(() => {
						this.detailDialogVisible = true;

						// 关键修改：确保子组件正确设置提交模式类型
						if (this.$refs.storePsiDetail) {
							// 先强制设置模式为 exam
							this.$refs.storePsiDetail.setDialogMode('exam', 'submit');

							// 确保快捷调拨模式被禁用
							this.$refs.storePsiDetail.isQuickTransferMode = false;
						}
					}, 50);

				} catch (error) {
					console.error('打开详情失败:', error);
					this.$message.error('打开详情失败');
				}
			},

			// 修改审核方法
			async handleAudit(row) {
				try {
					// 先关闭对话框（如果已打开）
					if (this.detailDialogVisible) {
						this.detailDialogVisible = false;
						await this.$nextTick();
					}

					this.currentPlanId = row.id;
					this.detailMode = 'exam';

					// 修复：直接传递库房信息给子组件
					this.$nextTick(() => {
						if (this.$refs.storePsiDetail) {
							this.$refs.storePsiDetail.currentWarehouse = this.queryForm.warehouse;
						}
					});

					// 添加延迟，确保DOM更新完成
					setTimeout(() => {
						this.detailDialogVisible = true;

						// 关键修改：确保子组件正确设置审核模式类型
						if (this.$refs.storePsiDetail) {
							// 根据单据状态设置正确的审核模式类型
							if (row.state === 2) {
								this.$refs.storePsiDetail.setDialogMode('exam', 'audit');
							} else if (row.state === 4) {
								this.$refs.storePsiDetail.setDialogMode('exam', 'pass');
							} else if (row.state === 0) {
								this.$refs.storePsiDetail.setDialogMode('exam', 'submit');
							}

							// 确保快捷调拨模式被禁用
							this.$refs.storePsiDetail.isQuickTransferMode = false;
						}
					}, 50);

				} catch (error) {
					console.error('打开详情失败:', error);
					this.$message.error('打开详情失败');
				}
			},

			// 修改过单方法
			async handlePass(row) {
				try {
					// 先关闭对话框（如果已打开）
					if (this.detailDialogVisible) {
						this.detailDialogVisible = false;
						await this.$nextTick();
					}

					this.currentPlanId = row.id;
					this.detailMode = 'exam';

					// 修复：直接传递库房信息给子组件
					this.$nextTick(() => {
						if (this.$refs.storePsiDetail) {
							this.$refs.storePsiDetail.currentWarehouse = this.queryForm.warehouse;
						}
					});

					// 添加延迟，确保DOM更新完成
					setTimeout(() => {
						this.detailDialogVisible = true;

						// 关键修改：确保子组件正确设置过单模式类型
						if (this.$refs.storePsiDetail) {
							// 先强制设置模式为 exam
							this.$refs.storePsiDetail.setDialogMode('exam', 'pass');

							// 确保快捷调拨模式被禁用
							this.$refs.storePsiDetail.isQuickTransferMode = false;
						}
					}, 50);

				} catch (error) {
					console.error('打开详情失败:', error);
					this.$message.error('打开详情失败');
				}
			},
			// 导出功能 - 优化版本
			  async handleExport() {
			    this.$confirm('确定要导出采购入库数据吗？', '导出确认', {
			      confirmButtonText: '确定导出',
			      cancelButtonText: '取消',
			      type: 'warning'
			    }).then(async () => {
			      await this.handleExportData();
			    }).catch(() => {
			      this.$message.info('已取消导出');
			    });
			  },
			
			  // 执行导出
			  async handleExportData() {
			    this.exporting = true;
			    this.exportProgress = 0;
			
			    try {
			      // 开始进度模拟
			      this.startExportProgress();
			
			      // 构建查询参数
			      const params = {
			        warehouse: this.queryForm.warehouse,
			        docNum: this.queryForm.docNum,
			        drugName: this.queryForm.goodsInfo,
			        startDate: this.queryForm.createTime[0] ? this.formatDateForApi(this.queryForm.createTime[0]) : '',
			        endDate: this.queryForm.createTime[1] ? this.formatDateForApi(this.queryForm.createTime[1]) : '',
			        putinTypeId: this.getPutinTypeIdForApi(),
			        supplierName: this.queryForm.supplier,
			        state: this.queryForm.state === '' ? '' : this.queryForm.state
			      };
			
			      // 移除空参数
			      Object.keys(params).forEach(key => {
			        if (params[key] === '' || params[key] === null || params[key] === undefined) {
			          delete params[key];
			        }
			      });
			
			      // 调用导出接口
			      const response = await exportAllZYWmDrugDgs(params);
			
			      if (response) {
			        await this.processExportData(response);
			        this.$message.success('导出成功，文件正在下载中...');
			      } else {
			        this.$message.error('导出数据为空');
			      }
			    } catch (error) {
			      console.error('导出失败:', error);
			      this.$message.error('导出失败: ' + (error.message || '未知错误'));
			      
			      // 尝试处理可能的错误响应
			      try {
			        if (error.response && error.response.data) {
			          const errorData = error.response.data;
			          if (typeof errorData === 'string' && errorData.includes('{')) {
			            const errorInfo = JSON.parse(errorData);
			            this.$message.error(errorInfo.message || errorInfo.msg || '导出接口返回错误');
			          }
			        }
			      } catch (parseError) {
			        // 忽略解析错误
			      }
			    } finally {
			      this.finishExport();
			    }
			  },
			
			  // 开始导出进度模拟
			  startExportProgress() {
			    this.exportProgress = 0;
			    this.exportTimer = setInterval(() => {
			      if (this.exportProgress < 90) {
			        this.exportProgress += 10;
			      }
			    }, 300);
			  },
			
			  // 完成导出
			  finishExport() {
			    this.exportProgress = 100;
			    setTimeout(() => {
			      if (this.exportTimer) {
			        clearInterval(this.exportTimer);
			        this.exportTimer = null;
			      }
			      this.exporting = false;
			      this.exportProgress = 0;
			    }, 500);
			  },
			
			// 处理导出数据
			async processExportData(blobData) {
			  try {
			    // 检查blobData是否为有效的Blob对象
			    if (!(blobData instanceof Blob)) {
			      console.error('返回的数据不是Blob对象:', typeof blobData);
			      
			      // 尝试将数据转换为文本，检查是否是错误信息
			      if (typeof blobData === 'string') {
			        try {
			          const errorInfo = JSON.parse(blobData);
			          this.$message.error(errorInfo.message || errorInfo.msg || '导出接口返回错误信息');
			        } catch (e) {
			          this.$message.error('导出数据格式错误: ' + blobData.substring(0, 100));
			        }
			      } else {
			        this.$message.error('导出数据格式不正确，请联系管理员');
			      }
			      return false;
			    }
			
			    // 检查Blob的大小，如果太小可能是错误信息
			    if (blobData.size < 100) {
			      const text = await this.blobToText(blobData);
			      try {
			        const errorInfo = JSON.parse(text);
			        this.$message.error(errorInfo.message || errorInfo.msg || '导出数据为空或格式错误');
			      } catch (e) {
			        console.log('Blob内容:', text);
			        this.$message.error('导出文件可能已损坏，请联系管理员');
			      }
			      return false;
			    }
			
			    // 验证文件类型
			    const isValidExcel = blobData.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
			                       blobData.type === 'application/vnd.ms-excel' ||
			                       blobData.type === 'application/octet-stream';
			
			    if (!isValidExcel) {
			      // 可能是错误信息，尝试读取
			      const text = await this.blobToText(blobData);
			      try {
			        const errorInfo = JSON.parse(text);
			        this.$message.error(errorInfo.message || errorInfo.msg || '导出失败');
			      } catch (e) {
			        this.$message.error('服务器返回非Excel文件: ' + text.substring(0, 200));
			      }
			      return false;
			    }
			
			    // 创建下载链接
			    const url = window.URL.createObjectURL(blobData);
			    const link = document.createElement('a');
			
			    // 生成文件名
			    const warehouseName = this.getWarehouseName(this.queryForm.warehouse);
			    const timestamp = new Date();
			    const dateStr = timestamp.toLocaleDateString('zh-CN', {
			      year: 'numeric',
			      month: '2-digit',
			      day: '2-digit'
			    }).replace(/\//g, '');
			    
			    const timeStr = timestamp.toLocaleTimeString('zh-CN', {
			      hour: '2-digit',
			      minute: '2-digit',
			      second: '2-digit'
			    }).replace(/:/g, '');
			
			    const fileName = `${warehouseName}入库导入_${dateStr}_${timeStr}.xlsx`;
			
			    // 设置下载属性
			    link.href = url;
			    link.download = fileName;
			    link.style.display = 'none';
			
			    // 添加到DOM并触发点击
			    document.body.appendChild(link);
			    
			    // 添加点击事件处理，确保下载完成后再清理
			    link.onclick = () => {
			      setTimeout(() => {
			        document.body.removeChild(link);
			        window.URL.revokeObjectURL(url);
			      }, 100);
			    };
			    
			    link.click();
			
			    console.log('文件下载信息:', {
			      文件大小: blobData.size + ' bytes',
			      文件类型: blobData.type,
			      文件名: fileName
			    });
			
			    return true;
			
			  } catch (error) {
			    console.error('处理导出数据失败:', error);
			    
			    // 尝试将错误信息转换为可读格式
			    if (error.response && error.response.data) {
			      try {
			        const errorText = await this.blobToText(error.response.data);
			        const errorInfo = JSON.parse(errorText);
			        this.$message.error(errorInfo.message || errorInfo.msg || '导出处理失败');
			      } catch (parseError) {
			        this.$message.error('导出失败: ' + error.message);
			      }
			    } else {
			      this.$message.error('导出失败: ' + (error.message || '未知错误'));
			    }
			    return false;
			  }
			},
			
			// 新增：Blob转文本工具方法
			blobToText(blob) {
			  return new Promise((resolve, reject) => {
			    const reader = new FileReader();
			    reader.onload = () => resolve(reader.result);
			    reader.onerror = reject;
			    reader.readAsText(blob);
			  });
			},
			
			  // 批量导出选中的数据
			  async handleBatchExport() {
			    if (this.selectedRows.length === 0) {
			      this.$message.warning('请先选择要导出的采购入库单');
			      return;
			    }
			
			    this.$confirm(`确定要导出选中的 ${this.selectedRows.length} 条采购入库单吗？`, '批量导出确认', {
			      confirmButtonText: '确定导出',
			      cancelButtonText: '取消',
			      type: 'warning'
			    }).then(async () => {
			      await this.handleBatchExportData();
			    }).catch(() => {
			      this.$message.info('已取消导出');
			    });
			  },
			
			  // 执行批量导出
			  async handleBatchExportData() {
			    this.exporting = true;
			    this.exportProgress = 0;
			
			    try {
			      this.startExportProgress();
			
			      // 获取选中行的ID
			      const selectedIds = this.selectedRows.map(row => row.id);
			
			      // 构建批量导出参数
			      const params = {
			        ids: selectedIds.join(','),
			        warehouse: this.queryForm.warehouse
			      };
			
			      // 调用批量导出接口（如果接口支持）
			      const response = await exportAllZYWmDrugDgs(params);
			
			      if (response) {
			        await this.processExportData(response);
			        this.$message.success(`成功导出 ${selectedIds.length} 条采购入库单`);
			      } else {
			        this.$message.error('导出数据为空');
			      }
			    } catch (error) {
			      console.error('批量导出失败:', error);
			      this.$message.error('批量导出失败: ' + (error.message || '未知错误'));
			    } finally {
			      this.finishExport();
			    }
			  },
			
			  // 根据条件导出
			  async handleConditionalExport() {
			    this.$confirm('确定要根据当前查询条件导出采购入库数据吗？', '条件导出确认', {
			      confirmButtonText: '确定导出',
			      cancelButtonText: '取消',
			      type: 'warning'
			    }).then(async () => {
			      await this.handleExportData(); // 使用相同的导出逻辑
			    }).catch(() => {
			      this.$message.info('已取消导出');
			    });
			  },
			
			  // 检查是否为 Electron 环境
			    checkIsElectron() {
			      try {
			        // 多种方式检查 Electron 环境
			        this.isElectron = (
			          // 方式1: 检查 window.process
			          (window && window.process && window.process.type) ||
			          // 方式2: 检查 window.electron
			          (window && window.electron) ||
			          // 方式3: 检查用户代理
			          navigator.userAgent.toLowerCase().indexOf(' electron/') > -1 ||
			          // 方式4: 检查特定 Electron 属性
			          (window && window.require && window.require('electron'))
			        ) ? true : false;
			        
			        console.log('当前是否为 Electron 环境:', this.isElectron);
			      } catch (error) {
			        console.log('检查 Electron 环境失败:', error);
			        this.isElectron = false;
			      }
			    },
			// 修改：快捷调拨详情方法
			async handleQuickTransferDetail(row) {
			  // 关键修改：添加入库库房检查
			  if (this.queryForm.warehouse !== 2) {
			    this.$message.warning('快捷调拨功能仅支持中药库操作');
			    return;
			  }
			  
			  if (row.state !== 5) {
			    this.$message.warning('只有已过单的入库单才能进行快捷调拨');
			    return;
			  }
			
			  try {
			    // 设置当前行和模式
			    this.currentRow = row;
			    this.detailMode = 'quickTransfer';
			
			    // 打开详情模态框
			    await this.handleDetail(row);
			
			    // 设置详情对话框的特定模式
			    this.$nextTick(() => {
			      if (this.$refs.storePsiDetail) {
			        this.$refs.storePsiDetail.setDialogMode('quickTransfer');
			      }
			    });
			
			  } catch (error) {
			    console.error('打开快捷调拨详情失败:', error);
			    this.$message.error('打开详情失败');
			  }
			},
			// 新增：在父组件中加载计划详情数据用于审核/过单
			async loadPlanDetailForAudit(planId) {
				try {
					this.detailLoading = true;

					// 调用API获取计划详情
					const response = await getPlanData({
						id: planId
					});

					if (response.code === 200) {
						// 将数据格式化后存储在父组件中
						this.currentPlanData = this.formatDetailDataForAudit(response.data);

						// 如果子组件已经存在，直接设置数据
						if (this.$refs.storePsiDetail) {
							this.$refs.storePsiDetail.setPlanData(this.currentPlanData);
						}
						this.$message.success('获取计划详情成功');
					} else {
						this.$message.error(response.message || '获取计划详情失败');
					}
				} catch (error) {
					////console.error('加载计划详情失败:', error);
					this.$message.error('加载计划详情失败');
				} finally {
					this.detailLoading = false;
				}
			},

			// 新增：格式化详情数据用于审核/过单
			// 格式化详情数据用于审核/过单
			formatDetailDataForAudit(apiData) {
				if (!apiData) return null;

				return {
					id: apiData.id || null,
					docNum: apiData.docNum || '',
					state: apiData.state || 0,
					createName: apiData.createName || apiData.creator || '',
					createTime: apiData.createTime || '',
					remarks: apiData.remarks || apiData.remark || '',
					busDate: apiData.busDate || apiData.invoDate || '',
					supplierName: apiData.supplierName || '',
					purcInvoCodg: apiData.purcInvoCodg || '',
					putinTypeId: apiData.putinTypeId || 1,
					lastRejectReason: apiData.lastRejectReason || '',

					// 处理药品列表数据 - 确保正确映射字段
					list: (apiData.list || []).map(item => ({
						id: item.id,
						drugId: item.drugId,
						name: item.name,
						drugSpecifications: item.drugSpecifications,
						pacSpec: item.pacSpec,
						purcCnt: item.purcCnt || 0,
						purcPric: item.purcPric || 0,
						salePric: item.salePric || 0,
						purcAmt: item.purcAmt || '0.00',
						saleAmt: item.saleAmt || '0.00',
						purcType: item.purcType?.toString() || '2',
						dosUnt: item.dosUnt || '粒',
						pacUnt: item.pacUnt || '盒',
						manuLotnum: item.manuLotnum || '',
						manuDate: item.manuDate || '',
						expyDate: item.expyDate || '',
						prodentpName: item.prodentpName || '',
						prodentpNameId: item.prodentpNameId || '',
						remarks: item.remarks || ''
					}))
				};
			},

			// 添加方法用于直接设置子组件数据
			setDetailData(data) {
				this.currentPlanData = data;
				if (this.detailDialogVisible && this.$refs.storePsiDetail) {
					this.$refs.storePsiDetail.setPlanData(data);
				}
			},
			// 冲销操作 - 添加确认提示
			async handleReverse(row) {
				try {
					this.$confirm('确定要冲销此采购入库吗？此操作将撤销已过单的入库单', '提示', {
						type: 'warning',
						confirmButtonText: '确定冲销',
						cancelButtonText: '取消'
					}).then(async () => {
						// 调用冲销接口
						const response = await dugDoctoZYFExamine({
							id: row.id,
							state: 6 // 冲销状态
						});

						if (response.code === 200) {
							this.$message.success('冲销成功');
							// 重新加载数据以更新状态
							this.loadData();
						} else {
							this.$message.error(response.message || '冲销失败');
						}
					}).catch(() => {
						this.$message.info('已取消冲销操作');
					});
				} catch (error) {
					////console.error('冲销采购入库失败:', error);
					this.$message.error('冲销失败');
				}
			},

			// 详情方法
			async handleDetail(row) {
				try {
					// 先关闭对话框（如果已打开）
					if (this.detailDialogVisible) {
						this.detailDialogVisible = false;
						await this.$nextTick();
					}

					this.currentPlanId = row.id;
					this.detailMode = 'view';

					// 根据当前库房选择详情接口
					const detailApi = this.queryForm.warehouse == 4 ? dugDocgetZYFDrugDetails : dugDocgetZYFDrugDetails;

					// 检查是否有缓存数据
					if (this.cachedPurchaseData && this.cachedPurchaseData.id === row.id) {
						// 使用缓存数据
						this.$nextTick(() => {
							if (this.$refs.storePsiDetail) {
								this.$refs.storePsiDetail.setPlanData(this.cachedPurchaseData);
								// 修复：直接设置warehouse属性，而不是调用setWarehouse方法
								this.$refs.storePsiDetail.currentWarehouse = this.queryForm.warehouse;
							}
						});
					} else {
						// 加载新数据
						const response = await detailApi({
							id: row.id
						});
						if (response.code === 200 && response.data) {
							this.cachedPurchaseData = response.data;
							this.$nextTick(() => {
								if (this.$refs.storePsiDetail) {
									this.$refs.storePsiDetail.setPlanData(response.data);
									// 修复：直接设置warehouse属性
									this.$refs.storePsiDetail.currentWarehouse = this.queryForm.warehouse;
								}
							});
						}
					}

					// 直接打开模态框
					this.detailDialogVisible = true;

				} catch (error) {
					console.error('打开详情失败:', error);
					this.$message.error('打开详情失败');
				}
			},

			// 提交方法 - 确保传递正确的数据
			// 修改：优化加载采购详情方法，添加缓存和防重复逻辑
			async loadPurchaseDetailForSubmit(purchaseId) {
				try {
					this.detailLoading = true;

					// 新增：检查是否正在请求相同ID的数据
					if (this.currentLoadingId === purchaseId && this.isLoading) {
						console.log('正在加载相同ID的数据，跳过重复请求');
						return;
					}

					// 设置当前加载ID和状态
					this.currentLoadingId = purchaseId;
					this.isLoading = true;

					// 调用获取采购入库详情接口
					const response = await dugDocgetZYFDrugDetails({
						id: purchaseId
					});

					if (response.code === 200 && response.data) {
						// 关键修改：一次性处理所有数据，避免多次调用
						await this.fillPurchaseFormFromDetail(response.data);
						this.$message.success('采购入库详情数据加载成功');

						// 缓存数据，避免重复加载
						this.cachedPurchaseData = response.data;
					} else {
						this.$message.error(response.message || '获取采购入库详情失败');
					}
				} catch (error) {
					console.error('加载采购入库详情失败:', error);
					this.$message.error('加载采购入库详情失败');
				} finally {
					this.detailLoading = false;
					this.isLoading = false;
				}
			},

			// 新增：从详情数据填充采购入库表单
			// 修改：优化填充采购表单方法，批量处理明细数据
			async fillPurchaseFormFromDetail(detailData) {
				try {
					// 清空现有的药品列表
					this.goodsList = [];

					// 填充采购表单基本信息
					this.purchaseForm = {
						warehouse: detailData.shedId || this.queryForm.warehouse,
						busDate: detailData.invoDate || new Date().toISOString().split('T')[0],
						supplierId: detailData.supplyCandidateId || '',
						supplierName: detailData.supplierName || '',
						purcInvoCodg: detailData.purcInvoCodg || '',
						supplyCode: detailData.supplyCode || '',
						putinTypeId: detailData.putinTypeId || 1,
						remark: detailData.remarks || '',
						totalAmt: detailData.costAmt || '0.00',
						docNum: detailData.docNum || ''
					};

					// 关键修改：批量处理药品明细，避免多次异步调用
					if (detailData.list && Array.isArray(detailData.list)) {
						// 使用Promise.all批量处理所有药品明细
						const goodsPromises = detailData.list.map(async (item, index) => {
							// 添加延迟，避免同时发起大量请求
							if (index > 0) {
								await new Promise(resolve => setTimeout(resolve, 10));
							}
							return await this.createDetailRow(item);
						});

						// 等待所有药品明细处理完成
						const goodsResults = await Promise.all(goodsPromises);

						// 一次性添加到商品列表
						this.goodsList = goodsResults.filter(item => item !== null);
					}

					// 计算合计金额
					this.calculateTotalCost();
					this.calculateTotalSale();

					// 设置编辑模式（因为提交时需要查看数据，不可编辑）
					this.isEditMode = false;

				} catch (error) {
					console.error('填充采购表单失败:', error);
					this.$message.error('填充采购表单失败');
				}
			},

			// 新增：创建详情行数据
			// 修改：优化创建详情行方法，减少不必要的异步调用
			async createDetailRow(item) {
				try {
					const newRow = {
						id: item.id || Date.now(),
						drugId: item.drugId,
						name: item.name,
						drugSpecifications: item.drugSpecifications,
						pacSpec: item.pacSpec,
						purcCnt: item.purcCnt || 1,
						purcPric: item.purcPric || 0,
						salePric: item.salePric || 0,
						purcAmt: item.purcAmt || '0.00',
						saleAmt: item.saleAmt || '0.00',
						manuLotnum: item.manuLotnum || '',
						manuDate: item.manuDate || '',
						expyDate: item.expyDate || '',
						prodentpNameId: this.safeParseInt(item.prodentpNameId),
						manufacturerOptions: [],
						drugLoading: false,
						priceLoading: false,
						purcType: item.purcType?.toString() || '2',
						markUpId: item.markUpId?.toString() || '1',
						markUpRate: item.markUpRate || 0,
						markUpPric: item.markUpPric || 0,
						dosUnt: item.dosUnt || '粒',
						pacUnt: item.pacUnt || '盒',
						pacCnt: item.pacCnt || 1,
						unitDisplay: item.purcType?.toString() === '1' ?
							(item.dosUnt || '粒') : (item.pacUnt || '盒'),
						putinTypeId: item.putinTypeId || 1,
						$errors: {}
					};

					// 关键修改：合并药品信息加载，减少请求次数
					await this.loadDrugAndManufacturerInfo(newRow);

					return newRow;
				} catch (error) {
					console.error('创建详情行失败:', error);
					return null;
				}
			},
			// 新增：加载药品信息的方法
			async loadDrugInfo(drugId) {
				let pamr = {
				  name: this.searchValue,
				  pageNum: this.pageNum,
				  pageSize : this.pageSize
				}
				try {
					return await getWareZY(pamr);
				} catch (error) {
					console.error('加载药品信息失败:', error);
					return null;
				}
			},

			// 新增：加载厂家信息的方法
			async loadManufacturerInfo(drugId) {
				try {
					return await getProdentZY({
						drugId: drugId
					});
				} catch (error) {
					console.error('加载厂家信息失败:', error);
					return null;
				}
			},
			// 新增：合并加载药品和厂家信息的方法
			async loadDrugAndManufacturerInfo(row) {
				try {
					// 如果已经有药品ID，同时加载药品信息和厂家信息
					if (row.drugId) {
						// 并行加载药品信息和厂家信息
						const [drugResponse, manufacturerResponse] = await Promise.all([
							// this.loadDrugInfo(row.drugId),
							// this.loadManufacturerInfo(row.drugId)
						]);

						// 处理药品信息
						if (drugResponse && drugResponse.code === 200) {
							const drugOptions = drugResponse.data.content || drugResponse.data.list || [];
							const selectedDrug = drugOptions.find(drug => drug.id === row.drugId);

							if (selectedDrug) {
								row.name = selectedDrug.name || row.name;
								row.drugSpecifications = selectedDrug.drugSpecifications || row.drugSpecifications;
								row.pacSpec = selectedDrug.pacSpec || row.pacSpec;
								row.dosUnt = selectedDrug.dosUnt || '粒';
								row.pacUnt = selectedDrug.pacUnt || '盒';
								row.pacCnt = selectedDrug.pacCnt || 1;
							}
						}

						// 处理厂家信息
						if (manufacturerResponse && manufacturerResponse.code === 200) {
							const manufacturers = manufacturerResponse.data || manufacturerResponse.data.list || [];
							row.manufacturerOptions = manufacturers;

							// 如果当前行有选中的生产厂家，确保选项中存在
							if (row.prodentpNameId) {
								const selectedManufacturer = manufacturers.find(prod => prod.id === row
									.prodentpNameId);
								if (!selectedManufacturer) {
									await this.loadManufacturerById(row.prodentpNameId, row);
								}
							}
						}
					}
				} catch (error) {
					console.error('加载药品和厂家信息失败:', error);
				}
			},
			// 新增：为详情加载药品信息
			async loadDrugDetailsForDetail(drugId, row) {
				let pamr = {
				  name: this.searchValue,
				  pageNum: this.pageNum,
				  pageSize : this.pageSize
				}
				try {
					const drugResponse = await getWareZY(pamr);
					if (drugResponse.code === 200) {
						const drugOptions = drugResponse.data.content || drugResponse.data.list || [];
						const selectedDrug = drugOptions.find(drug => drug.id === drugId);

						if (selectedDrug) {
							// 更新药品信息
							row.name = selectedDrug.name || row.name;
							row.drugSpecifications = selectedDrug.drugSpecifications || row.drugSpecifications;
							row.pacSpec = selectedDrug.pacSpec || row.pacSpec;
							row.dosUnt = selectedDrug.dosUnt || '粒';
							row.pacUnt = selectedDrug.pacUnt || '盒';
							row.pacCnt = selectedDrug.pacCnt || 1;
						}
					}
				} catch (error) {
					console.error('加载药品详情失败:', error);
				}
			},

			// 新增：为详情加载生产厂家选项
			async loadManufacturerOptionsForDetail(drugId, row) {
				try {
					const response = await getProdentZY({
						drugId: drugId
					});

					if (response.code === 200) {
						const manufacturers = response.data || response.data.list || [];
						row.manufacturerOptions = manufacturers;

						// 如果当前行有选中的生产厂家，确保选项中存在
						if (row.prodentpNameId) {
							const selectedManufacturer = manufacturers.find(prod => prod.id === row.prodentpNameId);
							if (!selectedManufacturer) {
								// 如果选中的厂家不在选项中，尝试单独加载
								await this.loadManufacturerById(row.prodentpNameId, row);
							}
						}
					}
				} catch (error) {
					console.error('加载生产厂家选项失败:', error);
				}
			},
			// 新增：格式化详情数据，确保与子组件数据结构匹配
			formatDetailData(apiData) {
				if (!apiData) return null;

				return {
					id: apiData.id || null,
					docNum: apiData.docNum || '', // 入库编号
					state: apiData.state || 0,
					createName: apiData.createName || apiData.creator || '',
					createTime: apiData.createTime || '',
					remarks: apiData.remarks || apiData.remark || '',
					applicantName: apiData.applicantName || apiData.createName || '',
					totalPurCnt: apiData.totalPurCnt || 0,
					auditor: apiData.auditor || '',
					auditTime: apiData.auditTime || '',
					lastRejectReason: apiData.lastRejectReason || '',
					email: apiData.email || '',
					applicantId: apiData.applicantId || '',
					putInDep: apiData.putInDep || '',

					// 处理药品列表数据
					list: (apiData.list || []).map(item => ({
						drugId: item.drugId,
						name: item.name,
						drugCode: item.drugCode,
						drugSpecifications: item.drugSpecifications,
						prodentpName: item.prodentpName,
						prodentpNameId: item.prodentpNameId,
						purCnt: item.purCnt || item.purcCnt || 0,
						purcPric: item.purcPric || 0,
						purcType: item.purcType || 2,
						remarks: item.remarks || '',
						stockCnt: item.stockCnt || 0,
						supplyCandidateId: item.supplyCandidateId,
						applicantId: item.applicantId || apiData.applicantId,
						putInDep: item.putInDep || apiData.putInDep
					}))
				};
			},

			// 准备商品列表数据
			prepareGoodsListData(row) {
				// 这里需要根据实际数据结构进行调整
				// 假设row包含药品明细信息
				if (row.list && Array.isArray(row.list)) {
					return row.list.map(item => ({
						drugId: item.drugId,
						name: item.name,
						drugCode: item.drugCode,
						drugSpecifications: item.drugSpecifications,
						prodentpName: item.prodentpName,
						prodentpNameId: item.prodentpNameId,
						purCnt: item.purcCnt || 0,
						purcPric: item.purcPric || 0,
						purcType: item.purcType || 2,
						remarks: item.remarks || '',
						stockCnt: item.stockCnt || 0,
						supplyCandidateId: item.supplyCandidateId
					}));
				}

				// 如果row本身就是一个药品条目，则包装成数组
				return [{
					drugId: row.drugId,
					name: row.name,
					drugCode: row.drugCode,
					drugSpecifications: row.drugSpecifications,
					prodentpName: row.prodentpName,
					prodentpNameId: row.prodentpNameId,
					purCnt: row.purcCnt || 0,
					purcPric: row.purcPric || 0,
					purcType: row.purcType || 2,
					remarks: row.remarks || '',
					stockCnt: row.stockCnt || 0,
					supplyCandidateId: row.supplyCandidateId
				}];
			},

			// 入库批量导入
			handleBatchApprove() {
				this.handleExcelImport();
			},

			// 打开Excel导入对话框
			handleExcelImport() {
				this.excelDialogVisible = true;
				this.resetImportData();
			},

			// 上传前校验
			beforeExcelUpload(file) {
				const isExcel = file.type.includes('excel') ||
					file.name.endsWith('.xlsx') ||
					file.name.endsWith('.xls');
				const isLt10M = file.size / 1024 / 1024 < 10;

				if (!isExcel) {
					this.$message.error('只能上传Excel文件!');
					return false;
				}
				if (!isLt10M) {
					this.$message.error('文件大小不能超过10MB!');
					return false;
				}
				return true;
			},

			// 处理文件变化
			// 修改：处理文件变化
			handleExcelChange(file, fileList) {
				if (fileList.length > 1) {
					this.excelFileList = [fileList[fileList.length - 1]];
					return;
				}

				this.excelFileList = fileList;
				this.filePath = file.name;
				this.excelRawFile = file.raw;

				// 清空之前的错误信息
				this.errorData = [];
				this.errorCount = 0;

				// 启用立即执行按钮
				this.isSubmitDisabled = false;

				// 更新文件列表
				this.fileList = [{
					name: file.name,
					path: file.name,
					status: '待处理'
				}];

				// 读取Excel内容
				this.readExcel(file.raw);
			},

			// 重新选择文件
			reSelectFile() {
				this.resetImportData();
			},

			// 移除文件
			removeFile(row) {
				// 清空所有相关数据
				this.excelFileList = [];
				this.excelTableData = [];
				this.excelColumns = [];
				this.fileList = [];
				this.filePath = '';
				this.errorData = [];
				this.errorCount = 0;

				// 重置原始文件对象
				this.excelRawFile = null;

				this.$message.info('文件已删除，请重新上传新文件');
			},

			// 读取Excel文件
			readExcel(file) {
				this.loading = true;
				const reader = new FileReader();

				reader.onload = (e) => {
					try {
						const data = new Uint8Array(e.target.result);
						const workbook = XLSX.read(data, {
							type: 'array'
						});

						const firstSheetName = workbook.SheetNames[0];
						const worksheet = workbook.Sheets[firstSheetName];

						const jsonData = XLSX.utils.sheet_to_json(worksheet);

						if (!jsonData || jsonData.length === 0) {
							this.$message.warning('Excel文件没有数据');
							return;
						}

						// 处理表头
						this.excelColumns = Object.keys(jsonData[0]).map(key => ({
							prop: key,
							label: key,
							width: 150
						}));

						this.excelTableData = jsonData;
						this.fileList[0].status = '导入成功';

						this.$message.success('Excel解析成功');
					} catch (error) {
						////console.error('Excel解析错误:', error);
						this.fileList[0].status = '失败';
						this.$message.error('Excel文件解析失败: ' + error.message);
					} finally {
						this.loading = false;
					}
				};

				reader.onerror = (error) => {
					////console.error('文件读取错误:', error);
					this.fileList[0].status = '失败';
					this.$message.error('文件读取失败');
					this.loading = false;
				};

				reader.readAsArrayBuffer(file);
			},

			// 提交Excel数据
			// 修改：提交Excel数据
			async submitExcel() {
				if (!this.excelRawFile) {
					this.$message.warning('请先上传Excel文件');
					return;
				}

				// 开启全局loading
				this.loading = true;
				// 禁用立即执行按钮
				this.isSubmitDisabled = true;

				try {
					const formData = new FormData();
					formData.append('file', this.excelRawFile);
					formData.append('type', 'western');
					formData.append('clinicId', this.$store.getters.clinicId || '');

					// 调用导入接口
					const response = await importZYExcel(formData);

					if (response.code === 200) {
						// 关键修改：根据接口返回的数据结构处理
						if (response.data && Object.keys(response.data).length > 0) {
							// 有错误数据，显示错误信息，不关闭模态框
							this.handleImportErrors(response.data);

							// 计算成功和失败数量
							const totalCount = this.excelTableData.length;
							const errorCount = Object.keys(response.data).length;
							const successCount = totalCount - errorCount;

							this.$message.warning(`导入完成！成功 ${successCount} 条，失败 ${errorCount} 条`);

							// 即使有错误数据，也要刷新主表格（因为部分数据可能导入成功）
							this.loadData();

						} else {
							// 没有错误数据，表示全部导入成功
							this.handleImportSuccess();
						}
					} else {
						this.$message.error(response.message || '导入失败');
					}
				} catch (error) {
					console.error('导入失败:', error);
					this.$message.error('导入失败: ' + (error.message || '网络错误'));
				} finally {
					// 关闭loading，但保持按钮禁用状态直到重新上传文件
					this.loading = false;
				}
			},
			// 修改：处理导入成功
			// 新增：处理导入成功
			handleImportSuccess() {
				this.$message.success('Excel导入成功！');

				// 关闭模态框
				this.excelDialogVisible = false;

				// 清空所有数据
				this.resetImportData();

				// 刷新主表格数据
				this.loadData();
			},

			// 新增：重置导入数据（扩展版）
			resetImportData() {
				this.excelFileList = [];
				this.excelTableData = [];
				this.excelColumns = [];
				this.fileList = [];
				this.filePath = '';
				this.errorData = [];
				this.errorCount = 0;
				this.excelRawFile = null;
				this.isSubmitDisabled = true; // 保持禁用直到重新上传
				this.currentPage = 1;
			},
			// 新增：提取错误信息
			extractErrorMessages(errorData) {
				if (!errorData) return '未知错误';

				// 如果errorData是字符串，直接返回
				if (typeof errorData === 'string') {
					return errorData;
				}

				// 如果errorData是数组，提取所有错误信息
				if (Array.isArray(errorData)) {
					return errorData.map(item => {
						if (typeof item === 'string') return item;
						if (item.message) return item.message;
						if (item.msg) return item.msg;
						return JSON.stringify(item);
					}).join('; ');
				}

				// 如果errorData是对象，提取message或msg字段
				if (typeof errorData === 'object') {
					if (errorData.message) return errorData.message;
					if (errorData.msg) return errorData.msg;

					// 尝试提取其他可能的错误信息字段
					const possibleErrorFields = ['error', 'errMsg', 'errorMessage', 'detail'];
					for (const field of possibleErrorFields) {
						if (errorData[field]) {
							return errorData[field];
						}
					}

					// 如果找不到明确的错误信息字段，返回整个对象
					return JSON.stringify(errorData);
				}

				return '未知错误类型';
			},

			// 修改：处理导入错误信息
			// 修改：处理导入错误信息，确保行号从1开始
			handleImportErrors(errorData) {
				this.errorData = [];
				this.errorCount = 0;

				try {
					console.log('原始错误数据:', errorData);

					if (typeof errorData === 'object' && errorData !== null) {
						Object.entries(errorData).forEach(([rowNumber, errorInfo]) => {
							const rowIndex = parseInt(rowNumber);
							const originalRow = this.excelTableData[rowIndex] || {}; // 注意：这里使用rowIndex直接对应数据行

							// 创建错误行数据，行号从1开始显示
							const errorRow = {
								id: this.errorData.length + 1,
								rowNumber: rowIndex, // 存储原始行索引（从0开始）
								displayRowNumber: rowIndex + 1, // 新增：显示行号（从1开始）
								errorInfo: errorInfo.msg || this.formatErrorInfo(errorInfo),
								_rawError: errorInfo
							};

							// 动态添加预览表格的所有字段
							this.excelColumns.forEach(col => {
								errorRow[col.prop] = originalRow[col.prop] || '--';
							});

							this.errorData.push(errorRow);
						});

						this.errorCount = this.errorData.length;
					}

					console.log('处理后的错误数据:', this.errorData);

				} catch (error) {
					console.error('处理错误信息失败:', error);
					this.errorData = [{
						id: 1,
						rowNumber: 0,
						displayRowNumber: 1,
						errorInfo: '处理错误信息时发生异常: ' + error.message,
						_rawError: error
					}];

					// 添加预览表格的字段
					this.excelColumns.forEach(col => {
						this.errorData[0][col.prop] = '--';
					});

					this.errorCount = 1;
				}

				// 数据驱动更新 - 强制重新渲染错误表格
				this.$forceUpdate();
			},

			// 新增：格式化错误信息
			formatErrorInfo(errorInfo) {
				if (typeof errorInfo === 'string') {
					return errorInfo;
				} else if (typeof errorInfo === 'object') {
					// 尝试从常见错误字段中提取错误信息
					const errorMessage = errorInfo.message || errorInfo.msg || errorInfo.error ||
						errorInfo.reason || errorInfo.desc || errorInfo.description;

					if (errorMessage) {
						return errorMessage;
					}

					// 如果是数组，拼接所有错误信息
					if (Array.isArray(errorInfo)) {
						return errorInfo.map(err => this.formatErrorInfo(err)).join('; ');
					}

					// 尝试转换为字符串
					try {
						return JSON.stringify(errorInfo);
					} catch (e) {
						return '未知错误格式';
					}
				}
				return '未知错误';
			},
			//  下载错误信息Excel
			// 修改：下载错误信息Excel，行号从1开始
			async downloadErrorExcel() {
				if (this.errorData.length === 0) {
					this.$message.warning('没有错误信息可下载');
					return;
				}

				this.downloadingError = true;

				try {
					// 创建工作簿
					const workbook = XLSX.utils.book_new();

					// 准备错误数据 - 行号从1开始
					const errorDataForExport = this.errorData.map((errorRow, index) => {
						const exportRow = {
							'行号': errorRow.displayRowNumber || (index + 1) // 使用显示行号或索引+1
						};

						// 添加预览表格的所有字段
						this.excelColumns.forEach(col => {
							exportRow[col.label] = errorRow[col.prop] || '--';
						});

						// 添加错误原因
						exportRow['错误原因'] = errorRow.errorInfo || '未知错误';

						return exportRow;
					});

					// 创建工作表
					const worksheet = XLSX.utils.json_to_sheet(errorDataForExport);

					// 设置列宽
					const colWidths = [{
							wch: 8
						}, // 行号
					];

					// 添加预览表格列的宽度
					this.excelColumns.forEach(col => {
						colWidths.push({
							wch: col.width ? col.width / 10 : 15
						});
					});

					// 错误原因列宽度
					colWidths.push({
						wch: 40
					});

					worksheet['!cols'] = colWidths;

					// 添加工作表到工作簿
					XLSX.utils.book_append_sheet(workbook, worksheet, '导入错误信息');

					// 生成Excel文件
					const excelBuffer = XLSX.write(workbook, {
						bookType: 'xlsx',
						type: 'array'
					});

					// 创建Blob并下载
					const blob = new Blob([excelBuffer], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});
					const url = URL.createObjectURL(blob);
					const link = document.createElement('a');

					// 生成带时间戳的文件名
					this.watermarkText = localStorage.getItem('watermarkText') || '中药库';
					const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
					const fileName = `${this.watermarkText}入库导入错误信息_${timestamp}.xlsx`;

					link.href = url;
					link.download = fileName;
					document.body.appendChild(link);
					link.click();

					// 清理
					setTimeout(() => {
						document.body.removeChild(link);
						URL.revokeObjectURL(url);
					}, 100);

					this.$message.success(`错误信息Excel文件已下载，共 ${this.errorData.length} 条错误记录`);

				} catch (error) {
					console.error('下载错误信息失败:', error);
					this.$message.error('下载错误信息失败: ' + error.message);
				} finally {
					this.downloadingError = false;
				}
			},

			// 修改：复制错误信息，包含所有字段
			copyErrorInfo(row) {
				// 构建包含所有字段的错误信息文本
				let errorText = `行号: ${row.rowNumber || '未知'}\n`;

				// 添加预览表格的所有字段
				this.excelColumns.forEach(col => {
					errorText += `${col.label}: ${row[col.prop] || '--'}\n`;
				});

				errorText += `错误原因: ${row.errorInfo || '未知错误'}`;

				// 使用Clipboard API（现代浏览器）
				if (navigator.clipboard && window.isSecureContext) {
					navigator.clipboard.writeText(errorText).then(() => {
						this.$message.success('错误信息已复制到剪贴板');
					}).catch(err => {
						// 降级方案
						this.fallbackCopyText(errorText);
					});
				} else {
					// 降级方案
					this.fallbackCopyText(errorText);
				}
			},

			// 降级复制方案
			fallbackCopyText(text) {
				const textArea = document.createElement('textarea');
				textArea.value = text;
				textArea.style.position = 'fixed';
				textArea.style.top = 0;
				textArea.style.left = 0;
				textArea.style.opacity = 0;
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					const successful = document.execCommand('copy');
					if (successful) {
						this.$message.success('错误信息已复制到剪贴板');
					} else {
						this.$message.error('复制失败，请手动复制');
					}
				} catch (err) {
					this.$message.error('复制失败: ' + err);
				}

				document.body.removeChild(textArea);
			},
			// 显示错误详情
			showErrorDetails(errorData) {
				// 这里可以打开一个模态框显示详细的错误信息
				let errorMessage = '导入错误详情:\n\n';

				if (Array.isArray(errorData)) {
					errorData.forEach((error, index) => {
						errorMessage += `${index + 1}. ${this.formatError(error)}\n`;
					});
				} else if (typeof errorData === 'object') {
					Object.entries(errorData).forEach(([key, value], index) => {
						errorMessage += `${index + 1}. ${key}: ${this.formatError(value)}\n`;
					});
				}

				// 使用Element UI的alert显示错误详情
				this.$alert(errorMessage, '导入错误详情', {
					confirmButtonText: '确定',
					customClass: 'error-details-dialog',
					dangerouslyUseHTMLString: false
				});
			},

			handleBatchDelete() {
				if (this.selectedRows.length === 0) {
					this.$message.warning('请选择要删除的采购入库');
					return;
				}
				this.$confirm(`确定要删除选中的 ${this.selectedRows.length} 条采购入库吗？`, '提示', {
					type: 'warning'
				}).then(() => {
					this.$message.success('批量删除成功');
					this.selectedRows = [];
				});
			},

			// 快速调拨
			async handleQuickTransfer() {
			  // 关键修改：检查入库库房
			  if (this.queryForm.warehouse !== 2) {
			    this.$message.warning('快捷调拨功能仅支持中药库操作');
			    return;
			  }
			  
				// 检查所选行是否都是已过单状态
				const invalidRows = this.selectedRows.filter(row => row.state != 5);
				if (invalidRows.length > 0) {
					this.$message.warning('只能选择已过单的入库单进行调拨操作');
					return;
				}

				// 新增：检查是否只选择了一行（因为接口只支持单行调拨）
				if (this.selectedRows.length !== 1) {
					this.$message.warning('快速调拨功能目前只支持单条入库单操作');
					return;
				}

				try {
					// 直接调用快速调拨接口，不需要打开对话框
					await this.confirmQuickTransfer();
				} catch (error) {
					console.error('快速调拨失败:', error);
					this.$message.error('快速调拨失败，请检查网络连接或联系管理员');
				}
			},

			// 修改：确认调拨方法，简化参数传递
			async confirmQuickTransfer() {
				if (this.selectedRows.length !== 1) {
					this.$message.warning('请选择一条入库单进行调拨');
					return;
				}

				const selectedRow = this.selectedRows[0];
				const id = selectedRow.id;

				// 确认对话框
				this.$confirm(`确定要对入库单 "${selectedRow.docNum}" 进行快速调拨吗？`, '确认调拨', {
					type: 'warning',
					confirmButtonText: '确定调拨',
					cancelButtonText: '取消'
				}).then(async () => {
					try {
						this.transferLoading = true;

						// 调用接口，只传递id参数
						const response = await ZYfastTransfer({
							id: id
						});

						if (response.code === 200) {
							this.$message.success('调拨成功');
							this.loadData(); // 刷新数据
							this.selectedRows = []; // 清空选中
							this.isQuickTransferEnabled = false;
						} else {
							console.error('调拨接口返回错误:', response);
							this.$message.error(response.message || '调拨失败');
						}
					} catch (error) {
						console.error('调拨操作失败:', error);
						this.$message.error('调拨操作失败，请检查网络连接或联系管理员');
					} finally {
						this.transferLoading = false;
					}
				}).catch(() => {
					this.$message.info('已取消调拨操作');
				});
			},

			// 修改：打开快速调拨对话框
			async openQuickTransferDialog() {
				// 重置调拨数据
				this.resetTransferData();

				// 设置调出药库为当前选中的药库
				this.quickTransferForm.fromWarehouse = this.queryForm.warehouse;

				// 加载选中的数据到调拨明细
				await this.loadSelectedRowsToTransfer();

				// 打开对话框
				this.showQuickTransferDialog = true;
			},

			resetTransferData() {
				this.quickTransferForm = {
					fromWarehouse: this.queryForm.warehouse,
					toWarehouse: 4, // 默认设置为4（中药房）
					busDate: new Date().toISOString().split('T')[0],
					remark: ''
				};

				this.transferTableDetailsData = [];
				this.totalCostAmount = '0.00';
				this.totalSaleAmount = '0.00';
			},

			// // 新增：生成调拨单号的方法
			// generateTransferDocNum() {
			//   const timestamp = new Date().getTime();
			//   const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
			//   return `DB${timestamp}${random}`;
			// },

			async loadSelectedRowsToTransfer() {
				this.transferTableDetailsData = [];

				try {
					// 使用Promise.all并行加载所有选中行的详情
					const loadPromises = this.selectedRows.map(async (row) => {
						try {
							const response = await dugDocgetZYFDrugDetails({
								id: this.selectedRows.id
							});

							if (response.code === 200 && response.data) {
								const detailData = response.data;

								// 处理药品明细数据
								if (detailData.list && Array.isArray(detailData.list)) {
									return detailData.list.map(item => this.formatTransferItem(item, row));
								} else {
									// 如果没有list字段，使用主数据
									return [this.formatTransferItem(detailData, row)];
								}
							}
							return [];
						} catch (error) {
							console.error(`加载入库单 ${row.docNum} 详情失败:`, error);
							this.$message.error(`加载入库单 ${row.docNum} 详情失败`);
							return [];
						}
					});

					// 等待所有详情加载完成
					const results = await Promise.all(loadPromises);
					this.transferTableDetailsData = results.flat();

					// 计算合计金额
					this.calculateTransferTotals();

				} catch (error) {
					console.error('加载调拨明细失败:', error);
					this.$message.error('加载调拨明细失败，请检查网络连接');
				}
			},

			// 新增：格式化调拨明细项
			formatTransferItem(item, row) {
				// 确保金额字段是数字类型
				const purcAmt = Number(item.purcAmt || row.purcAmt || 0);
				const saleAmt = Number(item.saleAmt || row.saleAmt || 0);
				const purcCnt = Number(item.purcCnt || row.purcCnt || 0);
				const purcPric = Number(item.purcPric || row.purcPric || 0);
				const salePric = Number(item.salePric || row.salePric || 0);

				return {
					...item,
					sourceDocId: row.id,
					sourceDocNum: row.docNum,
					name: item.name || row.name,
					drugSpec: item.drugSpecifications || row.drugSpecifications,
					purcCnt: purcCnt,
					purcType: item.purcType || row.purcType,
					purcPric: purcPric,
					salePric: salePric,
					purcAmt: purcAmt,
					saleAmt: saleAmt,
					manuLotnum: item.manuLotnum || row.manuLotnum,
					manuDate: item.manuDate || row.manuDate,
					expyDate: item.expyDate || row.expyDate,
					dosUnt: item.dosUnt || row.dosUnt || '粒',
					pacUnt: item.pacUnt || row.pacUnt || '盒',
					drugId: item.drugId || row.drugId
				};
			},


			// 新增：生成调拨单号的方法
			generateTransferDocNum() {
				const timestamp = new Date().getTime();
				const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
				return `DB${timestamp}${random}`;
			},
			// 修改：准备调拨数据方法，确保包含所有必要字段
			prepareTransferData() {
				const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

				// 计算总金额
				const totalCost = this.transferTableDetailsData.reduce((sum, item) => {
					return sum + (Number(item.purcAmt) || 0);
				}, 0);

				const totalSale = this.transferTableDetailsData.reduce((sum, item) => {
					return sum + (Number(item.saleAmt) || 0);
				}, 0);

				const transferData = {
					busDate: this.quickTransferForm.busDate,
					clinicId: userInfo.clinicId || 0,
					costAmt: totalCost,
					detailsVOS: this.transferTableDetailsData.map(item => ({
						drugId: item.drugId,
						expyDate: item.expyDate,
						manuDate: item.manuDate,
						manuLotnum: item.manuLotnum,
						purcAmt: Number(item.purcAmt) || 0,
						purcCnt: Number(item.purcCnt) || 0,
						purcPric: Number(item.purcPric) || 0,
						purcType: item.purcType || '2',
						saleAmt: Number(item.saleAmt) || 0,
						salePric: Number(item.salePric) || 0,
						sourceDocId: item.sourceDocId,
						sourceDocNum: item.sourceDocNum
					})),
					docNum: this.generateTransferDocNum(), // 确保有调拨单号
					phayId: this.quickTransferForm.toWarehouse,
					remarks: this.quickTransferForm.remark || '',
					saleAmt: totalSale,
					shedId: this.quickTransferForm.fromWarehouse,
					state: 0
				};

				return transferData;
			},

			handleAddTransfer() {
				this.$message.info('添加调拨入库功能开发中');
			},


			handleAddInventory() {
				this.$message.info('添加盘点入库功能开发中');
			}
		}
	}
</script>

<style lang="less" scoped>
	::v-deep .el-form-item__label {
		font-size: 12px;
	}

	.excel {
		display: flex;
		align-items: center;
		justify-content: center;

		/deep/ .el-dialog__header {
			padding: 4px;
			background-color: #007bb0;
		}

		/deep/ .el-dialog__title {
			color: #fff;
			font-size: 12px;
		}

		/deep/ .el-dialog__headerbtn {
			top: 10px;
		}

		/deep/ .el-dialog__body {
			padding: 10px;
		}

		/deep/ .el-dialog__headerbtn .el-dialog__close {
			color: #fff;
		}

		/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
			background-color: brown;
		}

		/deep/ .el-table .cell {
			font-size: 12px;
			font-weight: 400;
			color: #0c0c0c;
			text-align: left;
		}

		/* Excel导入样式 */
		.excel-import-dialog {
			.el-dialog__body {
				padding: 10px 20px;
			}
		}

		.excel-import-container {
			display: flex;
			height: 600px;

			.left-panel {
				flex: 1;
				display: flex;
				flex-direction: column;
				padding-right: 15px;
				border-right: 1px solid #ebeef5;

				.upload-header {
					padding: 10px 0;

					.upload-demo {
						text-align: center;
					}
				}

				.file-info {
					flex: 1;
					display: flex;
					flex-direction: column;

					.file-type-select {
						padding: 10px 0;

						.el-form-item {
							margin-bottom: 10px;
						}
					}

					.file-table {
						flex: 1;
						overflow: hidden;
					}
				}

				.action-footer {
					padding: 10px 0;
					text-align: center;

					.el-button {
						width: 100%;
					}
				}
			}

			.right-panel {
				flex: 2;
				display: flex;
				flex-direction: column;
				padding-left: 15px;
				overflow: hidden;

				/* 防止整体溢出 */
				.preview-header {
					padding: 10px 0;
					border-bottom: 1px solid #ebeef5;

					h4 {
						margin: 0;
						font-size: 14px;
						color: #606266;
					}
				}

				.preview-table {
					flex: 1;
					width: 100%;
					overflow: hidden;
				}

				.pagination-footer {
					padding: 10px 0;
					text-align: center;
					border-top: 1px solid #ebeef5;
				}
			}
		}

		.el-upload-dragger {
			width: 100%;
			padding: 20px;
		}

		.el-upload__tip {
			font-size: 12px;
			color: #909399;
			margin-top: 5px;
		}
	}

	.drug-option {
		display: flex;
		flex-direction: column;
		line-height: 1.4;
		padding: 4px 8px;
	}

	.drug-name {
		font-weight: 500;
		font-size: 13px;
		color: #303133;
	}

	.drug-spec {
		font-size: 12px;
		color: #909399;
		margin-top: 2px;
	}

	/* 确保下拉框中的选项样式 */
	.el-select-dropdown__item {
		padding: 8px 12px;
		height: auto;
		min-height: 36px;
	}

	.el-select-dropdown__item.selected {
		background-color: #f5f7fa;
	}

	/* 鼠标悬停效果 */
	.el-select-dropdown__item:hover {
		background-color: #ecf5ff;
	}

	/* 选中状态样式 */
	.el-select-dropdown__item.selected .drug-name {
		color: #409EFF;
		font-weight: 600;
	}

	.el-select-dropdown__item.selected .drug-spec {
		color: #67c23a;
	}

	/* 生产厂家选项样式 */
	.manufacturer-option {
		display: flex;
		flex-direction: column;
		line-height: 1.4;
		padding: 4px 8px;
	}

	.manufacturer-name {
		font-weight: 500;
		font-size: 13px;
		color: #303133;
	}

	.manufacturer-code {
		font-size: 12px;
		color: #909399;
		margin-top: 2px;
	}

	.selected-manufacturer {
		margin-top: 4px;
	}

	.manufacturer-text {
		font-size: 12px;
		color: #67c23a;
		background: #f0f9ff;
		padding: 2px 6px;
		border-radius: 2px;
	}

	/* 加载状态样式 */
	.drug-loading-icon {
		position: absolute;
		right: 8px;
		top: 50%;
		transform: translateY(-50%);
		color: #409EFF;
	}

	/* 调拨单加载状态样式 */
	.transfer-loading-overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(255, 255, 255, 0.9);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10;
		border-radius: 4px;
	}

	.supplier-dialog {
		/deep/ .el-dialog {
			max-height: 90vh;
			display: flex;
			flex-direction: column;

			.el-dialog__body {
				flex: 1;
				overflow-y: auto;
				padding: 20px;
			}

			&__header {
				background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
				padding: 12px 20px;
				border-bottom: 1px solid #e6e6e6;
				display: flex;

				.el-dialog__title {
					color: #fff;
					font-size: 16px;
					font-weight: bold;
				}
			}

			.el-dialog__headerbtn .el-dialog__close {
				color: #fff;
			}

			.el-dialog__headerbtn .el-dialog__close:hover {
				color: #f80000;
			}
		}
	}

	.purchase-dialog {
		/deep/ .el-dialog {
			max-height: 90vh;
			display: flex;
			flex-direction: column;

			.el-dialog__body {
				flex: 1;
				overflow-y: auto;
				padding: 20px;
			}

			&__header {
				background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
				padding: 12px 20px;
				border-bottom: 1px solid #e6e6e6;
				display: flex;

				.el-dialog__title {
					color: #fff;
					font-size: 16px;
					font-weight: bold;
				}
			}

			.el-dialog__headerbtn .el-dialog__close {
				color: #fff;
			}

			.el-dialog__headerbtn .el-dialog__close:hover {
				color: #f80000;
			}
		}
	}

	.loading-content {
		text-align: center;
		padding: 20px;
	}

	.loading-content i {
		font-size: 24px;
		color: #409EFF;
		margin-bottom: 10px;
	}

	.loading-content p {
		margin: 10px 0;
		color: #606266;
	}

	.loading-progress {
		font-size: 12px;
		color: #909399;
		margin-top: 5px;
	}

	/* 禁用状态的表格样式 */
	.el-table[disabled] {
		opacity: 0.6;
		pointer-events: none;
	}

	// 其他样式保持不变
	.store-psi-container {
		padding: 16px;
		background: #f5f7fa;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	/* 错误信息区域样式 */
	.error-info-section {
		margin-top: 16px;
		border: 1px solid #fde2e2;
		border-radius: 4px;
		background-color: #fef0f0;

		.error-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 8px 12px;
			background-color: #fde2e2;
			border-bottom: 1px solid #fbc4c4;

			h4 {
				margin: 0;
				font-size: 14px;
				display: flex;
				align-items: center;

				i {
					margin-right: 5px;
				}
			}
		}

		.error-table {
			/deep/ .el-table {
				.el-table__header-wrapper {
					background-color: #fde2e2;

					th {
						background-color: #fde2e2;
						color: #f56c6c;
						font-weight: bold;
					}
				}

				.el-table__body {
					tr:hover>td {
						background-color: #fef0f0;
					}
				}
			}
		}
	}

	// 新增：调拨单表格头部操作区域样式
	.transfer-table-actions {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		flex: 1;

		.create-transfer-btn {
			margin-right: 10px;
		}

		.table-actions {
			margin-left: 10px;
		}
	}

	// 响应式调整
	@media screen and (max-width: 1200px) {
		.transfer-table-actions {
			flex-wrap: wrap;
			gap: 8px;

			.el-select,
			.el-date-picker {
				margin-left: 0 !important;
			}
		}
	}

	.status-filter {
		display: flex;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 4px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
		padding: 8px;

		.status-item {
			padding: 6px 16px;
			margin: 0 2px;
			border-radius: 2px;
			font-size: 13px;
			color: #606266;
			cursor: pointer;
			transition: all 0.3s ease;

			&:hover {
				background: #f0f7ff;
				color: #409EFF;
			}

			&.active {
				background: #409EFF;
				color: #fff;
			}
		}
	}

	// 双表格布局容器
	.dual-table-container {
		display: flex;
		gap: 16px;
		height: calc(100vh - 310px);
		min-height: 500px;
		overflow: hidden;

		.table-wrapper {
			background: #fff;
			border-radius: 4px;
			box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
			display: flex;
			flex-direction: column;
			transition: all 0.3s ease;
			overflow: hidden; // 添加溢出隐藏

			&.half-width {
				width: 50%;
				min-width: 600px; // 设置最小宽度
			}

			&:not(.half-width) {
				width: 100%;
			}

			.table-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 12px 16px;
				border-bottom: 1px solid #e6e6e6;
				flex-shrink: 0; // 防止头部被压缩

				.table-title {
					margin: 0;
					font-size: 16px;
					font-weight: 600;
					color: #303133;
				}

				.table-actions {
					display: flex;
					align-items: center;
					gap: 8px;
				}
			}

			// 采购入库表格样式
			.el-table {
				flex: 1;
				width: 100%;

				/deep/ .el-table__body-wrapper {
					overflow-x: auto;
					overflow-y: auto;
				}

				/deep/ .el-table__header-wrapper {
					overflow: hidden;
				}
			}

			.pagination {
				padding: 12px 16px;
				border-top: 1px solid #e6e6e6;
				flex-shrink: 0; // 防止分页被压缩
			}
		}

		// 调拨单表格特殊样式
		.transfer-table {

			// 调拨单表格容器
			.transfer-table-container {
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				min-height: 400px; // 设置最小高度

				.transfer-table-content {
					flex: 1;
					width: 100%;

					/deep/ .el-table__body-wrapper {
						overflow-x: auto;
						overflow-y: auto;
						max-height: calc(100vh - 500px); // 限制最大高度
					}

					/deep/ .el-table__header-wrapper {
						overflow: hidden;
					}

					/deep/ .el-table__fixed,
					/deep/ .el-table__fixed-right {
						height: 100% !important;
					}
				}
			}

			// 操作下拉菜单样式
			.operation-dropdown {
				.el-dropdown-link {
					cursor: pointer;
					color: #409EFF;
					font-size: 12px;
					display: flex;
					align-items: center;

					&:hover {
						color: #66b1ff;
					}
				}
			}

			// 表格单元格样式优化
			/deep/ .el-table {
				font-size: 13px;

				.el-table__header {
					th {
						background: #f5f7fa;
						color: #606266;
						font-weight: 600;
						padding: 8px 0;

						.cell {
							font-size: 13px;
							font-weight: 600;
						}
					}
				}

				.el-table__body {
					tr:hover>td {
						background: #f0f7ff;
						cursor: pointer;
					}

					td {
						padding: 6px 0;

						.cell {
							font-size: 13px;
							line-height: 1.4;
						}
					}
				}

				// 固定列样式优化
				/deep/ .el-table__fixed-right {
					right: 0 !important;
					box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);

					.el-table__fixed-body-wrapper {
						overflow-y: auto;
					}
				}

				/deep/ .el-table__fixed {
					box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);

					.el-table__fixed-body-wrapper {
						overflow-y: auto;
					}
				}
			}

			// 分页样式
			.pagination {
				/deep/ .el-pagination {
					font-size: 13px;

					.btn-prev,
					.btn-next,
					.number {
						border-radius: 2px;
						min-width: 32px;
						height: 28px;
						line-height: 28px;
						font-size: 13px;
					}

					.active {
						background: #409EFF;
						color: #fff;
					}
				}
			}

			// 过渡动画
			&.el-zoom-in-left-enter-active,
			&.el-zoom-in-left-leave-active {
				transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
			}

			&.el-zoom-in-left-enter-from {
				opacity: 0;
				transform: scale(0.8) translateX(100%);
			}

			&.el-zoom-in-left-leave-to {
				opacity: 0;
				transform: scale(0.8) translateX(-100%);
			}
		}
	}

	// 创建信息单元格样式
	.creator-info-cell {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: start;
		text-align: left;
		line-height: 1.4;

		.creator-name {
			font-weight: 500;
			color: #303133;
			margin-bottom: 4px;
		}

		.create-time {
			font-size: 12px;
			color: #909399;
		}
	}

	// 操作下拉菜单样式
	.operation-dropdown {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 8px;

		.el-dropdown-link {
			cursor: pointer;
			color: #409EFF;
			font-size: 12px;
			display: flex;
			align-items: center;

			&:hover {
				color: #66b1ff;
			}
		}
	}

	// 响应式设计
	@media screen and (max-width: 1400px) {
		.dual-table-container {
			.table-wrapper {
				&.half-width {
					min-width: 550px;
				}
			}
		}
	}

	// 响应式设计
	@media screen and (max-width: 1200px) {
		.dual-table-container {
			flex-direction: column;
			height: auto;

			.table-wrapper {
				width: 100% !important;
				margin-bottom: 16px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}

	@media screen and (max-width: 768px) {
		.store-psi-container {
			padding: 8px;
		}

		.operation-buttons {
			.el-button {
				margin-bottom: 8px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
</style>